(function() {
  'use strict';

  angular
    .module('econet', [
       'ngAnimate',
       'ngCookies',
       'ngSanitize',
       'ngMessages',
       'ngAria',
       'ngMaterial',
       'restangular',
       'ui.router',
       'ngMaterialDatePicker',
       'chart.js',
       'ui.mask',
       'angulartics',
       'angulartics.google.analytics'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('menuToggle', menuToggle);

  /** @ngInject */
  function menuToggle() {
    return {
      scope: {
        section: '='
      },
       templateUrl: 'app/settings/menu/_menu-toggle.html',
      link: function (scope, element) {
        var controller = element.parent().controller();

        scope.isOpen = function () {
          return controller.isOpen(scope.section);
        };
        scope.toggle = function () {
          controller.toggleOpen(scope.section);
        };

        var parentNode = element[0].parentNode.parentNode.parentNode;
        if (parentNode.classList.contains('parent-list-item')) {
          var heading = parentNode.querySelector('h2');
          element[0].firstChild.setAttribute('aria-describedby', heading.id);
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('menuStatic', menuStatic);


  /** @ngInject */
  function menuStatic() {
    return {
      scope: {
        section: '='
      },
      restrict: 'E',
      templateUrl: 'app/settings/menu/_menu-static.html'
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('econet')
    .directive('menuLink', menuLink);


  /** @ngInject */
  function menuLink($state, $timeout) {
    return {
      scope: {
        section: '='
      },
      restrict: 'E',
      templateUrl: 'app/settings/menu/_menu-link.html',
      link: function ($scope, $element) {
        var controller = $element.parent().controller();

        $scope.focusSection = function () {
          if (!$scope.section.clicked) {
            $scope.section.clicked = true;

            $timeout(function() {
              $scope.section.clicked = false;
            },1000);
            
            // set flag to be used later when
            // $locationChangeSuccess calls openPage()
            if ($scope.section.sref) {
              $state.go($scope.section.sref);
            } else {
              controller.select($scope.section.state);
              controller.autoFocusContent = true;
            }
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('menuExternal', menuExternal);


  /** @ngInject */
  function menuExternal() {
    return {
      scope: {
        section: '='
      },
      restrict: 'E',
      templateUrl: 'app/settings/menu/_menu-external.html',
      link: function ($scope, $element) {
        var controller = $element.parent().controller();

        $scope.focusSection = function () {
          // set flag to be used later when
          // $locationChangeSuccess calls openPage()
          controller.select($scope.section.state);
          controller.autoFocusContent = true;
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .filter('nospace', nospace)
    .filter('humanizeDoc', humanizeDoc);

  /** @ngInject */
  //take all whitespace out of string
  function nospace () {
    return function (value) {
      return (!value) ? '' : value.replace(/ /g, '');
    };
  }

  //replace uppercase to regular case
  function humanizeDoc () {
    return function (doc) {
      if (!doc) return;
      if (doc.type === 'directive') {
        return doc.name.replace(/([A-Z])/g, function ($1) {
          return '-' + $1.toLowerCase();
        });
      }

      return doc.label || doc.name;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .factory('menuFactory', menuFactory);

  /** @ngInject */
  function menuFactory() {
    var vm = this;

    var sections = [];

    sections.push({
      name: 'Manage Account Info',
      type: 'toggle',
      pages: [{
        name: 'Change Email',
        state: 'changeEmail',
        type: 'link'
        // icon: 'fa fa-group'
      },{
        name: 'Change Password',
        state: 'changePassword',
        type: 'link'
        // icon: 'fa fa-map-marker'
      },{
        name: 'Notifications Preferences',
        state: 'notificationsPreferences',
        type: 'link'
        // icon: 'fa fa-map-marker'
      },{
        name: 'Temperature Unit',
        state: 'temperatureUnit',
        type: 'link'
      }]
    });

    sections.push({
      name: 'Manage Equipment/Locations',
      state: 'locationsAndEquipment',
      type: 'link'
    });

    sections.push({
      name: 'Network Info',
      state: 'networkInfo',
      type: 'link'
    });

    // sections.push({
    //   name: 'Works with Nest',
    //   state: 'nest',
    //   type: 'link'
    // });

    sections.push({
      name: 'Contractor Info',
      state: 'contractorInfo',
      type: 'link'
    });

    sections.push({
      name: 'User Guide',
      type: 'toggle',
      pages: [{
        name: 'Get Started',
        type: 'link',
        state: 'getStarted'
        // icon: 'fa fa-group'
      },{
        name: 'Troubleshooting',
        state: 'troubleshooting',
        type: 'link'
        // icon: 'fa fa-map-marker'
      }]
    });

    sections.push({
      name: 'Legal',
      type: 'toggle',
      pages: [{
        name: 'Terms of Service',
        type: 'link',
        state: 'termsOfService'
        // icon: 'fa fa-group'
      },{
        name: 'Privacy Statement',
        state: 'privacyStatement',
        type: 'link'
        // icon: 'fa fa-map-marker'
      }]
    });

    sections.push({
      name: 'Version ' + _.find(angular.element('meta'), {name: 'version'}).content,
      type: 'static'
    });

    sections.push({
      name: 'Log Out',
      sref: 'logout',
      type: 'link'
    });

    function toggleSelectSection(section) {
      vm.openedSection = (vm.openedSection === section ? null : section);
    }
    function isSectionSelected(section) {
      return vm.openedSection === section;
    }
    function selectPage(section, page) {
      // page && page.url && $location.path(page.url);
      vm.currentSection = section;
      vm.currentPage = page;
    }

    var service = {
      sections: sections,
      toggleSelectSection: toggleSelectSection,
      isSectionSelected: isSectionSelected,
      selectPage: selectPage
    };
    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('terms', terms);

  /** @ngInject */
  function terms() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/registration/terms.html',
      transclude: true,
      link: function(scope, elem, attr) {
        scope.vm = {};
        scope.vm.languages = [{abbr: 'en', full: 'English'}, {abbr: 'fr', full: 'French'}, {abbr: 'sp', full: 'Spanish'}];
        scope.vm.language = 'en';
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('registerAccount', registerAccount);

  /** @ngInject */
  function registerAccount(Dialogs, User, auth, $log, $state, $rootScope) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/registration/registerAccount.html',
      transclude: true,
      link: function(scope, elem, attr) {
        scope.register = function() {
          scope.error = '';
          if (scope.user.email !== scope.user.emailConfirm) {
            scope.error = 'Email does not match'; return;
          } else if (scope.user.password !== scope.user.passwordConfirm) {
            scope.error = 'Password does not match'; return;
          } else {
            User.register(scope.user.email, scope.user.password)
            .then(function() {
              $log.debug('User Registered');
              var user_data = $.param({
                username: scope.user.email,
                password: scope.user.password,
                grant_type: 'password'
              });

              return login(user_data);
            })
            .then(function(result) {
              if (result) {
                scope.next();
              } else {
                Dialogs.showDialog('Login Error', 'Could not log into your newly created account.');
                $state.go('login');
              }
            }, function(reject) {
              Dialogs.showDialog('Registration Error', 'Username is already taken.');
            });
          }
        };

        function login(user_data) {
          return auth.authenticate($rootScope.app_data_basic, user_data)
          .then(function(data) {
            if (data) {
              return User.getIdentity();
            }
          })
          .then(function() {
            return true;
          }, function error() {
            return false;
          });
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('provision', provision);

  /** @ngInject */
  function provision(Location) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/registration/provision.html',
      scope: {
        steps: '=',
        location: '=',
        onFinish: '&'
      },
      link: function(scope, elem, attr) {
        scope.stepIndex = 0;
        scope.newLocation = {};
        scope.locationData = {
          location: scope.location
        };

        scope.setLocation = function() {
          scope.locationData.location = Location.get().location;
        };

        scope.next = function() {
          if (scope.stepIndex <= scope.steps.length - 1){
            scope.stepIndex += 1;
          }
        };

        scope.lastStep = function() {
          return scope.stepIndex === scope.steps.length - 1;
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('notificationPreferences', notificationPreferences);

  /** @ngInject */
  function notificationPreferences($state, User, Dialogs) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/registration/notificationPreferences.html',
      transclude: true,
      link: function(scope, elem, attr) {
        scope.notifications = {
          "allowPushNotifications": false,
          "allowTextNotifications": false,
          "allowEmailNotifications": false,
          "receiveMarketingMessages": false
        };

        scope.finishRegistration = function() {
          if (scope.notifications.allowTextNotifications) {
            User.getIdentity()
            .then(function() {
              return User.updateSetting({phone: scope.identity.phone.replace(/\D/gi, '')});
            })
            .then(function() {
              savePreferences();
            }, function(response) {
              Dialogs.showDialog('Error', response.data.error);
            });
          } else {
            savePreferences();
          }

          function savePreferences() {
            User.updateNotifications(scope.notifications)
            .then(function(){
              $state.go('locations');
            }, function(response) {
              Dialogs.showDialog('Error', response.data.error);
            });
          }
        };

      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('connectModule', connectModule);

  /** @ngInject */
  function connectModule($timeout, $interval) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/registration/connectModule.html',
      transclude: true,
      link: function(scope, elem, attr) {
        var loadIframeTimer;

        scope.onFinish = function() {
          scope.iframeVisible = true;
          $interval.cancel(loadIframeTimer);
        };

        scope.successConnect = function(event) {
          scope.newLocation.adapterMACAddress = event.data.adapterMACAddress;
          scope.next();
          scope.iframeVisible = false;
          scope.$apply();
        };

        function iframeRefresh() {
          scope.iframeVisible = false;
          $timeout(function(){
            scope.iframeVisible = true;
          });
        }

        function loadIframe() {
          iframeRefresh();
          loadIframeTimer = $interval(iframeRefresh, 8000);
        }

        loadIframe();

        scope.$on('$destroy', function() {
          $interval.cancel(loadIframeTimer);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('addLocationTutorial', addLocationTutorial);

  /** @ngInject */
  function addLocationTutorial($interval, $http) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/registration/addLocationTutorial.html',
      transclude: true,
      link: function(scope, elem, attr) {
        var loadIframeTimer, networkDetect;

        scope.tutorialIndex = 0;
        scope.ready = false;
        scope.iframeVisible = false;

        scope.nextSlide = function(index) {
          scope.tutorialIndex += 1;
        };

        scope.detectNetworkChange = function() {
          var consecutivePositiveResult = 0;

          var moduleRefresh = function() {
            var now = moment();

            pingModule(now)
            .then(function(diff){
              if (diff > 0) {
                consecutivePositiveResult = 0;
              } else {
                consecutivePositiveResult += 1;
              }

              if (consecutivePositiveResult === 2) {
                consecutivePositiveResult = 0;
                scope.ready = true;
                $interval.cancel(networkDetect);
              }
            });
          };

          moduleRefresh();
          networkDetect = $interval(moduleRefresh, 6000);
        };

        function pingModule(now) {
          return $http({
            method: 'HEAD',
            timeout: 5000,
            url: 'http://192.168.10.1'
          }).then(function() {
            return moment().diff(now, 'seconds');
          }, function() {
            return moment().diff(now, 'seconds');
          });
        }

        scope.$on('$destroy', function(){
          $interval.cancel(networkDetect);
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('addLocation', addLocation);

  /** @ngInject */
  function addLocation(Location, $log) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/registration/addLocation.html',
      transclude: true,
      link: function(scope, elem, attr) {
        scope.createLocation = function(location) {
          $log.debug("creating");
          location.adapterMACAddress.toUpperCase();

          Location.add(location)
          .then(function() {
            scope.setLocation(location);
            if (scope.lastStep()){
              scope.onFinish();
            } else {
              scope.next();
            }
          });
        };

        scope.validateZipCode = function(zipcode) {
          scope.zipcodeVerified = false;
          if (zipcode.toString().match(/\d{5}$/g)) {
            Location.verifyZipcode(zipcode)
            .then(function(response){
              _.merge(scope.newLocation, response);
              scope.zipcodeVerified = true;
            });
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('addEquipment', addEquipment);

  /** @ngInject */
  function addEquipment(Location, Equipment) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/registration/addEquipment.html',
      transclude: true,
      link: function(scope, elem, attr) {
        scope.equipmentData = {};

        scope.updateEquipment = function(id) {
          if (scope.equipmentData[id].name !== scope.equipmentData[id].originalName) {
            var option = { "name": scope.equipmentData[id].name };

            Equipment.updateSetting(id, option)
            .then(function() {
              scope.equipmentData[id].originalName = scope.equipmentData[id].name;
            });
          }
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('NavbarController', NavbarController);

  /** @ngInject */
  function NavbarController($state, Dialogs, Alerts) {
    var vm = this;

    vm.alerts = Alerts.get();

    vm.openSidenav = Dialogs.openSidenav;
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .filter('temperature', temperature);

  /** @ngInject */
  function temperature($rootScope, User) {
    $rootScope.temperatureDisplayUnit = null;
    var serviceInvoked = false;

    function temperatureFilter(value) {
      if (value === -40) return '--';
      if ($rootScope.temperatureDisplayUnit === 'Celsius') {
        value = (value - 32) * 5/9;
      }

      return Math.round(value) + '°';
    }

    filterStub.$stateful = true;
    function filterStub(value) {
      if ($rootScope.temperatureDisplayUnit === null) {
        if (!serviceInvoked) {
          serviceInvoked = true;
          User.getIdentity()
          .then(function(identity) {
            $rootScope.temperatureDisplayUnit = identity.temperatureDisplayUnit;
          });
        }
        return "--";
      }
      else {
        return temperatureFilter(value);
      }
    }

    return filterStub;
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .filter('moment', momentFilter);

  /** @ngInject */
  function momentFilter() {
    return function(input, argument) {
      var hour = input[0];
      var minute = input[1];

      var time = moment({ hour:hour, minute:minute }).format(argument);
      return time;
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('equipmentToolbar', equipmentToolbar);

  /** @ngInject */
  function equipmentToolbar() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/elements/toolbar.html',
      transclude: true,
      replace: true,
      scope: {
        'title': '@title',
        'buttonText': '@buttonText'
      },
      controller: function($scope, $mdMedia) {
        $scope.mdMedia = $mdMedia;
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('selector', selector);

  /** @ngInject */
  function selector() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/elements/selector.html',
      transclude: true,
      scope: {
        'prev': '&prev',
        'next': '&next',
        'horizontal': '@horizontal',
        'disabled': '@disabled'
      },
      controller: function($scope) {
        $scope.isHorizontal = angular.isDefined($scope.horizontal);
        $scope.isDisabled = angular.isDefined($scope.disabled);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('resize', resize);

  /** @ngInject */
  function resize($window) {
    return {
      link: function(scope) {
        function cleanUp() {
          angular.element($window).off('resize', onResize);
        }

        function onResize() {
          scope.$broadcast('resize::resize');
        }

        angular.element($window).on('resize', _.throttle(onResize, 300));
        $(window).trigger('resize');

        scope.$on('$destroy', cleanUp);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('passwordField', passwordField);

  /** @ngInject */
  function passwordField($timeout) {
    return {
      restrict: 'E',
      template: "<div class='password-field'><div ng-transclude></div><md-button aria-label='Icon Visibility' tabindex='-1'><icon class='password-visibility' name='icon-visibility'></icon></md-button></div>",
      transclude: true,
      replace: true,
      scope: {},
      link: function(scope, element, attr) {
        var passwordClickHandler;

        function func() {
          var icon = element.find('md-icon');
          var input = element.find('input');
          var inputType = input.attr('type');
          var iconName = icon.hasClass('icon-visibility');

          inputType === 'password' ? input.attr('type', 'text') : input.attr('type', 'password');
          if (iconName) {
            icon.removeClass('icon-visibility');
            icon.addClass('icon-visibility_off');
          } else {
            icon.removeClass('icon-visibility_off');
            icon.addClass('icon-visibility');
          }
        }

        $timeout(function() {
          var icon = element.find('button');
          passwordClickHandler = icon.on('click', func);
        },0);

        scope.$on('$destroy', function() {
          passwordClickHandler.off('click');
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('ngRepeatFinish', ngRepeatFinish);

  /** @ngInject */
  function ngRepeatFinish() {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                scope.$evalAsync(attr.ngRepeatFinish);
            }
        }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('moduleIframe', moduleIframe);

  /** @ngInject */
  function moduleIframe() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        onFinishLoading: '&',
        onConnectionSuccess: '&'
      },
      template: '<div class="iframe-container"><iframe frameborder="0" ng-src="{{embedUrl}}"></iframe><md-progress-circular md-mode="indeterminate"></md-progress-circular></div>',
      // template: '<div class="iframe-container"><iframe frameborder="0" src="http://69.195.91.88/rheem/econet/#/reg/reg.html?id=DC-71-D9-F7-9C-E0&bt=&opt=rheem"></iframe><md-progress-circular md-mode="indeterminate"></md-progress-circular></div>',
      // template: '<div class="iframe-container"><iframe frameborder="0" src="http://localhost:3000/#/reg/reg.html?id=6C-71-D9-F7-9C-E0&bt=&opt=rheem"></iframe><md-progress-circular md-mode="indeterminate"></md-progress-circular></div>',
      link: function(scope, el){
        var contents = el.find("iframe")[0];
        window.addEventListener("message", receiveMessage, false);

        function receiveMessage(event)
        {
          // Can add a whitelist when host origin is known
          // if (event.origin !== location.origin)
          //   return;
          if (angular.isDefined(event.data)) {
            scope.onConnectionSuccess({event: event});
          }
        }
        contents.onload = function() {
          scope.onFinishLoading();
        };

        scope.$on('$destroy', function() {
          window.removeEventListener("message", receiveMessage, false);
        });
      },
      controller: function($scope, $sce, $rootScope){
         $scope.embedUrl = $sce.trustAsResourceUrl("http://192.168.10.1/?opt=" + $rootScope.brand + "econetdev");
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('inkBarResize', inkBarResize);

  /** @ngInject */
  function inkBarResize() {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        var tabWrapper = angular.element(element[0].querySelector('md-tabs-wrapper'));

        scope.$watch(function() {
          return {
           w:tabWrapper.width()
          };
         },
         function (newValue, oldValue) {
          if (newValue.w != oldValue.w) {
            window.dispatchEvent(new Event('resize'));
          }
        }, true);
      }
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('econet')
    .directive('icon', icon);

  /** @ngInject */
  function icon() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        'name': "@name"
      },
      templateUrl: 'app/components/elements/icon.html',
      link: function($scope) {
        $scope.$watch('name', function() {
          $scope.mode = {
            label: $scope.name
          };

          selectIcon();
        });

        function selectIcon() {
            switch ($scope.mode.label) {
              case 'Auto':
                $scope.mode.icon = {name: 'icon-coolheat',
                                    path: ['path1', 'path2']};
                break;
              case 'Heating':
                $scope.mode.icon = {name: 'icon-heating'};
                break;
              case 'Cooling':
                $scope.mode.icon = {name: 'icon-cooling'};
                break;
              case 'Fan Only':
                $scope.mode.icon = {name: 'icon-fan'};
                break;
              case 'Off':
                $scope.mode.icon = {name: 'icon-circle-backslash'};
                break;
              case 'Emergency Heat':
                $scope.mode.icon = {name: 'icon-emergencyheat'};
                break;
              case 'Energy Saver':
                $scope.mode.icon = {name: 'icon-Leaf'};
                break;
              case 'Heat Pump':
                $scope.mode.icon = {name: 'icon-heatpumponly',
                                    path: ['path1', 'path2', 'path3']};
                break;
              case 'High Demand':
                $scope.mode.icon = {name: 'icon-arrows'};
                break;
              case 'Electric':
                $scope.mode.icon = {name: 'icon-electriconly'};
                break;
              case 'Vacation':
                $scope.mode.icon = {name: 'icon-briefcase'};
                break;
              case 'Performance':
                $scope.mode.icon = {name: 'icon-arrows'};
                break;
              case 'Arrow Plus':
                $scope.mode.icon = {name: 'icon-arrow-plus',
                                    path: ['path1', 'path2']};
                break;
              case 'Arrow Minus':
                $scope.mode.icon = {name: 'icon-arrow-minus',
                                    path: ['path1', 'path2']};
                break;
              case 'Following Schedule':
                $scope.mode.icon = {name: 'icon-FollowingSchedule',
                                    path: ['path1', 'path2', 'path3', 'path4', 'path5', 'path6',
                                    'path7', 'path8', 'path9', 'path10', 'path11', 'path12',
                                    'path13', 'path14', 'path15', 'path16', 'path17',]};
                break;                
              case 'Schedule Overridden':
                $scope.mode.icon = {name: 'icon-ScheduleOverridden',
                                    path: ['path1', 'path2', 'path3', 'path4', 'path5', 'path6',
                                    'path7', 'path8', 'path9', 'path10', 'path11', 'path12',
                                    'path13', 'path14', 'path15', 'path16', 'path17',]};
                break;
              case 'Not Following Schedule':
                $scope.mode.icon = {name: 'icon-NotFollowingSchedule',
                                    path: ['path1', 'path2', 'path3', 'path4', 'path5', 'path6',
                                    'path7', 'path8', 'path9', 'path10', 'path11', 'path12',
                                    'path13', 'path14', 'path15', 'path16', 'path17',]};
                break;
              case 'Air':
                $scope.mode.icon = {name: 'icon-air-ruud',
                                    path: ['path1', 'path2']};
                break;
              case 'Water':
                $scope.mode.icon = {name: 'icon-water-ruud',
                                    path: ['path1', 'path2', 'path3']};
                break;
              case 'Reports':
                $scope.mode.icon = {name: 'icon-reports',
                                    path: ['path1', 'path2', 'path3', 'path4']};
                break;
              case 'Disabled':
                $scope.mode.icon = {name: 'icon-Disabled',
                                    path: ['path1', 'path2']};
                break;
              case 'Banner Vacation':
                $scope.mode.icon = {name: 'icon-banner-vacation',
                                    path: ['path1', 'path2']};
                break;
              case 'Call':
                $scope.mode.icon = {name: 'icon-call',
                                    path: ['path1', 'path2']};
                break;
              case 'Email':
                $scope.mode.icon = {name: 'icon-email',
                                    path: ['path1', 'path2']};
                break;
              case 'Add':
                $scope.mode.icon = {name: 'icon-Add',
                                    path: ['path1', 'path2']};
                break;
              case 'Add2':
                $scope.mode.icon = {name: 'icon-Add2',
                                    path: ['path1', 'path2']};
                break;
              case 'Settings':
                $scope.mode.icon = {name: 'icon-Settings',
                                    path: ['path1', 'path2']};
                break;
              default:
                $scope.mode.icon = {name: $scope.name};
                break;
            }
          }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('rmClassHeightGt', rmClassHeightGt);

  /** @ngInject */
  function rmClassHeightGt($window) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        var obj = JSON.parse(attr.rmClassHeightGt);
        var height;

        scope.$on('resize::resize', function() {
          height = $window.innerHeight;

          _.forEach(obj, function(value, key) {
            if (height < value) {
              element.addClass(key);
            } else {
              element.removeClass(key);
            }
          });
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('bubbles', bubbles);

  /** @ngInject */
  function bubbles() {
    return {
      restrict: 'E',
      template: '<div class="bubble"><img src="./assets/images/bubbles.png"/></div>',
      link: function(scope, element, attr) {
        var bubble = element.find('.bubble'),
            bubbles = [],
            tmp;

        var random = function(min, max) {
          return Math.round(min + Math.random() * (max - min));
        };

        for (var i=0; i < 13; i++) {
          tmp = bubble.clone(true);
          tmp.addClass(chooseBubble());
          element.append(tmp);
        }

        function chooseBubble() {
          switch(random(1,3)) {
            case 1:
              return 'one';
            case 2:
              return 'two';
            case 3:
              return 'three';
          }
        }

        var bubbles = element.find('.bubble');

        var addBubbleFloat = function(element, delay) {
          var position = random(1,100) + '%';
          var scale = random(50,100) / 100;
          var float = new TimelineMax({useFrames: false, delay: delay || 0, onCompleteParams: [element], onComplete: addBubbleFloat, autoRemoveChildren: true});

          float
          .set(element, {left: position, scale: scale, bottom: 0, opacity: 1})
          .to(element, 10 * scale, {bottom: '100%'})
          .to(element, 3, {opacity: 0}, '-=3');
        };

        for(i=0; i< bubbles.length; i++) {
          addBubbleFloat(bubbles[i], random(1,15));
        }

      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('appStore', appStore);

  /** @ngInject */
  function appStore() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/elements/appStore.html',
      replace: true,
      link: function(scope, elem, attr) {
        scope.stores = [
          {link: 'https://itunes.apple.com/us/app/ruud-econet/id964305008?mt=8', image: './assets/images/btn-apple-store.png'},
          {link: 'https://play.google.com/store/apps/details?id=com.ruud.econetconsumerandroid', image: './assets/images/btn-google-play.png'}
        ];
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .service('Dialogs', Dialogs);

  /** @ngInject */
  function Dialogs($mdSidenav, $mdDialog, $document, $timeout, $rootScope) {
    var vm = this;

    var ready = {
      'alerts': true,
      'settings': true
    };

    function toggle(name, data) {
      ready[name] = false;
      if (data) {
        $rootScope.$broadcast("drillIntoMenu" + name, { data: data });
      }
      $mdSidenav(name).toggle();
      return $timeout(500)
      .then(function() {
        ready[name] = true;
      });
    }

    vm.openSidenav = function(name, data) {
      if (ready.alerts && ready.settings) {
        switch(name) {
          case 'alerts':
            if ($mdSidenav('settings').isOpen()) {
              toggle('settings')
              .then(function() {
                toggle(name, data);
              });
            } else {
              toggle(name, data);
            }
            break;
          case 'settings':
            if ($mdSidenav('alerts').isOpen()) {
              toggle('alerts')
              .then(function() {
                toggle(name, data);
              });
            } else {
              toggle(name, data);
            }
            break;
        }
      }
    };

    vm.showDialog = function(title, description, element, options) {
       var parentEl = angular.element(element || $document.body);
       var content = {
         type: options && options.type || 'alert',
         title: title,
         description: description,
         element: element,
         ok: options && options.ok || 'Okay',
         cancel: options && options.cancel || 'Cancel',
         fullscreen: !!element,
         style: options?options.style:null
       };

       return $mdDialog.show({
         parent: parentEl,
         templateUrl: 'app/components/dialogs/dialogs.html',
         locals: {
           content: content
         },
         controller: DialogController
      });

      function DialogController($scope, $mdDialog, content) {
        $scope.content = content;
        $scope.closeDialog = function() {
          $mdDialog.hide();
        };

        $scope.cancelDialog = function() {
          $mdDialog.cancel();
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .factory('authToken', authToken);

  /** @ngInject */
  function authToken($window, Restangular, $log) {
    var storage = $window.sessionStorage;
    var cachedToken, tokenExpiration;
    var userToken = 'userToken';

    var authToken = {
      /**
       * Store a `token` with an `expiration` into either local or session storage based on `keepLoggedIn`.
       */
      setToken: function(token, expiration, keepLoggedIn) {
        storage = keepLoggedIn ? $window.localStorage : $window.sessionStorage;

        cachedToken = token;
        tokenExpiration = moment().add(expiration - 120, 's').toISOString();

        storage.setItem(userToken, token);
        storage.setItem('tokenExpiration', tokenExpiration);

        return cachedToken;
      },

      /**
       * Return a cached `token` from Angular app.  If none cached, then locate it from storage and set `cachedToken`.
       */
      getToken: function() {
        if (!cachedToken) {
          if ($window.localStorage.getItem(userToken)) {
            $log.debug('getting token from localStorage');
            storage = $window.localStorage;
            cachedToken = storage.getItem(userToken);
          } else if($window.sessionStorage.getItem(userToken)) {
            $log.debug('getting token from sessionStorage');
            storage = $window.sessionStorage;
            cachedToken = $window.sessionStorage.getItem(userToken);
          }
        }
        return cachedToken;
      },

      /**
       * Return boolean depending on if a `token` exists or not.
       */
      tokenExists: function() {
        return !authToken.isExpired();
      },

      /**
       * Return boolean if `token` is cached.  Does not look for a `token` in storage.
       */
      isTokenCached: function() {
        return !!cachedToken;
      },

      /**
       * Determine if a `token` is expired by using the storage expired timestamp.  Returns a boolean.
       */
      isExpired: function() {
        var expirationStamp = storage.getItem('tokenExpiration');
        var token = storage.getItem(userToken);
        if (expirationStamp && token) {
          var is_token_expired = moment().diff(expirationStamp, 'seconds') >= 0;
          return is_token_expired;
        }
        return true;
      },

      /**
       * Remove the `token` from storage as well as the `tokenExpiration` key.
       */
      removeToken: function() {
        cachedToken = null;
        storage.removeItem(userToken);
        storage.removeItem('tokenExpiration');
      }
    };

    return authToken;
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .service('auth', auth);

  /** @ngInject */
  function auth($window, $log, $location, $rootScope, Restangular, Dialogs, authToken) {
    var vm = this;

    vm.authenticate = function(app_data_basic, user_data, keepLoggedIn) {
      $log.debug("authenticating");

      return Restangular.all('auth/token')
        .customPOST(
            user_data,
            undefined,
            undefined,
            {'Authorization': 'Basic ' + app_data_basic, 'X-Requested-With' : 'XMLHttpRequest', 'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8"}
        )
        .then(function(data) {
          var token = authToken.setToken(data.access_token, data.expires_in, keepLoggedIn);
          Restangular.setDefaultHeaders({Authorization: "Bearer " + token});
          $log.debug("Token saved OK");
          return true;
        });
    };

    vm.isAuthenticated = function() {
      return authToken.tokenExists();
    };

    vm.su = function(id) {
      var app_data_su = $rootScope.app_data_su;

      return Restangular.all('admin/auth/token/' + id)
        .customPOST(
            undefined,
            undefined,
            undefined,
            {'Authorization': 'Basic ' + app_data_su}
        )
        .then(function(data) {
          var token = authToken.setToken(data.access_token, data.expires_in);
          Restangular.setDefaultHeaders({Authorization: "Bearer " + token});
          $log.debug("Token saved OK");
          return true;
        }, function() {
          $log.debug("There was an error saving token");
          return false;
        });
    };

    vm.search = function(method, value) {
      var app_data_su = $rootScope.app_data_su;
      var query = {method: value};
      return Restangular.one('search/users')
        .get(query, {'Authorization': 'Basic ' + app_data_su})
        .then(function(data) {
          $log.debug("userID Found");
          return data[0].id;
        }, function() {
          $log.debug("There was an error finding user");
          return false;
        });
    };

    vm.logout = function() {
      authToken.removeToken();
      Restangular.setDefaultHeaders('');
      location.reload();
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .service('Vacation', Vacation);

  /** @ngInject */
  function Vacation(Restangular) {
    var vm = this;

    var data = {};

    /**
     * Returns Vacation `data` object.
     */
    vm.get = function() {
      return data;
    };

    /**
     * Get /vacations from server.  Assign `vacations` to `data` object.  Returns `vacations` object.
     */
    vm.index = function() {
      return Restangular
      .all('vacations')
      .getList()
      .then(function(vacations) {
        data.vacations = vacations;
        return data.vacations;
      });
    };

    function findWithLocationId(id) {
      return Restangular
      .all('vacations')
      .getList()
      .then(function(vacations) {
        return _.find(vacations, function(n){
          return n.location.id === Number(id);
        });
      });
    }

    /**
     * Finds a location of `locationId`.  If location exists `vacation` object is assigned to `data`
     * object.  Otherwise, a null `vacation` object is assigned to `data`.  Returns `vacation` object.
     */
    vm.getVacation = function(locationId) {
      return findWithLocationId(locationId)
      .then(function(vacation) {
        if (vacation) {
          data.vacation = vacation;
        } else {
          data.vacation = null;
        }
        return data.vacation;
      });
    };

    /**
     * Returns vacation default settings.
     */
    vm.getDefaults = function(id) {
      return Restangular
      .one('locations', id)
      .one('vacation/defaults')
      .get()
      .then(function(defaults) {
        return defaults;
      });
    };

    /**
     * Add a vacation.
     */
    vm.add = function(settings) {
      return Restangular
      .one('vacations')
      .post(undefined, settings)
      .then(function(response) {
        data.vacation = response;
      });
    };

    /**
     * Put /vacations/:id to server with `settings`.  Updates a vacation's settings.  Returns `vacation` object.
     */
    vm.update = function(id, settings) {
      return Restangular
      .one('vacations', id)
      .customPUT(settings)
      .then(function() {
        _.merge(data.vacation, settings);
        return data.vacation;
      });
    };

    /**
     * Remove a vacation.  Returns `vacation` object.
     */
    vm.remove = function(id) {
      return Restangular
      .one('vacations', id)
      .remove(undefined, {"Content-Type": "application/json"})
      .then(function() {
        data.vacation = null;
        return data.vacation;
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .service('User', User);

  /** @ngInject */
  function User(Restangular, $rootScope) {
    var vm = this;

    /**
     * Return `identity` object from server.
     */
    vm.getIdentity = function() {
      return Restangular
      .one('identity')
      .get()
      .then(function(user) {
        return user;
      });
    };

    /**
     * Get /users/:id and return `user` object from server.  `id` is obtained from `getIdentity()`.
     */
    vm.show = function() {
      return vm.getIdentity()
      .then(function(identity) {
        return Restangular
        .one('users', identity.id)
        .get()
        .then(function(user) {
          return user;
        });
      });
    };

    /**
     * Update a user Setting.  `options` will be an object.  Returns server response.
     */
    vm.updateSetting = function(options) {
      return vm.show()
      .then(function(user) {
        return user.customPUT(options)
        .then(function(data) {
          return data;
        });
      });
    };

    /**
     * Update a users's notifications.  `options` requires a complete object.  Returns server response.
     */
    vm.updateNotifications = function(options) {
      return Restangular
      .one('notifications')
      .customPUT(options)
      .then(function(data) {
        return data;
      });
    };

    /**
     * Add's a token to a user account.
     */
    vm.addNestToken = function(token) {
      return Restangular
      .one('services/nest')
      .customPUT({nestToken: token})
      .then(function(data) {
        return data;
      });
    };

    /**
     * Attach `nestId` to a specfic `locationid`.
     */
    vm.attachNestToLocation = function(nestId, locationId) {
      return Restangular
      .one('nest/locations/' + nestId)
      .customPUT({locationID: locationId})
      .then(function(data) {
        return data;
      });
    };

    /**
     * Removes Nest from user account.
     */
    vm.removeNest = function() {
      return Restangular
      .one('services/nest')
      .remove(undefined, {
        "Content-Type": "application/json"
      });
    };

    /**
     * Get all Nest locations.
     */
    vm.getNestLocations = function() {
      return Restangular.all('nest/locations')
      .getList()
      .then(function(data) {
        return data;
      }, function(reject) {
        return reject;
      });
    };

    /**
     * Send a user an email which includes a link to a page that will allow a user to change their password.
     */
    vm.forgotPassword = function(email, token, password) {
      return Restangular
      .one('auth/reset_password/initiate')
      .customPOST(
            {email: email},
            undefined,
            undefined,
            {'Authorization': 'Basic ' + $rootScope.app_data_basic, 'X-Requested-With' : 'XMLHttpRequest'}
      );
    };

    /**
     * Reset user password.
     */
    vm.resetPassword = function(options) {
      return Restangular
      .one('auth/reset_password')
      .customPOST(
            {email: options.email, token: options.token, password: options.password},
            undefined,
            undefined,
            {'Authorization': 'Basic ' + $rootScope.app_data_basic, 'X-Requested-With' : 'XMLHttpRequest'}
      );
    };

    /**
     * Register a user account.
     */
    vm.register = function(email, password) {
      return Restangular
      .one('register')
      .customPOST(
            {email: email, password: password},
            undefined,
            undefined,
            {'Authorization': 'Basic ' + $rootScope.app_data_basic, 'X-Requested-With' : 'XMLHttpRequest'}
      );
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .service('Location', Location);

  /** @ngInject */
  function Location(Restangular, Alerts, Dialogs, $q, $rootScope) {
    var vm = this;

    var data = {};

    /**
     * Returns Location `data` object.
     */
    vm.get = function() {
      return data;
    };

    /**
     * Get /locations from server.  Key returned `locations` by id.  Assign `locations` object to
     * `data` object.  Return `locations` object.
     */
    vm.index = function() {
      return Restangular
      .all('locations')
      .getList()
      .then(function(locations) {
        if (!!data.locations && data.locations.length === locations.length) {
          _.forEach(locations, function(value, key) {
            data.locations[key] = _.pick(data.locations[key], '$$hashKey');
            _.merge(data.locations[key], value);
          });
        } else {
          data.locations = locations;
        }
        return data.locations;
      });
    };

    /**
     * Get /locations/:id from server.  Assign `location` object to `data` object.  Return `location` object.
     */
    vm.show = function(id) {
      return Restangular
      .one('locations', id)
      .get()
      .then(function(location) {
        if (angular.isUndefined($rootScope.activeLocation) || $rootScope.activeLocation === id) {
          data.location = location;
        }
        return location;
      });
    };

    /**
     * Get /locations/:id from server.  Return `location` object.  Similiar to `show()` except that
     * no `location` object gets assigned.
     */
    vm.detail = function(id) {
      return Restangular
      .one('locations', id)
      .get()
      .then(function(location) {
        return location;
      });
    };

    /**
     * Post /locations to server with `settings` object.  Add's a location, updates Alerts, and
     * location index.  Does not return anything.
     */
    vm.add = function(settings) {
      return Restangular
      .one('locations')
      .post(undefined, settings)
      .then(function(response) {
        data.location = response;
        $rootScope.activeLocation = response.id;
        return vm.index();
      })
      .then(function() {
        Alerts.index(data.locations.plain());
      }, function(error) {
        Dialogs.showDialog('Location Add Error', error.data.error);
      });
    };

    /**
     * Searches equipment in `location` for `outdoorTemperature` and returns a value.
     * `-40` represents no temperature.
     */
    vm.getOutdoorTemp = function(location) {
      var temp = _.find(location.equipment, function(n) {
        return n.outdoorTemperature;
      });

      if (temp) {
        return temp.outdoorTemperature;
      } else {
        return -40;
      }
    };

    /**
     * Removes a location of `id`.  Updates location index.  Returns false if no more locations exist,
     * returns location data of first location if locations still exist.
     */
    vm.remove = function(id) {
      return Restangular
      .one('locations', id)
      .remove(undefined, {
        "Content-Type": "application/json"
      })
      .then(function() {
        return vm.index();
      })
      .then(function() {
        if (angular.isDefined(data.locations[0])) {
          $rootScope.activeLocation = data.locations[0].id;
          return vm.show(data.locations[0].id);
        } else {
          return false;
        }
      });
    };

    /**
     * Get /connected_systems/:mac from server.  Returns boolean if MAC is recognized by server.
     */
    vm.isSystemConnected = function(mac) {
      return Restangular.withConfig(function(RestangularProvider) {
        RestangularProvider.setFullResponse(true);
      })
      .one('connected_systems', mac)
      .get()
      .then(function(response){
        if (response.status === 204) {
          return true;
        } else {
          return false;
        }
      });
    };

    /**
     * Post /connected_systems to server with `{"locationID": id, "adapterMACAddress": mac}`.  Connects
     * a `mac` to server.  Returns server response.
     */
    vm.connectSystem = function(id, mac) {
      return Restangular
      .one('connected_systems')
      .post(undefined, {"locationID": id, "adapterMACAddress": mac})
      .then(function(response){
        return response;
      });
    };

    /**
     * Put /locations/:id to server.  `location` object used to obtain id.  Returns `true` when successful.
     */
    vm.updateMetadata = function(location) {
      return Restangular
      .one('locations', location.id)
      .customPUT({name: location.name, city: location.city, state: location.state, timeZoneGMTOffset: location.timeZoneGMTOffset, zipCode: location.zipCode})
      .then(function() {
        return true;
      });
    };

    /**
     * Using a given `zipcode` will obtain information about it using Google API.  Returns an object that
     * contains `city` `state` and `timeZoneGMTOffset`.
     */
    vm.verifyZipcode = function(zipcode) {
      return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setDefaultHeaders({});
      })
      .oneUrl('geocode', 'https://maps.googleapis.com/maps/api/geocode/json')
      .get({address: 'postal_code:' + zipcode, key: $rootScope.gapi})
      .then(function(data) {
        var stateObj = _(data.results).find('address_components').address_components.find(function(n) {
          return _.includes(n.types, 'administrative_area_level_1');
        });
        var cityObj = _(data.results).find('address_components').address_components.find(function(n) {
          return _.includes(n.types, 'locality');
        });

        if (!stateObj || !cityObj) return false;

        return {
          lat: data.results[0].geometry.location.lat,
          lng: data.results[0].geometry.location.lng,
          address: data.results[0].formatted_address,
          city: cityObj?cityObj.short_name:null,
          state: stateObj?stateObj.short_name:null
        };
      })
      .then(function(locationData) {
        if (!locationData) return false;

        return Restangular.withConfig(function(RestangularConfigurer) {
          RestangularConfigurer.setDefaultHeaders({});
        })
        .oneUrl('geocode', 'https://maps.googleapis.com/maps/api/timezone/json')
        .get({location: locationData.lat + ',' + locationData.lng, timestamp: moment().unix(), key: $rootScope.gapi})
        .then(function(data) {
           return {
            city: locationData.city,
            state: locationData.state,
            timeZoneGMTOffset: ((data.rawOffset + data.dstOffset) / 60) / 60
          };
        });
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .service('Equipment', Equipment);

  /** @ngInject */
  function Equipment(Restangular, Location, Alerts, Dialogs) {
    var vm = this;

    /**
     * Get /equipment/:id from server and return a boolean for `isConnected`.
     */
    vm.isConnected = function(id) {
      return Restangular
      .one('equipment', id)
      .get()
      .then(function(equipment) {
        return equipment.isConnected;
      });
    };

    /**
     * Get /equipment/:id from server.  Assign `increasePoint` and `decreasePoint` methods to equipment
     * object returned.  If `fanMode: true` assign `increaseFanSpeed` and `decreaseFanSpeed` methods to
     * equipment.  Returns `equipment` object.
     */
    vm.show = function(id) {
      return Restangular
      .one('equipment', id)
      .get()
      .then(function(equipment) {
        equipment.increasePoint = vm.increasePoint;
        equipment.decreasePoint = vm.decreasePoint;

        // if (equipment.scheduleOverrideUntilDate) {
        //   equipment.scheduleOverrideUntilDate = moment(equipment.scheduleOverrideUntilDate).add(Location.get().location.timeZoneGMTOffset, 'h').format();
        // }

        if (equipment.fanMode) {
          equipment.increaseFanSpeed = increaseFanSpeed;
          equipment.decreaseFanSpeed = decreaseFanSpeed;
        }
        return equipment;
      });
    };

    /**
     * Get /equipment/:id/fanModes from server.  Returns `fanModes` array.
     */
    vm.getFanModes = function(id) {
      return Restangular
      .one('equipment', id)
      .all('fanModes')
      .getList()
      .then(function(modes) {
        return modes;
      });
    };

    /**
     * Get /equipment/:id/modes from server.  Returns `modes` array.
     */
    vm.getModes = function(id) {
      return Restangular
      .one('equipment', id)
      .all('modes')
      .getList()
      .then(function(modes) {
        return modes;
      });
    };

    /**
     * Put /equipment/:id/modes to server with `{"mode": mode}` object.  Returns server response.
     */
    vm.setMode = function(id, mode) {
      return Restangular
      .one('equipment/', id)
      .all('modes')
      .customPUT({"mode": mode})
      .then(function(response) {
        return response;
      });
    };

    function increaseFanSpeed() {
      var equipment = this;
      var length = equipment.fanModes.length;
      var currentIndex = _.findIndex(equipment.fanModes, {name: equipment.fanMode});
      if (currentIndex + 1 < length) {
        equipment.fanModes.customPUT({"fanMode": equipment.fanModes[currentIndex + 1].name})
        .then(function() {
          equipment.fanMode = equipment.fanModes[currentIndex + 1].name;
        });
      }
    }

    function decreaseFanSpeed() {
      var equipment = this;
      var currentIndex = _.findIndex(equipment.fanModes, {name: equipment.fanMode});
      if (currentIndex - 1 >= 0) {
        equipment.fanModes.customPUT({"fanMode": equipment.fanModes[currentIndex - 1].name})
        .then(function() {
          equipment.fanMode = equipment.fanModes[currentIndex - 1].name;
        });
      }
    }

    /**
     * Increases temperature with respect to deadband and limits.
     */
    vm.increasePoint = function(changePoint, limit, deadband) {
      var equipment = this,
          newValue = equipment[changePoint],
          max = limit?limit:equipment['max' + changePoint[0].toUpperCase() + changePoint.slice(1)];

      if (newValue < max){
        newValue++;

        vm.deadband.call(equipment, deadband | equipment.deadband, '+', changePoint, newValue);

        equipment[changePoint] = newValue;
      }
    };

    /**
     * Decreases temperature with respect to deadband and limits.
     */
    vm.decreasePoint = function(changePoint, limit, deadband) {
      var equipment = this,
          newValue = equipment[changePoint],
          min = limit?limit:equipment['min' + changePoint[0].toUpperCase() + changePoint.slice(1)];

      if (newValue > min){
        newValue--;

        vm.deadband.call(equipment, deadband | equipment.deadband, '-', changePoint, newValue);

        equipment[changePoint] = newValue;
      }
    };

    /**
     * Activated by `increasePoint` and `decreasePoint` when temperature needs to be set in respect
     * to the deadband settings.
     */
    vm.deadband = function(deadband, direction, changePoint, newValue) {
      var equipment = this;
      if (changePoint === 'heatSetPoint') {
        if (direction === '+') {
          if (equipment.coolSetPoint - newValue < deadband) {
            equipment['coolSetPoint']++;
          }
        }
      } else if (changePoint === 'coolSetPoint') {
        if (direction === '-') {
          if (newValue - equipment.heatSetPoint < deadband) {
            equipment['heatSetPoint']--;
          }
        }
      }
    };

    /**
     * Get /equipment/:id/schedule from server.  Returns `schedule` object.
     */
    vm.getSchedule = function(id) {
      return Restangular
      .one('equipment', id)
      .one('schedule')
      .get()
      .then(function(schedule) {
        return schedule;
      });
    };

    /**
     * Post /equipment_check to server.  Returns boolean from response `equipmentChanged`.
     */
    vm.equipmentCheck = function() {
      return Restangular
      .one('equipment_check')
      .post()
      .then(function(response) {
        if (response.equipmentChanged) {
          return Location.index()
          .then(function() {
            Dialogs.showDialog('New Equipment Found', 'New connected equipment was detected and successfully added to your location.');
            return true;
          });
        } else {
          Dialogs.showDialog('No New Equipment', 'No additional equipment was detected at this time.');
          return false;
        }
      });
    };

    /**
     * Post /equipment_check with `{"locationID": id, "adapterMacAddress": mac}`.  Returns server response.
     */
    vm.connectedSystems = function(id, mac) {
      return Restangular
      .one('equipment_check')
      .post(null, {"locationID": id,"adapterMACAddress": mac})
      .then(function(response) {
        return response;
      });
    };

    /**
     * Get /equipment/:id/settings from server. Returns `settings` array.
     */
    vm.getSettings = function(id) {
      return Restangular
      .one('equipment', id)
      .all('settings')
      .getList()
      .then(function(settings) {
        return settings;
      });
    };

    /**
     * Get /equipment/:id/usage from server.  Returns server response.
     */
    vm.getUsageReport = function(id) {
      return Restangular
      .one('equipment', id)
      .one('usage')
      .get()
      .then(function(response) {
        return response.plain();
      });
    };

    /**
     * Get /safetyandcaredocuments/:modelnumber from server.  Returns response object.
     */
    vm.getDocuments = function(modelnumber) {
      return Restangular
      .one('safetyandcaredocuments', modelnumber)
      .get()
      .then(function(response) {
        return response;
      });
    };

    /**
     * Put /equipment/:id/settings to server with `{"name": name, "value": value}`.  Modifies given
     * setting of `name` with `value` for equipment with provided `id`.  Returns response object.
     */
    vm.modifySetting = function(id, name, value) {
      return Restangular
      .one('equipment', id)
      .all('settings')
      .customPUT({name: name, value: value})
      .then(function(data) {
        return data;
      });
    };

    /**
     * Put /equipment/:id/ to server with `options` object.  This will update a given option for
     * a piece of equipment of `id`.  Returns response object.
     */
    vm.updateSetting = function(id, options) {
      return Restangular
      .one('equipment', id)
      .customPUT(options)
      .then(function(data) {
        return data;
      });
    };

    /**
     * Remove equipment of `id`.  Updates Alert `data` object using new `locations` index.  Returns server response.
     */
    vm.remove = function(id) {
      return Restangular
      .one('equipment', id)
      .remove(undefined, {
        "Content-Type": "application/json"
      })
      .then(function(data) {
        Alerts.index(Location.get().locations);
        return data;
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .service('Econet', Econet);

  /** @ngInject */
  function Econet(Restangular, $log) {
    var vm = this;

    var networkAddress = 'http://192.168.10.1/';

// // GET to http://www.google.com/ You set the URL in this case
// Restangular.allUrl('googlers', 'http://www.google.com/').getList();

// // GET to http://www.google.com/1 You set the URL in this case
// Restangular.oneUrl('googlers', 'http://www.google.com/1').get();

    vm.scan = function() {
      return Restangular
      .oneUrl('sys/scan', networkAddress + 'sys/scan')
      .get()
      .then(function(networks) {
        $log.debug(networks);
        return networks;
      }, function() {
        $log.debug('error');
      });
    };

    // /sys/scan

//     {
//   "networks": [
//     [
//       "WYCHE-2.4",
//       "9c:34:26:e0:19:ee",
//       5,
//       1,
//       -96,
//       -98
//     ],
//     [
//       "ATT132",
//       "60:fe:20:76:f6:12",
//       5,
//       1,
//       -92,
//       -98
//     ],
//     [
//       "xfinitywifi",
//       "ae:34:26:e0:19:ee",
//       0,
//       1,
//       -95,
//       -98
//     ],
//     [
//       "NETGEAR79",
//       "a0:63:91:e4:1e:26",
//       4,
//       2,
//       -86,
//       -98
//     ],
//     [
//       "2WIRE376",
//       "b8:e6:25:32:6e:19",
//       5,
//       4,
//       -91,
//       -98
//     ],
//     [
//       "2WIRE459",
//       "b8:e6:25:a9:47:99",
//       5,
//       4,
//       -85,
//       -98
//     ],
//     [
//       "ATT4hUK3Yv",
//       "dc:7f:a4:30:f8:de",
//       4,
//       5,
//       -77,
//       -98
//     ],
//     [
//       "ATT400",
//       "60:fe:20:bf:63:b2",
//       5,
//       5,
//       -90,
//       -98
//     ],
//     [
//       "ATT4jzX2T2",
//       "f8:18:97:93:db:1e",
//       5,
//       5,
//       -89,
//       -98
//     ],
//     [
//       "ATT9E5S5h3",
//       "44:e1:37:2a:e0:90",
//       5,
//       6,
//       -93,
//       -98
//     ],
//     [
//       "HOME-BBC0-2.4",
//       "84:00:2d:e1:a6:38",
//       5,
//       6,
//       -91,
//       -98
//     ],
//     [
//       "xfinitywifi",
//       "84:00:2d:e1:a6:3a",
//       0,
//       6,
//       -90,
//       -98
//     ],
//     [
//       "ATT3k4P7c3",
//       "10:05:b1:38:3b:c0",
//       5,
//       6,
//       -88,
//       -98
//     ],
//     [
//       "2WIRE224",
//       "60:c3:97:c3:da:b1",
//       5,
//       6,
//       -92,
//       -98
//     ],
//     [
//       "2WIRE529",
//       "c0:83:0a:e4:b2:09",
//       5,
//       8,
//       -88,
//       -98
//     ],
//     [
//       "Arthur Murtagh",
//       "00:23:69:b1:56:41",
//       4,
//       11,
//       -58,
//       -98
//     ],
//     [
//       "ATT823",
//       "f8:18:97:69:4a:b2",
//       5,
//       11,
//       -74,
//       -98
//     ],
//     [
//       "xfinitywifi",
//       "ae:34:26:8f:71:1a",
//       0,
//       11,
//       -89,
//       -98
//     ],
//     [
//       "ATTFB8tkwa",
//       "64:55:b1:79:68:20",
//       5,
//       11,
//       -68,
//       -98
//     ]
//   ]
// }

// /sys

// {
//   "uuid": "c86408621ba63a28dc85dec55ae2",
//   "interface": "uap",
//   "prov": {
//     "types": [
//       "marvell",
//       "wps"
//     ]
//   },
//   "connection": {
//     "station": {
//       "mac_addr": "dc:85:de:c5:5a:e2",
//       "configured": 0,
//       "status": 0
//     },
//     "uap": {
//       "ssid": "EcoNet-DC85DEC55AE2",
//       "bssid": "dc:85:de:c5:5a:e2",
//       "channel": 0,
//       "security": 0,
//       "ip": 0
//     }
//   }
// }



  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .service('Alerts', Alerts);

  /** @ngInject */
  function Alerts(Restangular) {
    var vm = this;

    var data = {};

    /**
     * Returns Alert `data` object.
     */
    vm.get = function() {
      return data;
    };

    /**
     * Get /alerts from server, and use `locations` object passed in to find the equipment name
     * for each alert.  Writes `alerts` into `data` object.  Returns `data` object.
     */
    vm.index = function(locations) {
      return Restangular
      .all('alerts')
      .getList()
      .then(function(alerts) {
        _.forEach(alerts, function(value, key) {
          alerts[key].equipment.name = _(locations).flatMap('equipment').find(['id', value.equipment.id]).name;
        });
        data.alerts = alerts;
        vm.getUnreadCount();
        groupByEquipment();
        return data;
      });
    };

    /**
     * Uses `alert` object passed in to connect to /alerts/:id and set `markedAsRead` to `true`.
     */
    vm.markAsRead = function(alert) {
      Restangular.one('alerts', alert.id)
      .customPUT({'markedAsRead' : true})
      .then(function(){
        data.alerts[_.indexOf(data.alerts, alert)].markedAsRead = true;
        vm.getUnreadCount();
        groupByEquipment();
      });
    };

    /**
     * Search through `alerts` inside `data` object to find all alerts with `markedAsRead: false`. 
     */
    vm.getAlertById = function(id) {
      return _.find(data.alerts, ['id', id]);
    };

    vm.getUnreadCount = function() {
      data.newAlertCount = _.filter(data.alerts, ['markedAsRead', false]).length;
      return data.newAlertCount;
    };


    function groupByEquipment() {
      data.equipment = {};
      data.equipment = _.groupBy(data.alerts, 'equipment.id');

      _.forEach(data.equipment, function(value, key) {
        data.equipment[key].critical = _(value).filter(['level', 'Critical']).orderBy('timestamp', 'desc').value();
        data.equipment[key].alert = _(value).filter(['level', 'Alert']).filter(['markedAsRead', false]).orderBy('timestamp', 'desc').value();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('VacationFooterController', VacationFooterController);

  /** @ngInject */
  function VacationFooterController(Location) {
    var vm = this;

    vm.data = Location.get();
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('VacationController', VacationController);

  /** @ngInject */
  function VacationController($scope, $state, $q, $stateParams, Location, Vacation, Equipment) {
    var vm = this;
    var locationId;

    vm.format = 'ddd M/D/YYYY h:mmA';
    vm.startTime = new moment();
    var endTime = moment().day(7).set({'hour': 17, 'minute': 0, 'seconds': 0});

    vm.data = Location.get();
    locationId = vm.data.location.id;
    populateVacationData();

    vm.toggle = function (item, list, equipment) {
      if (equipment.isConnected) {
        var idx = _.findIndex(list, {'id': item});
        if (idx > -1) {
          list.splice(idx, 1);
        }
        else {
          list.push({'id': item});
        }
      }
    };

    vm.exists = function (item, list) {
      return _.findIndex(list, {'id': item}) > -1;
    };

    vm.create = function() {
      formatDate();

      Vacation.add(vm.settings)
      .then(function() {
        Location.show(locationId)
        .then(function() {
          $state.go('locations');
        });
      });
    };

    vm.update = function() {
      formatDate();

      Vacation.update(vm.data.vacation.id, vm.settings)
      .then(function() {
        Location.show(locationId)
        .then(function() {
          $state.go('locations');
        });
      });
    };

    vm.delete = function() {
      Vacation.remove(vm.data.vacation.id)
      .then(function() {
        Location.show(locationId)
        .then(function() {
          $state.go('locations');
        });
      });
    };

    vm.decreasePoint = function(changePoint, equipment) {
      Equipment.decreasePoint.call(vm.settings, changePoint, equipment.minHeatSetPoint, equipment.deadband);
    };

    vm.increasePoint = function(changePoint, equipment) {
      Equipment.increasePoint.call(vm.settings, changePoint, equipment.maxHeatSetPoint, equipment.deadband);
    };

    vm.decreaseFanMode = function() {
      var currentIndex = vm.defaults.availableFanModes.indexOf(vm.settings.fanMode);
      if (currentIndex > 0) {
        vm.settings.fanMode = vm.defaults.availableFanModes[currentIndex - 1];
      }
    };

    vm.increaseFanMode = function() {
      var length = vm.defaults.availableFanModes.length;
      var currentIndex = vm.defaults.availableFanModes.indexOf(vm.settings.fanMode);
      if (currentIndex < length -1) {
        vm.settings.fanMode = vm.defaults.availableFanModes[currentIndex + 1];
      }
    };

    function populateVacationData() {
      $q.all([
        Vacation.getVacation(locationId),
        Vacation.getDefaults(locationId)
      ])
      .then(function(data) {
        vm.data.vacation = data[0];
        vm.defaults = data[1];

        // configure settings if a vacation exists
        if (vm.data.vacation) {
          vm.selected = _.map(data[0].participatingEquipment, function(n) {
            return {'id': n.id};
          });
          vm.settings = {
            'participatingEquipment': vm.selected,
            'heatSetPoint': data[0].heatSetPoint,
            'coolSetPoint': data[0].coolSetPoint,
            'fanMode': data[0].fanMode,
            'startDate': data[0].startDate,
            'endDate': data[0].endDate
          };
        // if no vacation exists then configure settings to defaults
        } else {
          vm.settings = {
            'participatingEquipment': [],
            'heatSetPoint': data[1].heatSetPoint,
            'coolSetPoint': data[1].coolSetPoint,
            'fanMode': data[1].fanMode,
            'startDate': vm.startTime,
            'endDate': endTime,
            'location': {'id': Number(locationId)}
          };
        }
        vm.startDate = moment(vm.settings.startDate).format(vm.format);
        vm.endDate = moment(vm.settings.endDate).format(vm.format);
      });
    }

    function formatDate() {
      vm.settings.startDate = moment(vm.startDate, vm.format).toISOString();
      vm.settings.endDate = moment(vm.endDate, vm.format).toISOString();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('staticInclude', staticInclude);

  /** @ngInject */
  function staticInclude($templateRequest, $compile) {
    return {
      restrict: 'A',
      scope: {
        'staticInclude': '@',
        'onFinish': '&onFinish'
      },
      link: function(scope, element, attrs) {
        attrs.$observe('staticInclude', function() {
          var useLoad = angular.isDefined(scope.onFinish);
          if (attrs.staticInclude !== '') {
            var templatePath = 'app/settings/_' + attrs.staticInclude + '.html';
            $templateRequest(templatePath)
            .then(function(response) {
              var contents = element.html(response).contents();
              $compile(contents)(scope.$parent);
              if (useLoad) {
                scope.onFinish();
              }
            });
          }
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController(menuFactory, ENVIRONMENT, $log, $interval, $timeout, $rootScope, $mdSidenav, $state, $scope, Restangular, Dialogs, User, Equipment, Location) {
    var vm = this;
    root();

    vm.languages = [{abbr: 'en', full: 'English'}, {abbr: 'fr', full: 'French'}, {abbr: 'sp', full: 'Spanish'}];
    vm.language = 'en';

    function changeEmail() {
      var fs = this;
      fs.options = {
        'email': '',
        'validationPassword': ''
      };
      fs.emailVerify = '';
      fs.match = true;

      fs.update = function() {
        if (fs.options.email === fs.emailVerify) {
          fs.match = true;
          User.updateSetting(fs.options)
          .then(function() {
            $log.debug
        icon.password-visibility(name='icon-visibility')("Email Updated");
            root();
          }, function error(response) {
            Dialogs.showDialog('Email Update Error', response.data.error);
          });
        } else {
          fs.match = false;
        }
      };
    }

    function changePassword() {
      var fs = this;
      fs.options = {
        'password': '',
        'validationPassword': ''
      };

      fs.confirmPassword = '';
      fs.match = true;

      fs.update = function() {
        if (fs.options.password === fs.confirmPassword) {
          fs.match = true;
          User.updateSetting(fs.options)
          .then(function() {
            $log.debug
        icon.password-visibility(name='icon-visibility')("Password Updated");
            root();
          }, function error(response) {
            Dialogs.showDialog('Password Update Error', response.data.error);
          });
        } else {
          fs.match = false;
        }
      };
    }

    function temperatureUnit() {
      var fs = this;

      User.show()
      .then(function(user) {
        fs.user = user;
      });

      fs.update = function() {
        fs.option = { "temperatureDisplayUnit": fs.user.temperatureDisplayUnit };
        User.updateSetting(fs.option)
        .then(function(data) {
          $rootScope.temperatureDisplayUnit = data.temperatureDisplayUnit;
        });
      };
    }

    function contractorInfo() {
      var fs = this;
      fs.preload = 'contractor';

      Restangular.all('contractors')
      .getList()
      .then(function(contractors) {
        fs.contractors = contractors;
      });
      fs.contractor = {};
      fs.action = null;
      fs.index = null;

      function defaults() {
        return {
          "contactName": "",
          "companyName": "",
          "phoneNumbers": [{
            "number": "",
            "isMainNumber": true
          }],
          "expertiseHVAC": false,
          "expertiseWaterHeater": false,
          "expertisePoolAndSpa": false,
          "email": "",
          "notes": ""
        };
      }

      fs.saveContractor = function() {
        if (fs.action === 'edit') {
          fs.contractors[fs.index].customPUT(fs.options)
          .then(function(){
            _.merge(fs.contractors[fs.index], fs.options);
            fs.cancel();
          });
        } else {
          fs.contractors.post(fs.options)
          .then(function(data) {
            fs.contractors.push(data);
            fs.cancel();
          });
        }
      };

      fs.cancel = function() {
        fs.index = null;
        vm.back();
      };

      fs.addNumberField = function() {
        fs.options.phoneNumbers.push({
          "number": '',
          "isMainNumber": false
        });
      };

      fs.addContractor = function() {
        vm.forward();
        fs.options = defaults();
        $scope.addContractorForm.$setUntouched();
      };

      fs.viewContractor = function(id,index) {
        vm.forward();
        fs.contractor = _.find(fs.contractors, function(contractor) {
          return contractor.id === id;
        });
        fs.index = index;
        fs.options = _.pick(fs.contractor, ['contactName', 'companyName', 'phoneNumbers', 'expertiseHVAC', 'expertiseWaterHeater', 'expertisePoolAndSpa', 'email', 'notes']);
        fs.action = 'view';
      };

      fs.editContractor = function() {
        fs.action = 'edit';
      };

      fs.removeContractor = function(id) {
        Restangular.one('contractors', id)
        .remove(undefined, {
          "Content-Type": "application/json"
        })
        .then(function() {
          fs.contractors = Restangular.all('contractors').getList().$object;
          vm.back();
        });
      };
    }

    function locationsAndEquipment() {
      var fs = this;
      fs.preload = 'manageEquipment';

      fs.locations = Location.get();

      fs.editLocation = function(location) {
        vm.crumb[2].header = 'Edit Location';
        vm.state = 'editLocation';
        fs.location = location;
        vm.forward();
      };

      fs.editEquipment = function(equipment) {
        vm.crumb[2].header = 'Edit Equipment';
        vm.state = 'editEquipment';
        fs.equipment = equipment;
        vm.forward();
      };

      fs.addLocation = function() {
        vm.crumb[2].header = 'Add Location';
        vm.state = 'addLocation';
        fs.steps = ['add-location-tutorial','connect-module','add-location'];
        vm.forward();
      };

      fs.addEquipment = function(location) {
        vm.crumb[2].header = 'Add Equipment';
        vm.state = 'addEquipment';
        fs.steps = ['add-location-tutorial','connect-module','add-equipment'];
        fs.location = location;
        vm.forward();
      };

      fs.removeLocation = function() {
        Dialogs.showDialog('Delete Confirmation', 'Are you sure you wish to delete ' + fs.location.name + '?', null, {type: 'confirm', ok: 'Delete'})
        .then(function() {
          return Location.remove(fs.location.id);
        })
        .then(function() {
          $state.go("locations");
          vm.back();
        });
      };

      fs.removeEquipment = function() {
        Dialogs.showDialog('Delete Confirmation', 'Are you sure you wish to delete ' + fs.equipment.name + '?', null, {type: 'confirm', ok: 'Delete'})
        .then(function() {
          return Equipment.remove(fs.equipment.id);
        })
        .then(function() {
          $state.go("locations");
          vm.back();
        });
      };

      fs.updateLocation = function(location) {
        Location.updateMetadata(location)
        .then(function(){
          vm.back();
        });
      };

      fs.updateEquipment = function() {
        var option = { "name": fs.equipment.name };
        Equipment.updateSetting(fs.equipment.id, option)
        .then(function() {
          vm.back();
        });
      };
    }

    function networkInfo() {
      var fs = this;
      fs.preload = 'network';

      fs.viewNetwork = function(network) {
        vm.forward();
        fs.network = network;
        fs.network.wifiSignal = Math.round(fs.network.wifiSignal * 100 / 20) * 20;
      };

      Restangular.all('wifimodules')
      .getList()
      .then(function(modules) {
         fs.modules = modules;
      });
    }

    function notificationsPreferences() {
      var fs = this;
      var initialPhoneNumber;
      User.getIdentity()
      .then(function(identity) {
        initialPhoneNumber = identity.phone;
        fs.identity = identity;
        fs.notifications = Restangular.one('notifications').get().$object;
      });

      fs.update = function() {
        if (fs.notifications.allowTextNotifications && fs.identity.phone !== initialPhoneNumber) {
          User.updateSetting({phone: fs.identity.phone.replace(/\D/gi, '')})
          .then(function() {
            savePreferences();
          }, function(response) {
            Dialogs.showDialog('Error', response.data.error);
          });
        } else {
          savePreferences();
        }
      };

      function savePreferences() {
        Restangular
        .copy(fs.notifications)
        .put()
        .then(function() {
          root();
        }, function(response) {
          Dialogs.showDialog('Error', response.data.error);
        });
      }
    }

    function nest() {
      var fs = this;
      fs.preload = 'nestAttach';

      fs.locations = Location.get();

      fs.nestArray = {
        'Production': 'https://home.nest.com/login/oauth2?client_id=a59625e9-3933-4a6e-8a37-2cd8b8ad83db&state=STATE',
        'Staging': 'https://home.nest.com/login/oauth2?client_id=a12ebce0-8490-4778-be64-5889b6355df8&state=STATE'
      };

      fs.nestAddress = fs.nestArray[ENVIRONMENT.NAME];

      if (vm.params && vm.params.code) {
        User.addNestToken(vm.params.code)
        .then(function() {
          return User.getNestLocations();
        })
        .then(function(data) {
          fs.nestLocations = data;
          if (fs.locations.locations.length > 1) {
            Dialogs.showDialog('Automatic Location Pairing Unavailable', 'Please complete your pairing by selecting a Nest structure below.');
          }
        });
      } else {
        User.getNestLocations()
        .then(function(data) {
          fs.nestLocations = data;
        });
      }

      fs.disconnect = function() {
        Dialogs.showDialog('Are you sure?', 'This will disconnect your Nest from EcoNet.', null, {type: 'confirm', ok: 'Disconnect'})
        .then(function() {
          return User.removeNest();
        })
        .then(function() {
          return User.getNestLocations();
        })
        .then(function(response) {
          fs.nestLocations = response;
        }, function() {
          fs.nestLocations = null;
        });
      };

      fs.attachNest = function(nest) {
        fs.nestLocation = nest;
        vm.forward();
      };

      fs.attach = function(nest, locationId) {
        if (nest.pairedLocation && nest.pairedLocation.id === locationId) locationId = null;

        if (_.find(fs.nestLocations, ['pairedLocation.id', locationId])) {
          Dialogs.showDialog('Location Paired', 'This EcoNet location is currently paired.  Please un-pair this location and try again.', null, {type: 'alert', ok: 'Okay'});
        } else {
          User.attachNestToLocation(nest.id, locationId)
          .then(function() {
            return User.getNestLocations();
          })
          .then(function(response) {
            fs.nestLocations = response;
            fs.nestLocation = _.find(response, ['id', nest.id]);
          });
        }
      };
    }

    function getStarted() {}

    function privacyStatement() {}

    function termsOfService() {}

    function troubleshooting() {}

    //functions for menu-link and menu-toggle
    vm.isOpen = isOpen;
    vm.toggleOpen = toggleOpen;
    vm.autoFocusContent = false;
    vm.menu = menuFactory;
    vm.open = true;

    vm.menuOpen = function() {
      return $mdSidenav("settings").isOpen();
    };

    function isOpen(section) {
      return menuFactory.isSectionSelected(section);
    }

    function toggleOpen(section) {
      menuFactory.toggleSelectSection(section);
    }

    vm.select = function(state, header) {
      if (!header) {
        header = state;
        header = header.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
        header = header.charAt(0).toUpperCase() + header.slice(1);
      }

      vm.crumb.push({name: state, header: header});
      vm.forward();
    };

    vm.preload = function(state, header) {
      if (!header) {
        header = state;
        header = header.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
        header = header.charAt(0).toUpperCase() + header.slice(1);
      }

      vm.crumb.push({name: state, header: header});
    };

    vm.load = function(state) {
      if (vm.currentState !== state) {
        vm[vm.currentState] = null;

        switch (state) {
          case "changeEmail": vm.changeEmail = new changeEmail(); break;
          case "changePassword": vm.changePassword = new changePassword(); break;
          case "temperatureUnit": vm.temperatureUnit = new temperatureUnit(); break;
          case "contractorInfo": vm.contractorInfo = new contractorInfo(); break;
          case "getStarted": vm.getStarted = new getStarted(); break;
          case "nest": vm.nest = new nest(); break;
          case "locationsAndEquipment": vm.locationsAndEquipment = new locationsAndEquipment(); break;
          case "networkInfo": vm.networkInfo = new networkInfo(); break;
          case "notificationsPreferences": vm.notificationsPreferences = new notificationsPreferences(); break;
          case "privacyStatement": vm.privacyStatement = new privacyStatement(); break;
          case "termsOfService": vm.termsOfService = new termsOfService(); break;
          case "troubleshooting": vm.troubleshooting = new troubleshooting(); break;
        }
      }
      vm.currentState = state;

      if (vm[vm.currentState].preload) {
        vm.preload(vm[vm.currentState].preload);
      }
    };

    vm.close = function() {
      $mdSidenav('settings').close();
    };

    vm.back = function() {
      if (vm.settingsIndex > 0) {
        vm.crumb = _.slice(vm.crumb, 0, vm.settingsIndex);
        vm.settingsIndex -= 1;

        if (vm.settingsIndex !== 0) {
          vm.load(vm.crumb[vm.settingsIndex].name);
        } else {
          vm[vm.currentState] = null;
          vm.currentState = null;
        }
      }
    };

    vm.forward = function() {
      if (vm.settingsIndex < vm.crumb.length) {
        vm.settingsIndex += 1;
      }
    };

    function root() {
      vm[vm.currentState] = null;
      vm.currentState = null;
      vm.settingsIndex = 0;

      vm.crumb = [{
        name: 'settings',
        header: 'Settings'
      }];
    }

    $scope.$on("drillIntoMenusettings", function(event, args) {
      if (args.data.name === 'root') {
        root();
      } else {
        vm.select(args.data.name);
        vm.params = args.data;
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('RegistrationController', RegistrationController);

  /** @ngInject */
  function RegistrationController() {
    var vm = this;

    vm.steps = ['terms', 'register-account', 'add-location-tutorial', 'connect-module', 'add-location', 'add-equipment', 'notification-preferences'];
    vm.totalSteps = vm.steps.length;
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('RedirectController', RedirectController);

  /** @ngInject */
  function RedirectController($window, $state, $stateParams) {
    var vm = this;
    vm.params = $stateParams;
    vm.frame = false;
    vm.showNext = false;

    var inIframe = window.self !== window.top;
    if (inIframe) {
      vm.showNext = true;
    }

    vm.goNext = function() {
      parent.postMessage({adapterMACAddress: vm.params.id}, "*");
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('LoginController', LoginController);

  /** ÿngInject */
  function LoginController(Restangular, ENVIRONMENT, $window, $mdMedia, $templateCache, $http, $scope, $state, auth, $rootScope, Dialogs, User) {
    var vm = this;
    vm.state = $state;
    vm.mdMedia = $mdMedia;

    vm.user = {
      username: '',
      password: '',
      grant_type: 'password'
    };

    vm.environments = ENVIRONMENT.ARRAY;
    vm.environment = ENVIRONMENT.NAME;

    $rootScope.showEnvironmentSelect = function() {
      vm.showEnvironmentSelect = !vm.showEnvironmentSelect;
    };

    vm.updateEnv = function() {
      window.localStorage.setItem('serverEnvironment', vm.environment);
      location.reload();
    };

    vm.login = function() {
      var user_data = $.param(vm.user);
      auth.authenticate($rootScope.app_data_basic, user_data, vm.keepLoggedIn)
      .then(function(data) {
        if (data) {
          return User.getIdentity();
        }
      })
      .then(function() {
        $state.go('locations');
      }, function error() {
        Dialogs.showDialog('Login Error', 'Invalid email and password combination.  Please try again.');
        return false;
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('ForgotController', ForgotController);

  /** @ngInject */
  function ForgotController(User, Dialogs, auth, $rootScope, $state, $log, $stateParams) {
    var vm = this;
    vm.forgotPasswordEmail = '';
    vm.options = {
      'password': '',
      'email': $stateParams.email || '',
      'token': $stateParams.token || ''
    };

    vm.confirmPassword = '';
    vm.match = true;

    vm.forgotPassword = function() {
      User.forgotPassword(vm.forgotPasswordEmail)
      .then(function() {
        Dialogs.showDialog('Check your email', 'An email has been sent to the address provided.  Please follow the instructions there to reset your password.  If you do not receive the message within a few minutes, check your Junk E-mail folder.')
        .then(function() {
          $state.go('login');
        });
      }, function() {
        Dialogs.showDialog('Records Error: Invalid Email', 'Please provide a valid email to reset your password.');
      });
    };

    vm.resetPassword = function() {
      if (vm.options.password === vm.confirmPassword) {
        vm.match = true;
        User.resetPassword(vm.options)
        .then(function() {
          $log.debug("Password Updated");
          var user_data = $.param({
            username: vm.options.email,
            password: vm.options.password,
            grant_type: 'password'
          });

          return login(user_data);
        })
        .then(function(result) {
          if (result) {
            $state.go('locations');
          } else {
            Dialogs.showDialog('Login Error', 'Could not log into your account.');
            $state.go('login');
          }
        }, function error(response) {
          Dialogs.showDialog('Password Update Error', response.data.error);
        });
      } else {
        vm.match = false;
      }
    };

    function login(user_data) {
      return auth.authenticate($rootScope.app_data_basic, user_data)
      .then(function(data) {
        if (data) {
          return User.getIdentity();
        }
      })
      .then(function() {
        return true;
      }, function error() {
        return false;
      });
    }

    vm.cancel = function() {
      $state.go('login');
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('TroubleshootingController', TroubleshootingController);

  /** @ngInject */
  function TroubleshootingController(Location, Equipment, $timeout, $q, $state) {
    var vm = this;
    vm.selectedIndex = 0;
    vm.found = [];

    vm.data = Location.get();

    var promiseList = [];
    _.forEach(vm.data.locations, function(location) {
      promiseList.push(Location.show(location.id));
    });

    $q.all(promiseList)
    .then(function(data) {
      vm.troubleLocations = data;
      return data;
    })
    .then(function(data) {
      data = _.forEach(data, function(location) {
        _.map(location.equipment, function(n) {
          n.locationName = location.name;
        });
      });
      var equipment = _(data).map('equipment').flatten().filter({'isConnected': false}).reject({'type': 'WiFi Adapter'}).value();
      vm.offlineEquipment = equipment;
    });

    vm.continue = function() {
      vm.selectedIndex += 1;
    };

    function retryPromise(promise, maxTries, args) {
      return promise(args)
      .then(function(isConnected){
        if (!isConnected && maxTries - 1 > 0) {
          return $timeout(function() {return retryPromise(promise, maxTries - 1, args);}, 5000);
        } else {
          return isConnected;
        }
      });
    }

    vm.retry = function() {
      vm.selectedIndex += 1;
      var promises = [];
      vm.status = 'searching';

      _.forEach(vm.offlineEquipment, function(value) {
        var promise = retryPromise(Equipment.isConnected, 5, value.id)
        .then(function(data) {
          if (data) {vm.found[value.id] = true;}
          return data;
        });
        promises.push(promise);
      });

      $q.all(promises)
      .then(function(data) {
        if (_.indexOf(data, false) > -1) {
          vm.status = 'support';
        } else {
          vm.status = 'success';
          $timeout(function() {
            $state.go('locations');
          }, 5000);
        }
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .directive('locationEquipmentCard', locationEquipmentCard);

  /** @ngInject */
  function locationEquipmentCard() {
    return {
      restrict: 'E',
      templateUrl: 'app/location/locationEquipmentCard.html'
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('LocationIndexController', LocationIndexController);

  /** @ngInject */
  function LocationIndexController($q, $scope, $timeout, $document, $state, $rootScope, $stateParams, $interval, locations, $mdMedia, $mdDialog, Alerts, Dialogs, Location, Equipment, Vacation) {
    var vm = this,
        autoRefresh,
        watchLocationChange;

        vm.selectedIndex = 0;
        vm.previousIndex = null;
        vm.state = $state;

    function init() {
      if (locations && !!locations.location || locations.length) {
        vm.mdMedia = $mdMedia;
        vm.timers = {};

        vm.data = Location.get();
        vm.vacation = Vacation.get();
        vm.alerts = Alerts.get();
        Vacation.getVacation(vm.data.location.id);
        Alerts.index(vm.data.locations.plain());

        setHeader();
        activateAutoRefresh();
      } else {
        vm.data = Location.get();
        Dialogs.showDialog('No Location', 'You currently have no location');
      }

      intializeLocationsWatcher();
    }

    vm.show = function(index) {
      // If the equipment page is open and the user interacts with the location index,
      // the location view will focus removing all other views.
      if (!$state.is('locations') && vm.previousIndex !== vm.selectedIndex) {
        $state.go('locations');
      }
      if (!vm.data || !vm.data.locations) {
        vm.data = Location.get();
      }

      // Get the location id using the ng-repeat index returned by selectedIndex.
      var id = vm.data.locations[index].id;
      vm.previousIndex = vm.selectedIndex;
      $rootScope.activeLocation = id;

      if (vm.data.location.id !== id) {
        vm.data.location = null;
        Location.show(id)
        .then(function() {
          setHeader();
        });

        Vacation.getVacation(id);
      }
    };

    $timeout(function(){
      if ($stateParams.code) {
        Dialogs.openSidenav('settings', {name: 'nest', code: $stateParams.code, state: $stateParams.state});
      }
    });

    vm.changeTime = function(id, newVal) {
      vm.timers[id].time = newVal;
    };

    vm.changeTemp = function(newVal) {
      vm.outdoorTemperature = newVal !== -40? newVal: false;
    };

    vm.openAlert = function(id) {
      Dialogs.openSidenav('alerts', {alertId: id});
    };

    vm.isValidEquipment = function(value) {
      return (value.type === 'HVAC' || value.type === 'Water Heater');
    };

    vm.isNestEvent = function(equipment, location) {
      if (angular.isDefined(location.nestLocation) && equipment.isOnVacation) {
        return location.nestLocation.state !== 'home' ||
               location.nestLocation.smokeState === 'emergency' ||
               location.nestLocation.coState === 'emergency' ||
               moment().isBetween(location.nestLocation.rhrStart, location.nestLocation.rhrEnd);
      }
    };

    vm.go = function(equipment, location) {
      switch(true) {
        case !equipment.isConnected:
          $state.go('locations.troubleshooting');
          break;
        case equipment.hasCriticalAlert:
          Dialogs.showDialog('Critical Alarm', 'There is an active critical alarm on this equipment. Please check your active alerts.');
          break;
        case vm.isNestEvent(equipment, location):
          showConfirmAlert(location.nestMessage, 'Your water heater set point has been temporarily lowered to minimize operation because your Nest account:<br/>&#8226;is set to Away<br/>&#8226;received a Rush Hour request<br/>&#8226;detected Smoke or Carbon Monoxide<br/>&#8226;Tapping Disable Now will override this event.  This feature can be permanently disabled in Settings.', equipment.id);
          break;
        case equipment.isOnVacation && !equipment.vacationCanBeDisabled:
          Dialogs.showDialog('Vacation Enabled on Unit', 'The Unit is manually set on vacation.  To disable it, please locate your unit and manually switch it to another mode than vacation.');
          break;
        case equipment.isOnVacation && equipment.vacationCanBeDisabled:
          showConfirmAlert('Vacation Enabled', 'Vacation Mode is currently set on this location.  Continuing will disable this location\'s vacation.', equipment.id);
          break;
        case equipment.isConnected:
          $state.go('equipment', {equipmentId: equipment.id});
          break;
      }
    };

    function showConfirmAlert(title, description, id) {
      Dialogs.showDialog(title, description, null, {type: 'confirm', ok: 'Disable Now'})
      .then(function() {
        Equipment.updateSetting(id, {isOnVacation: false})
        .then(function() {
          Location.show(vm.data.location.id);
        });
      });
    }

    function setHeader() {
      // check if an outdoor temperature exists and assign to variable
      vm.changeTemp(Location.getOutdoorTemp(vm.data.location));
      var id = vm.data.location.id;

      if (!vm.timers[id]) {
        vm.timers[id] = {};
        var time, isDst;
        var tick = function(id) {
          if (vm.data.location) {
            vm.timers[id].offset = vm.data.location.timeZoneGMTOffset;
            time = moment().utc().utcOffset(vm.timers[id].offset); // get the current time

            // Local DST so the clock works for most everyone in the US, and residing in the same timezone
            // as the econet unit.
            isDst = moment().utc().local().isDST();
            if (!isDst) {
              time = time.subtract(1,'h');
            }

            vm.changeTime(id, time);
          }
        };
        // Run tick initially and start the timer
        tick(id);
        vm.timers[id].timer = $interval(function() {tick(id);}, 1000);
      }
    }

    function activateAutoRefresh() {
      autoRefresh = $timeout(function() {
        if (angular.isUndefined(vm.data.location) || !vm.data.location) {
          activateAutoRefresh();
          Alerts.index(vm.data.locations.plain());
          $timeout.cancel(autoRefresh);
        }

        if (!document.hidden && vm.data.location) {
          Location.index()
          .then(function() {
            return Location.show(vm.data.location.id);
          })
          .then(function() {
            if (angular.isUndefined(vm.data.locations)) {
              activateAutoRefresh();
            } else {
              return Alerts.index(vm.data.locations.plain());
            }
          })
          .then(function() {
            activateAutoRefresh();
          }, function() {
            activateAutoRefresh();
          });
        } else {
          activateAutoRefresh();
        }
      }, 5000);
    }

    init();

    function intializeLocationsWatcher() {
      watchLocationChange = $scope.$watch('vm.data.locations.length', function (newValue, oldValue) {
        if (oldValue != newValue) {
          destroyFunction();
          Location.index()
          .then(function(data) {
            if (data.length) {
              return Location.show(data[0].id)
              .then(function() {
                return Location.get();
              });
            } else {
              return data.plain();
            }
          }).then(function(response){
            locations = response;
            init();
          });
        }
      }, true);
    }

    $scope.$on('$destroy', destroyFunction);

    function destroyFunction() {
      if (watchLocationChange) watchLocationChange();
      if (autoRefresh) {
        $timeout.cancel(autoRefresh);
        autoRefresh = null;
      }

      _.forEach(vm.timers, function(value, index){
        $interval.cancel(vm.timers[index].timer);
        vm.timers[index].timer = null;
      });

      vm.timers = null;
      vm.data = null;
      vm.vacation = null;
      vm.alerts = null;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('UsageController', UsageController);

  /** @ngInject */
  function UsageController($stateParams, $log, $scope, $timeout, equipment, Equipment) {
    var vm = this;
    var id = $stateParams.equipmentId;

    vm.name = equipment.subType;

    var customTooltips = function(tooltip) {
      // Tooltip Element
      var tooltipEl = document.getElementById('chartjs-tooltip');
      if (!tooltipEl) {
        var div = document.createElement('div');
        div.id = 'chartjs-tooltip';
        document.body.appendChild(div);
        tooltipEl = document.getElementById('chartjs-tooltip');
      }
      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        this._chart.canvas.style.cursor = 'default';
        return;
      }
      this._chart.canvas.style.cursor = 'pointer';
      // Set caret Position
      tooltipEl.classList.remove('left', 'right', 'center');
      tooltipEl.classList.add(tooltip.yAlign);
      tooltipEl.classList.add(tooltip.xAlign);

      function joinBody(bodyItem) {
        return [].concat(bodyItem.before, bodyItem.lines.toString().replace(/(^\s*:)/g, ''), bodyItem.after).join('\n');
      }
      // Set Text
      if (tooltip.body) {
        tooltipEl.innerHTML =
        '<p class="value">' + (tooltip.body || []).map(joinBody).join('\n') + ' ' + vm.unit + '</p>' +
        '<p class="title">' + (tooltip.title || []).join('\n') + '</p>';
      }
      // Find Y Location on page
      var top = 0;
      if (tooltip.yAlign) {
        if (tooltip.yAlign == 'above') {
          top = tooltip.y - tooltip.caretSize - tooltip.caretPadding;
        } else {
          top = tooltip.y + tooltip.caretSize + tooltip.caretPadding - 55;
        }
      }
      var position = this._chart.canvas.getBoundingClientRect();
      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1;
      tooltipEl.style.left = position.left + tooltip.x + 'px';
      tooltipEl.style.top = position.top + top + 'px';
      tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
    };

    $scope.options = {
      tooltips: {
        enabled: false,
        custom: customTooltips
      }
    };

    $scope.override = [{pointBorderColor: '#6D7F8D', pointBackgroundColor: '#D3DCE4', borderColor: '#6D7F8D'}];
    $scope.onClick = function (points, evt) {
      $log.debug(points, evt);
    };

    Equipment.getUsageReport(id)
    .then(function(response){
      vm.usage = response;

      vm.chooseType('water');
    }, function() {
      vm.noUsageReport = true;
    });

    vm.chooseType = function(type) {
      vm.activeType = type;
      var object = vm.usage[type + 'Usage'];

      vm.unit = object.unit;
      vm.report = object.report;

      var hours = _.toPairs(object.hours);
      var days = _.toPairs(object.days);
      var months = _.toPairs(object.months);

      vm.hoursSorted = hours.sort(function(a,b){
        return moment(a[0]).diff(moment(b[0]));
      });
      vm.daysSorted = days.sort(function(a,b){
        return moment(a[0]).diff(moment(b[0]));
      });
      vm.monthsSorted = months.sort(function(a,b){
        return moment(a[0]).diff(moment(b[0]));
      });

      vm.selectTimeframe('1M');
    };

    vm.selectTimeframe = function(timeframe) {
      switch(timeframe) {
        case '1D':
          angular.element('.selection').css('left', '0%');
          $scope.labels = vm.hoursSorted.map(function(value) {return moment(value[0]).format('hA'); });
          $scope.data = [vm.hoursSorted.map(function(value) {return value[1]; })];
          break;
        case '1M':
          angular.element('.selection').css('left', '20%');
          $scope.labels = vm.daysSorted.map(function(value) {return moment(value[0]).format('MMM D'); });
          $scope.data = [vm.daysSorted.map(function(value) {return value[1]; })];
          break;
        case '3M':
          angular.element('.selection').css('left', '40%');
          $scope.labels = vm.monthsSorted.slice(vm.monthsSorted.length - 3, vm.monthsSorted.length).map(function(value) {return moment(value[0]).format('MMM D YY'); });
          $scope.data = [vm.monthsSorted.slice(vm.monthsSorted.length - 3, vm.monthsSorted.length).map(function(value) {return value[1]; })];
          break;
        case '6M':
          angular.element('.selection').css('left', '60%');
          $scope.labels = vm.monthsSorted.slice(vm.monthsSorted.length - 6, vm.monthsSorted.length).map(function(value) {return moment(value[0]).format('MMM D YY'); });
          $scope.data = [vm.monthsSorted.slice(vm.monthsSorted.length - 6, vm.monthsSorted.length).map(function(value) {return value[1]; })];
          break;
        case '1Y':
          angular.element('.selection').css('left', '80%');
          $scope.labels = vm.monthsSorted.map(function(value) {return moment(value[0]).format('MMM D YY'); });
          $scope.data = [vm.monthsSorted.map(function(value) {return value[1]; })];
          break;
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('ScheduleController', ScheduleController)
    .controller('PanelDialogController', PanelDialogController);

  /** @ngInject */
  function ScheduleController(Restangular, $mdPanel, $stateParams, Equipment, schedule, equipment) {
    var vm = this;
    vm._mdPanel = $mdPanel;

    vm.equipment = equipment;
    vm.schedule = schedule;
    vm.days = schedule.days;
    vm.availableFanModes = schedule.availableFanModes;

    // The time and day index that has been selected by the user
    vm.today = moment().day();
    vm.activeDay = vm.today;
    vm.selectedDay = vm.activeDay;

    vm.currentTime = getCurrentTime();
    vm.activeTime = vm.currentTime;

    function getCurrentTime() {
      var nowMoment = moment();
      var objMoment, nextMoment;
      return _.findIndex(vm.days[vm.activeDay].times, function(object, index) {
        objMoment = (index === 0)?moment({ hour:0, minute:0 }):moment({ hour:object.hour, minute:object.minute });
        nextMoment = (index < vm.days[vm.activeDay].times.length -1)?moment({ hour: vm.days[vm.activeDay].times[index+1].hour, minute: vm.days[vm.activeDay].times[index+1].minute}):moment({ hour:24, minute:0 });
        if (nowMoment.isBetween(objMoment, nextMoment)) {
          return true;
        }
      });
    }

    vm.selectedTime = function(index) {
      return vm.activeDay === vm.selectedDay && index === vm.activeTime;
    }

    vm.currentTimeIndicator = function(index) {
      return vm.activeDay === vm.today && index === vm.currentTime;
    }

    vm.decreasePoint = function(changePoint, time, dayIndex) {
      Equipment.decreasePoint.call(time, changePoint, equipment.minHeatSetPoint, vm.equipment.deadband);
      vm.schedule.customPUT({'days': [{'name': vm.days[dayIndex].name, 'times': [time]}]});
    };

    vm.increasePoint = function(changePoint, time, dayIndex) {
      Equipment.increasePoint.call(time, changePoint, equipment.maxHeatSetPoint, vm.equipment.deadband);
      vm.schedule.customPUT({'days': [{'name': vm.days[dayIndex].name, 'times': [time]}]});
    };

    vm.decreaseFanMode = function(time, dayIndex) {
      var currentIndex = vm.availableFanModes.indexOf(time.fanMode);
      if (currentIndex > 0) {
        time.fanMode = vm.availableFanModes[currentIndex - 1];
      }
      vm.schedule.customPUT({'days': [{'name': vm.days[dayIndex].name, 'times': [time]}]});
    };

    vm.increaseFanMode = function(time, dayIndex) {
      var length = vm.availableFanModes.length;
      var currentIndex = vm.availableFanModes.indexOf(time.fanMode);
      if (currentIndex < length -1) {
        time.fanMode = vm.availableFanModes[currentIndex + 1];
      }
      vm.schedule.customPUT({'days': [{'name': vm.days[dayIndex].name, 'times': [time]}]});
    };

    vm.decreaseTime = function(dayIndex, timeIndex) {
      var time = vm.days[dayIndex].times[timeIndex];
      var prev = vm.days[dayIndex].times[timeIndex - 1];
      var selectedMoment = moment({ hour:time.hour, minute:time.minute });
      var newTime = selectedMoment.subtract(15, 'm');
      var prevMoment = prev?moment({ hour:prev.hour, minute:prev.minute }):moment({ hour:0, minute:0 });

      if (!newTime.isSameOrBefore(prevMoment)) {
        time.hour = newTime.hour();
        time.minute = newTime.minute();
      }
      vm.schedule.customPUT({'days': [{'name': vm.days[dayIndex].name, 'times': [time]}]});
    };
// { 'days' : [{'name' : 'Monday', 'times' : [{'name' : 'Morning', 'heatSetPoint' : 67.0}]}] }
    vm.increaseTime = function(dayIndex, timeIndex) {
      var time = vm.days[dayIndex].times[timeIndex];
      var next = vm.days[dayIndex].times[timeIndex + 1];
      var selectedMoment = moment({ hour:time.hour, minute:time.minute });
      var newTime = selectedMoment.add(15, 'm');
      var nextMoment = next?moment({ hour:next.hour, minute:next.minute }):moment({ hour:24, minute:0 });

      if (!newTime.isSameOrAfter(nextMoment)) {
        time.hour = newTime.hour();
        time.minute = newTime.minute();
      }
      vm.schedule.customPUT({'days': [{'name': vm.days[dayIndex].name, 'times': [time]}]});
    };

    vm.copy = function(from, to) {
      var dayArray = [];

      _.forEach(to, function(value) {
        var temp = angular.copy(from);
        temp.name = value;
        dayArray.push(temp);
      });
      vm.schedule.customPUT({'days': dayArray})
      .then(function() {
        _.forEach(dayArray, function(value) {
          upsert(vm.days, ['name', value.name], value);
        });
      });
    };

    var upsert = function (arr, key, newval) {
      var match = _.find(arr, key);
      if(match){
        var index = _.indexOf(arr, _.find(arr, key));
        arr.splice(index, 1, newval);
      } else {
        arr.push(newval);
      }
    };

    vm.showDialog = function() {
      var position = vm._mdPanel.newPanelPosition()
          .absolute()
          .center();
      var config = {
        attachTo: angular.element(document.body),
        controller: PanelDialogController,
        controllerAs: 'vm',
        disableParentScroll: true,
        templateUrl: './app/equipment/schedule.copy.html',
        hasBackdrop: true,
        panelClass: 'demo-dialog-example',
        position: position,
        trapFocus: true,
        zIndex: 150,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: true,
        locals: {
          activeDay: vm.activeDay,
          days: vm.days,
          onClose: vm.copy
        }
      };
      vm._mdPanel.open(config);
    };
  }


  function PanelDialogController(mdPanelRef) {
    var vm = this;
    vm._mdPanelRef = mdPanelRef;

    vm.selected = [];
    vm.toggle = function (item, list) {
      if (vm.days[vm.activeDay].name === item.name) return;
        var idx = list.indexOf(item.name);
        if (idx > -1) {
          list.splice(idx, 1);
        }
      else {
        list.push(item.name);
      }
    };

    vm.exists = function (item, list) {
      return list.indexOf(item.name) > -1;
    };

    vm.closeDialog = function() {
      vm._mdPanelRef.close();
    };

    vm.saveAndClose = function() {
      vm._mdPanelRef.close()
      .then(function() {
        vm.onClose(vm.days[vm.activeDay], vm.selected);
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('ModesController', ModesController);

  /** @ngInject */
  function ModesController(Restangular, Equipment, equipment, $state, $stateParams) {
    var vm = this;
    var id = $stateParams.equipmentId;

    vm.update = function() {
      vm.equipmentModes.customPUT({"mode": vm.equipment.mode})
      .then(function() {
        equipment.mode = vm.equipment.mode;
        $state.go('^');
      });
    };

    Equipment.show(id)
    .then(function(equipment) {
      vm.equipment = equipment;
    });

    Equipment.getModes(id)
    .then(function(data) {
      vm.equipmentModes = data;
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('HvacController', HvacController);

  /** @ngInject */
  function HvacController($stateParams, equipment, Equipment) {
    var vm = this;
    var id = $stateParams.equipmentId;

    vm.selected = '';
    vm.select = function(category, setting) {
      var selectedSetting = category + ' ' + setting;
      if (vm.selected === selectedSetting) {
        vm.selected = '';
      } else {
        vm.selected = selectedSetting;
      }
    };

    Equipment.getSettings(id)
    .then(function(settings) {
      vm.settings = settings;

      vm.update = function(key, value) {
        vm.settings.customPUT({"name": key, "value": value})
        .then(function() {
          if (key === 'followSchedules') {
            equipment.isFollowingSchedule = value;
          }
        });
      };
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('EquipmentController', EquipmentController);

  /** @ngInject */
  function EquipmentController($stateParams, $interval, $scope, Equipment, equipment, Location, Dialogs) {
    var vm = this;
    vm.id = $stateParams.equipmentId;

    vm.equipment = equipment;

    var location = Location.get();
    var locationEquipmentInitial = _.find(location.location.equipment, {'id': Number(vm.id)});
    var locationEquipmentUpdate;

    var checkForUpdates = $interval(function() {
      if (locationEquipmentUpdate) locationEquipmentInitial = locationEquipmentUpdate;
      locationEquipmentUpdate = _(location.location.equipment).find({'id': Number(vm.id)});
      if (!_.isMatch(_.omit(locationEquipmentInitial, ['$$hashKey', 'connectedSystem']), _.omit(locationEquipmentUpdate, ['$$hashKey', 'connectedSystem']))) {
        Equipment.show(vm.id)
        .then(function(response){
          vm.equipment = response;
        });
      }
    }, 5000);

    vm.filterByType = function(type, section) {
      switch(section) {
        case "Water Usage":
          return _.indexOf(["Tankless Water Heater"], type) > -1;
        case "High Temperature Mode Banner":
          return _.indexOf(["Tankless Water Heater"], type) > -1;
        case "Energy Saver Banner":
          return _.indexOf(["Heat Pump Water Heater"], type) > -1;
        case "Change Mode":
          return _.indexOf(["Tankless Water Heater","Gas Water Heater"], type) === -1;
        case "Disabled":
          return _.indexOf(["Gas Water Heater"], type) === -1;
      }
    };

    vm.enableEnergySaveMode = function() {
      Equipment.setMode(vm.equipment.id, 'Energy Saver')
      .then(function() {
        vm.equipment.mode = 'Energy Saver';
      });
    };

    vm.increaseFanMode = function() {
      vm.equipment.increaseFanSpeed();
      vm.equipment.customPUT({"fanMode": vm.equipment.fanMode});
    };

    vm.decreaseFanMode = function() {
      vm.equipment.decreaseFanSpeed();
      vm.equipment.customPUT({"fanMode": vm.equipment.fanMode});
    };

    vm.increase = function(value) {
      vm.equipment.increasePoint(value);

      var setPoint = {};
      setPoint[value] = vm.equipment[value];
      if (setPoint[value] === 120) {
        Dialogs.showDialog('Warning', 'Water Temperature over 120 degrees F (48 degrees C) can cause severe burns instantly or death from scalds.  <br/><br/>Households with children, disabled, and elderly are at the highest risk of being scalded.  <br/><br/>See instruction manual before setting temperature.  <br/><br/>Feel water before bathing or showering.', angular.element('#equipment'), {type: 'confirm', ok: 'Confirm', style: {'background-color': 'red'}})
        .then(function() {
          vm.equipment.customPUT(setPoint);
        }, function() {
          vm.equipment.decreasePoint(value);
        });
      } else if(setPoint[value] === 141) {
        Dialogs.showDialog('Warning', 'We’ve detected High Temperature mode is enabled on your water heater and that you’re attempting to increase your Water Temperature over 140 degrees F (60 degrees C).   This Water Temperature can cause severe burns instantly or death from scalds.  Time to produce serious burns can be less than 5 seconds.<br/><br/>Households with children, disabled and elderly are at the highest risk of being scalded.<br/><br/>See instruction manual before setting temperature.<br/><br/>Feel water before bathing or showering.', angular.element('#equipment'), {type: 'confirm', ok: 'Confirm', style: {'background-color': 'red'}})
        .then(function() {
          vm.equipment.customPUT(setPoint);
        }, function() {
          vm.equipment.decreasePoint(value);
        });
      } else {
        vm.equipment.customPUT(setPoint);
      }
    };

    vm.decrease = function(value) {
      vm.equipment.decreasePoint(value);

      var setPoint = {};
      setPoint[value] = vm.equipment[value];
      vm.equipment.customPUT(setPoint);
    };

    vm.toggleDisable = function() {
      vm.equipment.isEnabled = !vm.equipment.isEnabled;
      vm.equipment.customPUT({"isEnabled": vm.equipment.isEnabled});
    };

    vm.followSchedule = function() {
      Equipment.updateSetting(vm.id, {isFollowingSchedule: true})
      .then(function() {
        vm.equipment.isFollowingSchedule = true;
      });
    };

    vm.followSchedulePerSettings = function() {
      Equipment.modifySetting(vm.id, "followSchedules", true)
      .then(function() {
        vm.equipment.isFollowingSchedule = true;
      });
    };

    $scope.$on('$destroy', destroyFunction);

    function destroyFunction() {
      $interval.cancel(checkForUpdates);
    }
    // "Water Tempearture over 120 degrees F(49 degrees C) can cause severe burns instantly or death from scalds."
    // "Households with children, disabled, and elderly are at the highest risk of being scalded."
    // "See instruction manual before setting temperature."
    // "Feel water before bathing or showering."
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('DocumentsController', DocumentsController);

  /** @ngInject */
  function DocumentsController($stateParams, equipment, Equipment) {
    var vm = this;

    vm.name = equipment.subType;

    Equipment.getDocuments(equipment.modelNumber)
    .then(function(response) {
      vm.documents = response;
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .controller('AlertsController', AlertsController);

  /** @ngInject */
  function AlertsController(Restangular, $rootScope, $scope, $mdSidenav, Alerts) {
    var vm = this;
    root();

    vm.data = Alerts.get();

    vm.selectedAlert = null;
    vm.selectedIndex = 0;

    vm.select = function(id) {
      vm.selectedAlert = Alerts.getAlertById(id);
      vm.selectedIndex = 1;
      vm.header = ('Alarm Code: ' + vm.selectedAlert.code).toUpperCase();

      if (vm.selectedAlert.markedAsRead === false) {
        Alerts.markAsRead(vm.selectedAlert);
      }
    };

    vm.back = function() {
      if (vm.selectedIndex > 0) {
        vm.selectedAlert = null;
        vm.header = null;
        vm.selectedIndex = 0;
      }
    };

    vm.close = function() {
      $mdSidenav('alerts').close();
    };

    function root() {
      vm.selectedAlert = null;
      vm.selectedIndex = 0;
    }

    $scope.$on("drillIntoMenualerts", function(event, args) {
      if (args.data.name === 'root') {
        root();
      } else {
        vm.select(args.data.alertId);
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .run(runBlock);

  /** @ngInject */
  function runBlock(Restangular, $document, $transitions, ENVIRONMENT, $injector, $window, $log, $http, $q, $rootScope, Dialogs, $state, auth, authToken) {
    $rootScope._ = _;
    $rootScope.gapi = 'AIzaSyDZRW7J7aITf85QeALk8-SMS1GpSwPH_yg';

    // App Settings
    var data = {
      clientId: 'com.rheem.econet_api',
      clientKey: 'stablekernel'
    };

    // Encode app data with base64
    $rootScope.app_data_basic = btoa(data.clientId + ':' + data.clientKey);
    $rootScope.brand = 'ruud';

    var token = authToken.getToken();
    if (token) {
      $log.debug("retrieve cached token");
      Restangular.setDefaultHeaders({Authorization: "Bearer " + token});
    }

    $transitions.onStart({ to: function(state){
      return state.data && angular.isDefined(state.data.rolesAllowed) === true;
    }}, function(trans) {

      var expired = authToken.isExpired();
      $log.debug("is token expired?", expired?'Yes':'No');
      if (expired) {
        authToken.removeToken();
        Restangular.setDefaultHeaders('');
      }

      var dataObj = trans.$to().data,
          rolesAllowed = dataObj.rolesAllowed,
          redirect = dataObj.redirect;

      var currentRole = auth.isAuthenticated() ? 'auth':'guest';

      if (rolesAllowed !== 'all' && rolesAllowed.indexOf(currentRole) === -1) {
        return trans.router.stateService.target(redirect || 'login');
      }
    });

    Restangular.setErrorInterceptor(function(response) {
        $log.debug(response);

        switch(response.status) {
          case 401:
            if (!$state.includes('login')) auth.logout();
            break;
        }

        return true; // error not handled
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlServiceProvider, $locationProvider) {
    $urlServiceProvider.config.strictMode(false);
    $locationProvider.html5Mode(true).hashPrefix('');

    $stateProvider
      .state('root', {
        url: '',
        abstract: true,
        views: {
          '': {
            template: '<div ui-view class="fade", layout="column" flex><div layout="column" flex layout-align="center center"><md-progress-circular md-mode="indeterminate"></md-progress-circular></div></div>'
          },
          'navbar': {
            templateUrl: 'app/components/navbar/navbar.html',
            controller: 'NavbarController',
            controllerAs: 'vm'
          },
          'sidebar': {
            templateUrl: 'app/settings/settings.html',
            controller: 'SettingsController',
            controllerAs: 'vm'
          },
          'alerts': {
            templateUrl: 'app/alerts/alerts.html',
            controller: 'AlertsController',
            controllerAs: 'vm'
          },
          'footer': {
            template: ''
          }
        }
      })
      .state('home', {
        url: '/',
        redirectTo: 'locations'
      })
      // .state('nestRedirect', {
      //   url: '/?{state}{code}',
      //   redirectTo: function(trans) {
      //     return { state: 'locations', params: trans.params() };
      //   }
      // })
      .state('registration', {
        url: '/reg/reg.html?{id}&{bt}&{opt}',
        controller: 'RedirectController',
        controllerAs: 'vm',
        templateUrl: 'app/main/redirect.html'
      })
      .state('login', {
        parent: 'root',
        url: '/login',
        views: {
          '@': {
            templateUrl: 'app/main/login.html',
            controller: 'LoginController',
            controllerAs: 'vm'
          },
          'navbar@': {
            templateUrl: 'app/components/navbar/navbarLogin.html'
          },
          'sidebar@': {
            template: ''
          },
          'alerts@': {
            template: ''
          },
          'footer@': {
            templateUrl: 'app/main/login.footer.html'
          }
        },
        data: {
          rolesAllowed: ['guest'],
          redirect: 'locations'
        }
      })
      .state('forgot', {
        parent: 'root',
        url: '/forgotpassword',
        views: {
          '@': {
            templateUrl: 'app/main/forgotPassword.html',
            controller: 'ForgotController',
            controllerAs: 'vm'
          },
          'navbar@': {
            templateUrl: 'app/components/navbar/navbarLogin.html'
          },
          'sidebar@': {
            template: ''
          },
          'alerts@': {
            template: ''
          },
          'footer@': {
            templateUrl: 'app/main/login.footer.html'
          }
        },
        data: {
          rolesAllowed: ['guest'],
          redirect: 'locations'
        }
      })
      .state('forgot.reset', {
        url: '/forgotPassword.html?{token}&{email}',
        views: {
          '@': {
            templateUrl: 'app/main/resetPassword.html',
            controller: 'ForgotController',
            controllerAs: 'vm'
          }
        }
      })
      .state('signup', {
        parent: 'root',
        url: '/signup',
        views: {
          '@': {
            templateUrl: 'app/main/registration.html',
            controller: 'RegistrationController',
            controllerAs: 'vm'
          },
          'navbar@': {
            templateUrl: 'app/components/navbar/navbarLogin.html'
          },
          'sidebar@': {
            template: ''
          },
          'alerts@': {
            template: ''
          },
          'footer@': {
            templateUrl: 'app/main/login.footer.html'
          }
        },
        data: {
          rolesAllowed: ['guest'],
          redirect: 'locations'
        }
      })
      .state('logout', {
        url: '/logout',
        resolve: {
          logout: function(Dialogs) {
            return Dialogs.showDialog('Confirm Log Out', 'Are you sure you wish to log out?', null, {type: 'confirm', ok: 'Logout'});
          }
        },
        controller: function(auth) {
          auth.logout();
        },
        data: {
          rolesAllowed: ['auth'],
          redirect: 'login'
        }
      })
      .state('locations', {
        parent: 'root',
        url: '/locations',
        views: {
          '@': {
            templateUrl: 'app/location/location.html',
            controller: 'LocationIndexController',
            controllerAs: 'vm'
          },
          'footer@': {
            templateUrl: 'app/vacation/vacation.footer.html',
            controller: 'VacationFooterController',
            controllerAs: 'vm'
          }
        },
        params: {
          code: null,
          state: null
        },
        resolve: {
          locations: function(Location) {
            return Location.index()
            .then(function(data) {
              if (data.length) {
                return Location.show(data[0].id)
                .then(function() {
                  return Location.get();
                });
              } else {
                return data.plain();
              }
            });
          }
        },
        data: {
          rolesAllowed: ['auth'],
          redirect: 'login'
        }
      })
      .state('locations.troubleshooting', {
        url: '/troubleshooting',
        templateUrl: 'app/location/troubleshooting.html',
        controller: 'TroubleshootingController',
        controllerAs: 'vm'
      })
      .state('locations.vacation', {
        url: '/vacation',
        templateUrl: 'app/vacation/vacation.html',
        controller: 'VacationController',
        controllerAs: 'vm'
      })
      .state('equipment', {
        parent: 'locations',
        url: '/:equipmentId',
        templateUrl: 'app/equipment/equipment.html',
        controller: 'EquipmentController',
        controllerAs: 'vm',
        resolve: {
          equipment: function(Equipment, $stateParams) {
            var equipment;
            return Equipment.show($stateParams.equipmentId)
            .then(function(data) {
              equipment = data;
              if (equipment.fanMode) { return Equipment.getFanModes($stateParams.equipmentId); }
            })
            .then(function(modes) {
              equipment.fanModes = modes;
              return equipment;
            });
          }
        },
        data: {
          rolesAllowed: ['auth'],
          redirect: 'login'
        }
      })
      .state('equipment.documents', {
        url: '/documents',
        views: {
          '@locations': {
            templateUrl: 'app/equipment/documents.html',
            controller: 'DocumentsController',
            controllerAs: 'vm'
          }
        }
      })
      .state('equipment.usage', {
        url: '/usage',
        views: {
          '@locations': {
            templateUrl: 'app/equipment/usage.html',
            controller: 'UsageController',
            controllerAs: 'vm'
          }
        }
      })
      .state('equipment.modes', {
        url: '/modes',
        views: {
          '@locations': {
            templateUrl: 'app/equipment/modes.html',
            controller: 'ModesController',
            controllerAs: 'vm'
          }
        }
      })
      .state('equipment.hvacSettings', {
        url: '/settings',
        views: {
          '@locations': {
            templateUrl: 'app/equipment/hvacsettings.html',
            controller: 'HvacController',
            controllerAs: 'vm'
          }
        }
      })
      .state('equipment.schedule', {
        url: '/schedule',
        views: {
          '@locations': {
            templateUrl: 'app/equipment/schedule.html',
            controller: 'ScheduleController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          schedule: function(Equipment, $stateParams) {
            return Equipment.getSchedule($stateParams.equipmentId)
            .then(function(schedule) {
              return schedule;
            });
          }
        }
      });

    $urlServiceProvider.rules.otherwise('/');
  }

})();

(function() {
  'use strict';

  angular
    .module('econet')
    .constant('_', window._)
    .constant('ENVIRONMENT', (function() {
      var defaultEnv = 'Production';
      var environments = {
        'Staging': 'http://econet-uat-api.rheemcert.com',
        'Production': 'https://econet-api.rheemcert.com'
      };
      var environment = window.localStorage.getItem('serverEnvironment');

      return {
        ARRAY: _.keys(environments),
        NAME: environment || defaultEnv,
        LINK: environments[environment || defaultEnv]
      };
    })());
})();

(function() {
  'use strict';

  angular
    .module('econet')
    .config(config)
    .config(['uiMask.ConfigProvider', function(uiMaskConfigProvider) {
      uiMaskConfigProvider.maskDefinitions({'H': /[A-Fa-f0-9]/});
      uiMaskConfigProvider.addDefaultPlaceholder(false);
    }]);

  /** @ngInject */
  function config($logProvider, ENVIRONMENT, $mdThemingProvider, $sceDelegateProvider, RestangularProvider, ChartJsProvider) {
    // Enable log
    $logProvider.debugEnabled(false);
    $sceDelegateProvider.resourceUrlWhitelist([
      'self',
      'http://home.nest.com/login/**'
    ]);

    // Configure all charts
    ChartJsProvider.setOptions({
      responsive: true,
      scales : {
        yAxes: [{
          gridLines: {
            drawBorder: false,
            lineWidth: 3,
            zeroLineWidth: 3,
            color: "#F6F9FB",
            tickMarkLength: 10,
            zeroLineColor: "#F6F9FB"
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 2,
            padding: 0,
            fontSize: 16,
            fontStyle: 'bold',
            min: 0,
            fontColor: '#6D7F8D'
          }
        }],
        xAxes: [{
          gridLines :{
            display : false,
            tickMarkLength: 30
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 4,
            fontSize: 15,
            maxRotation: 0,
            fontColor: '#6D7F8D'
          }
        }]
      }
    });

    // Configure all line charts
    ChartJsProvider.setOptions('elements',{
        line: {
          tension: 0,
          fill: false,
          borderWidth: 1
        },
        point: {
          borderWidth: 1,
          radius: 3
        }
    });

    RestangularProvider.setBaseUrl(ENVIRONMENT.LINK);

    $mdThemingProvider.theme('default')
      .primaryPalette('blue-grey')
      .accentPalette('blue-grey');
  }

})();

angular.module("econet").run(["$templateCache", function($templateCache) {$templateCache.put("app/alerts/alerts.html","<div id=alerts layout=row><md-sidenav md-component-id=alerts class=\"md-sidenav-right md-whiteframe-z2\"><md-toolbar layout=row layout-align=space-between><div layout=row class=md-toolbar-tools><div layout=column layout-align=\"center start\" flex=15 class=column><md-button ng-if=\"vm.selectedIndex === 0\" ng-click=vm.close()>Done</md-button><md-button ng-if=\"vm.selectedIndex &gt; 0\" ng-click=vm.back()>Back</md-button></div><div layout=column layout-align=\"center center\" flex class=column><span class=banner-bold>{{vm.header || \'Alerts\'}}</span></div></div></md-toolbar><md-tabs md-selected=vm.selectedIndex layout-fill flex><md-tab label=list><md-content layout-fill><md-list><md-list-item ng-show=!vm.data.alerts.length class=no-alert><p>There are currently no alerts.</p></md-list-item><md-list-item ng-repeat=\"alert in vm.data.alerts | orderBy:&quot;-timestamp&quot;\" ng-class=\"{unread: !alert.markedAsRead}\" ng-click=vm.select(alert.id) class=alert><md-avatar layout=column layout-align=\"center center\" flex=15><icon ng-show=\"alert.level === &quot;Critical&quot;\" name=icon-caution class=critical></icon><img ng-show=\"alert.level === &quot;Alert&quot;\" src=./assets/images/gfx_medium_alert_color.png class=alert><div class=unread-text>{{alert.markedAsRead?\'\':\'Unread\'}}</div></md-avatar><md-list-item-text flex><p class=\"md-subhead bold\">{{alert.equipment.name}}</p><p class=md-body-1>{{alert.originalCode}}</p><p class=md-body-1>{{alert.timestamp | date:\'MMM dd, yyyy h:mma\'}}</p></md-list-item-text><md-divider></md-divider></md-list-item></md-list></md-content></md-tab><md-tab label=alert><md-list><md-list-item><md-list-item-text class=md-padding><p ng-bind-html=vm.selectedAlert.description></p><md-button ng-click=\"\" class=\"md-raised md-primary large email-button\">Email a Contractor</md-button></md-list-item-text></md-list-item></md-list></md-tab></md-tabs></md-sidenav></div>");
$templateCache.put("app/equipment/documents.html","<equipment-toolbar title=\"Safety &amp; Care Manuals\"></equipment-toolbar><md-content id=safetyandcare><div layout=row class=row><img layout-align=\"start center\" ng-src={{vm.documents[0].ProductImageUrl}} class=product-image><p layout layout-align=\"left center\" flex>{{vm.name}}</p></div><md-divider></md-divider><md-list><md-list-item ng-repeat=\"document in vm.documents\" target=_blank ng-href={{document.DocumentUrl}}><md-avatar><icon name=icon-file-text></icon></md-avatar><p>{{document.Title}}</p><md-divider></md-divider></md-list-item></md-list><md-divider></md-divider></md-content>");
$templateCache.put("app/equipment/equipment.html","<div id=equipment flex layout=column><equipment-toolbar title={{vm.equipment.name}} button-text=Done></equipment-toolbar><div ng-switch=vm.equipment.type flex layout=column><div ng-switch-when=HVAC flex layout=column class=hvac><div layout=column flex layout-align=\"center center\" class=viewport><div ng-if=\"vm.equipment.mode === &quot;Auto&quot;\" layout=row layout-align=center class=auto><selector prev=vm.decrease(&quot;heatSetPoint&quot;) next=vm.increase(&quot;heatSetPoint&quot;)><h4>Heating</h4><div class=\"equipment-value heat\">{{vm.equipment.heatSetPoint | temperature}}</div></selector><selector prev=vm.decrease(&quot;coolSetPoint&quot;) next=vm.increase(&quot;coolSetPoint&quot;)><h4>Cooling</h4><div class=\"equipment-value cool\">{{vm.equipment.coolSetPoint | temperature}}</div></selector></div><div ng-if=\"vm.equipment.mode === &quot;Heating&quot;\" class=heat><selector prev=vm.decrease(&quot;heatSetPoint&quot;) next=vm.increase(&quot;heatSetPoint&quot;)><h4>Heating</h4><div class=\"equipment-value heat\">{{vm.equipment.heatSetPoint | temperature}}</div></selector></div><div ng-if=\"vm.equipment.mode === &quot;Cooling&quot;\" class=cooling><selector prev=vm.decrease(&quot;coolSetPoint&quot;) next=vm.increase(&quot;coolSetPoint&quot;)><h4>Cooling</h4><div class=\"equipment-value cool\">{{vm.equipment.coolSetPoint | temperature}}</div></selector></div><div ng-if=\"vm.equipment.mode === &quot;Emergency Heat&quot;\" class=emergency><selector prev=vm.decrease(&quot;heatSetPoint&quot;) next=vm.increase(&quot;heatSetPoint&quot;)><h4>Emergency Heat</h4><div class=\"equipment-value heat\">{{vm.equipment.heatSetPoint | temperature}}</div></selector></div><div ng-if=\"vm.equipment.mode === &quot;Fan Only&quot;\" class=fanonly><selector prev=vm.decreaseFanMode() next=vm.increaseFanMode()><h4>Fan Only</h4><div class=equipment-value>{{vm.equipment.fanMode}}</div></selector></div><div ng-if=\"vm.equipment.mode === &quot;Off&quot;\" layout layout-align=\"center center\" class=off><div class=equipment-value>OFF</div></div><div layout=row layout-align=\"center center\" layout-padding class=hvac-details-row><div layout=row layout-align=\"center center\" class=row><icon name=icon-droplet></icon><h4>{{vm.equipment.indoorHumidityPercentage | number:0}}%</h4></div><div layout=row layout-align=\"center center\" class=row><icon name=icon-fan></icon><span>&nbsp</span><h4>{{vm.equipment.mode === \'Fan Only\'?vm.equipment.fanMode:vm.equipment.fanSpeed}}</h4></div><h4>Inside: {{vm.equipment.indoorTemperature | temperature}}</h4><h4>Outside: {{vm.equipment.outdoorTemperature | temperature}}</h4></div></div><md-list layout=column layout-align=\"end stretch\" class=options><div layout layout-align=\"center center\" class=equipment-name>{{vm.equipment.name}}</div><md-divider class=top></md-divider><md-list-item layout=row ui-sref=equipment.modes><md-avatar><icon name=Air></icon></md-avatar><p>Change Mode</p><div layout=column class=column><icon layout-align=\"end center\" name={{vm.equipment.mode}}></icon></div><md-divider></md-divider></md-list-item><md-list-item layout=row ui-sref=equipment.schedule ng-if=vm.equipment.isFollowingSchedule><md-avatar><icon name=\"Following Schedule\"></icon></md-avatar><p>Following Schedule</p><md-divider></md-divider></md-list-item><md-list-item layout=row ui-sref=equipment.schedule ng-if=\"!vm.equipment.isFollowingSchedule &amp;&amp; vm.equipment.scheduleOverrideUntilDate\"><md-avatar><icon name=\"Schedule Overridden\"></icon></md-avatar><p>Schedule overridden until {{vm.equipment.scheduleOverrideUntilDate | date:\'h:mm a\'}}</p><md-button ng-click=vm.followSchedule() class=\"md-raised md-primary\">Follow</md-button><md-divider></md-divider></md-list-item><md-list-item layout=row ui-sref=equipment.schedule ng-if=\"!vm.equipment.isFollowingSchedule &amp;&amp; !vm.equipment.scheduleOverrideUntilDate\"><md-avatar><icon name=\"Not Following Schedule\"></icon></md-avatar><p>Not Following Schedule</p><md-button ng-click=vm.followSchedulePerSettings() class=\"md-raised md-primary\">Follow</md-button><md-divider></md-divider></md-list-item><md-list-item ng-if=equipment.modelNumber layout=row ui-sref=equipment.documents><md-avatar><icon name=icon-file-text></icon></md-avatar><p>Safety & Care Manuals</p><span class=list-right-text>View</span><md-divider></md-divider></md-list-item><md-list-item layout=row ui-sref=equipment.hvacSettings><md-avatar><icon name=Settings></icon></md-avatar><p>HVAC Options</p></md-list-item></md-list></div><div ng-switch-when=\"Water Heater\" flex layout=column class=water><div ng-if=\"vm.filterByType(vm.equipment.subType, &quot;Energy Saver Banner&quot;) &amp;&amp; vm.equipment.isEnabled &amp;&amp; vm.equipment.mode === &quot;High Demand&quot; || vm.equipment.mode === &quot;Electric&quot;\" layout=row class=energySaverBanner><div layout=column layout-align=\"center center\" flex=noshrink class=column><icon name=icon-Leaf class=\"mode-icon circle\"></icon></div><div layout=column flex=85 class=column><p>This equipment should be set to Energy Saver Mode for maximum efficiency.</p></div><div layout=column layout-align=center flex=noshrink class=column><md-button ng-click=vm.enableEnergySaveMode()>ENABLE</md-button></div></div><div ng-if=\"vm.filterByType(vm.equipment.subType, &quot;High Temperature Mode Banner&quot;) &amp;&amp; vm.equipment.isEnabled &amp;&amp; vm.equipment.isHighTemperatureEnabled\" layout=row class=highTemperatureBanner><div layout=column layout-align=\"center center\" flex class=column><p>High Temperature Mode is Enabled</p></div></div><div layout=column flex layout-align=\"center center\" class=viewport><p class=\"md-caption uppercase\">Water Temperature Set Point</p><selector disabled horizontal ng-if=!vm.equipment.isEnabled><div class=equipment-value>OFF</div></selector><selector prev=vm.decrease(&quot;setPoint&quot;) next=vm.increase(&quot;setPoint&quot;) horizontal ng-if=vm.equipment.isEnabled><div class=equipment-value>{{vm.equipment.setPoint | temperature}}</div></selector><div layout=column layout-align=\"center center\" ng-if=\"vm.equipment.setPoint &gt;= 120\" class=caution><div class=\"banner-bold heat md-body-1\">Caution. Hot Water</div><div class=\"banner-regular heat md-body-1\">Contact may cause serious burns to skin.</div></div></div><bubbles></bubbles><md-list layout=column layout-align=end class=options><div layout layout-align=center class=equipment-name>{{vm.equipment.name}}</div><div ng-if=vm.equipment.inUse layout layout-align=center class=running>&bull; Running</div><md-divider class=top></md-divider><md-list-item ng-if=\"vm.filterByType(vm.equipment.subType, &quot;Change Mode&quot;)\" layout ui-sref=equipment.modes ng-disabled=!vm.equipment.isEnabled><md-avatar><icon name=Water></icon></md-avatar><p>{{vm.equipment.mode}}</p><icon name={{vm.equipment.mode}}></icon><md-divider></md-divider></md-list-item><md-list-item ng-if=\"vm.filterByType(vm.equipment.subType, &quot;Water Usage&quot;)\" layout=row ui-sref=equipment.usage><md-avatar><icon name=Reports></icon></md-avatar><p>Usage Reports</p><span class=list-right-text>View</span><md-divider></md-divider></md-list-item><md-list-item ng-if=vm.equipment.modelNumber layout=row ui-sref=equipment.documents><md-avatar><icon name=icon-file-text></icon></md-avatar><p>Safety & Care Manuals</p><span class=list-right-text>View</span><md-divider></md-divider></md-list-item><md-list-item ng-if=\"vm.filterByType(vm.equipment.subType, &quot;Disabled&quot;)\" layout ng-click=vm.toggleDisable()><md-avatar><icon name=Disabled></icon></md-avatar><p>Disabled</p><div ng-class=\"{on: !vm.equipment.isEnabled}\" class=sprite><img src=./assets/images/btn-toggle-on-off.png></div></md-list-item><md-list-item ng-if=\"vm.equipment.subType === &quot;Gas Water Heater&quot;\" class=gasValveMessage><div layout=column flex layout-align=\"center center\" class=column><p class=uppercase>Gas Valve Position Warning</p><p>The temperature control located on the water heater is set to a maximum temperature of {{vm.equipment.maxSetPoint | temperature}}</p></div></md-list-item></md-list></div></div></div>");
$templateCache.put("app/equipment/hvacsettings.html","<equipment-toolbar title=\"HVAC Settings\"></equipment-toolbar><md-content id=hvacsettings><md-list ng-repeat=\"category in vm.settings\" ng-init=\"categoryIndex = $index\"><md-subheader class=md-no-sticky>{{category.category}}</md-subheader><md-list layout=column ng-repeat=\"setting in category.settings\" ng-switch=setting.type ng-init=\"settingIndex = $index\" class=items><div layout=row layout-align=\"space-between center\" ng-click=\"vm.select(categoryIndex, settingIndex)\" class=item><span flex=80>{{setting.title}}</span><span layout layout-align=end flex=20 ng-if=\"setting.type === &quot;bool&quot;\" class=option-value>{{setting.value === true?\"Yes\":\"No\"}}{{setting.unit}}</span><span layout layout-align=end flex=20 ng-if=\"setting.type !== &quot;bool&quot;\" class=option-value>{{setting.value}} {{setting.unit}}</span></div><div ng-show=\"vm.selected === categoryIndex + &quot; &quot; + settingIndex\" layout=column class=itemExpanded><p>{{setting.description}}</p><div ng-switch-when=bool layout=row layout-align=\"space-between center\" layout-margin class=bool><p class=option-value>{{setting.value === true?\"Yes\":\"No\"}}{{setting.unit}}</p><md-switch ng-model=setting.value aria-label={{setting.name}} ng-change=\"vm.update(setting.name, setting.value)\"></md-switch></div><div ng-switch-when=value class=value><md-slider-container layout=row layout-align=\"space-between center\"><p class=option-value>{{setting.value}} {{setting.unit}}</p><md-slider flex=80 aria-label={{setting.name}} min={{setting.lowerLimit}} max={{setting.upperLimit}} step={{setting.increment}} ng-model=setting.value ng-change=\"vm.update(setting.name, setting.value)\"></md-slider></md-slider-container></div><div ng-switch-when=list layout-margin class=list><md-input-container><md-select ng-model=setting.value aria-label={{setting.name}} ng-change=\"vm.update(setting.name, setting.value)\"><md-option ng-repeat=\"value in setting.availableValues\" value={{value}} class=option-value>{{value}}</md-option></md-select></md-input-container></div></div><md-divider ng-if=!$last></md-divider></md-list></md-list></md-content>");
$templateCache.put("app/equipment/modes.html","<equipment-toolbar title=\"Change Mode\"></equipment-toolbar><md-content id=modes layout=column flex><md-radio-group ng-model=vm.equipment.mode ng-change=vm.update()><md-list ng-repeat=\"mode in vm.equipmentModes\"><md-list-item><md-avatar><icon name={{mode.name}}></icon></md-avatar><md-list-item-text><p>{{mode.name}}</p></md-list-item-text><md-radio-button layout-fill value={{mode.name}} aria-label={{mode.name}} class=md-secondary></md-radio-button></md-list-item><md-list-item class=mode-description><div class=mode-description>{{mode.description}}</div></md-list-item></md-list></md-radio-group></md-content>");
$templateCache.put("app/equipment/schedule.copy.html","<div role=dialog aria-label=\"Copy Day\" layout=column layout-align=\"center center\" class=schedule-copy><md-toolbar><div class=md-toolbar-tools><h2>Copy Schedule Day(s)</h2></div></md-toolbar><div class=demo-dialog-content><p>Copy {{vm.days[vm.activeDay].name}}\'s schedule to the following</p><div layout=column><md-list><md-list-item ng-repeat=\"day in vm.days\" ng-disabled=\"vm.days[vm.activeDay].name === day.name\"><p>{{day.name}}<span ng-if=\"vm.days[vm.activeDay].name === day.name\"> (You are copying this day)</span></p><md-checkbox ng-disabled=\"vm.days[vm.activeDay].name === day.name\" ng-checked=\"vm.exists(day, vm.selected)\" ng-click=\"vm.toggle(day, vm.selected)\"></md-checkbox><md-divider ng-hide=$last></md-divider></md-list-item></md-list></div></div><div layout=row layout-align=space-around layout-fill class=demo-dialog-button><md-button ng-click=vm.closeDialog() class=md-primary>Cancel</md-button><md-button md-autofocus=\"\" ng-click=vm.saveAndClose() class=md-primary>Save</md-button></div></div>");
$templateCache.put("app/equipment/schedule.html","<equipment-toolbar title=Schedule></equipment-toolbar><md-tabs id=hvac-schedule flex md-selected=vm.activeDay md-stretch-tabs=always><md-tab ng-repeat=\"day in vm.days\" label={{day.name[0]}}><div id=schedule layout=column><div layout=row layout-align=space-between class=row><md-subheader class=md-no-sticky>{{day.name}}</md-subheader><md-button ng-click=vm.showDialog($event)>Copy Day</md-button></div><div ng-repeat=\"time in day.times\" ng-click=\"vm.activeTime = $index; vm.selectedDay = vm.activeDay;\" class=timeslot><div ng-class=\"{\'visible\': !vm.selectedTime($index), \'indicator\': vm.currentTimeIndicator($index)}\" layout=row class=minimized><p flex=25 layout layout-align=center>{{[time.hour,time.minute] | moment:\'h:mm a\'}}</p><p flex=25 layout layout-align=center class=heat>{{time.heatSetPoint | temperature}}</p><p flex=25 layout layout-align=center class=cool>{{time.coolSetPoint | temperature}}</p><span layout=row flex=20 layout-align=\"end center\"><span layout layout-align=\"end center\"><icon name=icon-fan></icon><span>&nbsp {{time.fanMode}}</span></span></span></div><div ng-class=\"{\'visible\': vm.selectedTime($index), \'indicator\': vm.currentTimeIndicator($index)}\" layout=row layout-align=\"center center\" class=maximized><selector prev=\"vm.decreaseTime(vm.activeDay, vm.activeTime)\" next=\"vm.increaseTime(vm.activeDay, vm.activeTime)\" flex=25><h4>Time</h4><div class=equipment-value>{{[time.hour,time.minute] | moment:\'h:mm a\'}}</div></selector><selector prev=\"vm.decreasePoint(&quot;heatSetPoint&quot;, time, vm.activeDay)\" next=\"vm.increasePoint(&quot;heatSetPoint&quot;, time, vm.activeDay)\" flex=25><h4>Heat</h4><div class=\"equipment-value heat\">{{time.heatSetPoint | temperature}}</div></selector><selector prev=\"vm.decreasePoint(&quot;coolSetPoint&quot;, time, vm.activeDay)\" next=\"vm.increasePoint(&quot;coolSetPoint&quot;, time, vm.activeDay)\" flex=25><h4>Cool</h4><div class=\"equipment-value cool\">{{time.coolSetPoint | temperature}}</div></selector><selector prev=\"vm.decreaseFanMode(time, vm.activeDay)\" next=\"vm.increaseFanMode(time, vm.activeDay)\" flex=25><h4>Fan</h4><div class=equipment-value>{{time.fanMode}}</div></selector></div><md-divider></md-divider></div></div></md-tab></md-tabs>");
$templateCache.put("app/equipment/usage.html","<equipment-toolbar title=\"Usage Reports\"></equipment-toolbar><md-content id=usagereports flex ng-if=!vm.noUsageReport><div layout=row layout-align=\"center center\" class=\"row controls\"><md-button ng-click=vm.chooseType(&quot;water&quot;) ng-class=\"{active: vm.activeType === &quot;water&quot;}\" class=left>Water Usage</md-button><md-button ng-click=vm.chooseType(&quot;energy&quot;) ng-class=\"{active: vm.activeType === &quot;energy&quot;}\" class=right>Energy Usage</md-button></div><md-list layout=row class=timelineSelect><div class=selection><svg width=25 height=12 xmlns=http://www.w3.org/2000/svg><g><path stroke=#000 id=triangle d=m0.696174,20.57245l11.812341,-16.656028l11.812341,16.656028l-23.624682,0z fill-opacity=null stroke-opacity=null stroke-width=3 fill=#fff></path></g></svg></div><md-list-item flex ng-click=vm.selectTimeframe(&quot;1D&quot;)><span>1D</span></md-list-item><md-list-item flex ng-click=vm.selectTimeframe(&quot;1M&quot;)><span>1M</span></md-list-item><md-list-item flex ng-click=vm.selectTimeframe(&quot;3M&quot;)><span>3M</span></md-list-item><md-list-item flex ng-click=vm.selectTimeframe(&quot;6M&quot;)><span>6M</span></md-list-item><md-list-item flex ng-click=vm.selectTimeframe(&quot;1Y&quot;)><span>1Y</span></md-list-item></md-list><p class=unit>{{vm.unit}}</p><canvas chart-data=data chart-labels=labels chart-options=options chart-dataset-override=override chart-click=onClick class=\"chart chart-line\"></canvas><div class=energyReport><h1>{{vm.report.title}}</h1><md-tabs><md-tab ng-repeat=\"report in vm.report.reports\" label={{report.section}} md-dynamic-height=false md-border-bottom=false><div layout=row class=report-content><div layout=column layout-align=\"center center\" class=column><icon name=icon-Leaf class=\"mode-icon circle\"></icon></div><div layout=column flex class=column><p class=title>{{report.title}}</p><p ng-class=\"{green: report.status === 0, orange: report.status === 1, nodata: report.status === 2}\" class=subtitle>{{report.subtitle}}</p></div></div></md-tab></md-tabs></div></md-content>");
$templateCache.put("app/location/location.html","<div id=locations layout=column layout-align=center flex=100><div layout=column ng-hide=\"!vm.mdMedia(&quot;gt-md&quot;) || vm.state.is(&quot;locations&quot;)\" class=gutter></div><div id=equipmentIndex layout=column ng-hide=\"!vm.mdMedia(&quot;gt-md&quot;) &amp;&amp; !vm.state.is(&quot;locations&quot;)\"><div ng-if=\"vm.data.locations.length === 1\" layout=column layout-align=start flex class=container><div layout=column layout-align=\"center center\" flex=none class=header><div class=location-name>{{vm.data.locations[0].name}}</div><div class=location-info>{{vm.timers[vm.data.locations[0].id].time.format(\'h:mmA •\')}} {{vm.data.locations[0].city}}, {{vm.data.locations[0].state}}</div><div ng-if=vm.outdoorTemperature class=outside-temp>Currently {{vm.outdoorTemperature | temperature}} Outside</div></div><md-content layout=column flex=noshrink><location-equipment-card ng-repeat=\"equipment in vm.data.location.equipment | filter: vm.isValidEquipment | orderBy: \'name\'\" ng-class=\"{connected: equipment.isConnected, mobile: vm.mdMedia(\'xs\'), last: $last}\"></location-equipment-card></md-content></div><div ng-if=\"vm.data.locations.length &gt; 1\" layout=column layout-align=start flex class=container><md-tabs ng-class=\"{paginate: !vm.mdMedia(&quot;gt-md&quot;)}\" md-selected=vm.selectedIndex md-stretch-tabs={{vm.mdMedia(&quot;gt-md&quot;)?&quot;always&quot;:&quot;never&quot;}} md-no-ink-bar={{vm.mdMedia(&quot;gt-md&quot;)?&quot;false&quot;:&quot;true&quot;}} md-no-pagination={{vm.mdMedia(&quot;gt-md&quot;)?&quot;false&quot;:&quot;true&quot;}} md-border-bottom md-swipe-content ink-bar-resize><md-tab flex md-on-select=vm.show(vm.selectedIndex) label={{vm.mdMedia(&quot;gt-md&quot;)?location.name:&quot;•&quot;}} ng-repeat=\"location in vm.data.locations\"><div layout=column layout-align=\"center center\" class=header><div class=location-name>{{location.name}}</div><div class=location-info>{{vm.timers[location.id].time.format(\'h:mmA •\')}} {{location.city}}, {{location.state}}</div><div ng-if=vm.outdoorTemperature class=outside-temp>Currently {{vm.outdoorTemperature | temperature}} Outside</div></div><md-content><location-equipment-card ng-repeat=\"equipment in vm.data.location.equipment | filter: vm.isValidEquipment\" ng-class=\"{connected: equipment.isConnected, mobile: vm.mdMedia(\'xs\'), last: $last}\"></location-equipment-card></md-content></md-tab></md-tabs></div></div><div layout=column ng-hide=\"!vm.mdMedia(&quot;gt-md&quot;) || vm.state.is(&quot;locations&quot;)\" class=gutter></div><div id=equipmentDetail layout=row ng-hide=vm.state.is(&quot;locations&quot;) ng-class=\"{doublescreen: vm.mdMedia(&quot;gt-md&quot;)}\"><div ui-view flex layout=column md-whiteframe=6 class=main-content></div></div><div layout=column ng-hide=\"!vm.mdMedia(&quot;gt-md&quot;) || vm.state.is(&quot;locations&quot;)\" class=gutter></div></div>");
$templateCache.put("app/location/locationEquipmentCard.html","<div ng-if=\"equipment.type === &quot;HVAC&quot;\" ng-class=\"{&quot;md-whiteframe-14dp&quot;: vm.state.includes(&quot;equipment&quot;, {equipmentId: equipment.id})}\" layout=column class=locationEquipment><div layout=row ng-click=\"vm.go(equipment, location || vm.data.locations[0])\" class=row><div flex=15 layout=column layout-align=\"center center\" class=column><img src=./assets/images/btn_hvac@3xruud.png></div><div flex layout=column layout-align=\"center start\" class=column><div class=equipment-nickname>{{equipment.name}}</div><div ng-show=equipment.isConnected layout=row layout-align=\"center center\" class=row><icon name=icon-droplet class=droplet></icon><div class=equipment-subhead>{{equipment.indoorHumidityPercentage | number: 0}}%</div><icon name=icon-fan class=fan></icon><div class=equipment-subhead>{{equipment.mode === \'Fan Only\'?equipment.fanMode:equipment.fanSpeed}}</div></div></div><div ng-show=equipment.isConnected flex=25 layout=column layout-align=\"center center\" class=column><div ng-if=\"equipment.mode === &quot;Auto&quot;\" layout=column layout-align=\"center center\" class=column><div layout=row layout-align=\"center center\" class=mode><icon name={{equipment.mode}}></icon><div class=hvac-mode>Auto</div></div><div layout=row class=equipment-value><div class=heat>{{equipment.heatSetPoint | temperature}}</div><span>&nbsp</span><div class=cool>{{equipment.coolSetPoint | temperature}}</div></div></div><div ng-if=\"equipment.mode === &quot;Cooling&quot;\" layout=column layout-align=\"center center\" class=column><div layout=row layout-align=\"center center\" class=mode><icon name={{equipment.mode}}></icon><div class=hvac-mode>Cool</div></div><div class=equipment-value><div class=cool>{{equipment.heatSetPoint | temperature}}</div></div></div><div ng-if=\"equipment.mode === &quot;Heating&quot; || equipment.mode === &quot;Emergency Heat&quot;\" layout=column layout-align=\"center center\" class=column><div layout=row layout-align=\"center center\" class=mode><icon name={{equipment.mode}}></icon><div class=hvac-mode>{{equipment.mode === \"Heating\"?\"Heat\":\"Em. Heat\"}}</div></div><div class=equipment-value><div class=heat>{{equipment.heatSetPoint | temperature}}</div></div></div><div ng-if=\"equipment.mode === &quot;Fan Only&quot;\" layout=column layout-align=\"center center\" class=column><div class=equipment-value>{{equipment.fanMode}}</div></div><div ng-if=\"equipment.mode === &quot;Off&quot;\" layout=column layout-align=\"center center\" class=column><div class=equipment-value>OFF</div></div><div class=hvac-mode2>Inside {{equipment.indoorTemperature | temperature}}</div></div><div ng-hide=equipment.isConnected flex=25 layout=column layout-align=\"center center\" class=column><icon name=icon-caution class=caution></icon></div><div flex=10 layout=column layout-align=\"start start\" ng-if=equipment.isConnected class=column><icon name=icon-rightarrow class=arrow></icon><icon ng-if=equipment.isOnVacation name=\"Banner Vacation\" class=vacation-banner></icon><img ng-if=\"vm.isNestEvent(equipment, location || vm.data.locations[0])\" src=./assets/images/img_flag_nest@3x.png class=nest-banner></div></div><div ng-show=!equipment.isConnected layout=row class=\"alert error\"><div flex=10 layout=column layout-align=\"start center\" class=column><icon name=icon-caution></icon></div><div flex layout=column layout-align=\"center start\" class=column><div class=banner-bold>Connection Error</div><div class=banner-regular>Can\'t Connect to Equipment</div></div></div><div ng-click=vm.openAlert(vm.alerts.equipment[equipment.id].critical[0].id) ng-show=\"equipment.isConnected &amp;&amp; vm.alerts.equipment[equipment.id].critical.length\" layout=row class=\"alert critical\"><div flex=10 layout=column layout-align=\"start center\" class=column><icon name=icon-caution></icon></div><div flex layout=column layout-align=\"center start\" class=column><div class=banner-bold>Critical</div><div class=banner-regular>{{vm.alerts.equipment[equipment.id].critical[0].originalCode}}</div></div></div><div ng-click=vm.openAlert(vm.alerts.equipment[equipment.id].alert[0].id) ng-show=\"equipment.isConnected &amp;&amp; !equipment.hasCriticalAlert &amp;&amp; vm.alerts.equipment[equipment.id].alert.length\" layout=row class=alert><div flex=10 layout=column layout-align=\"start center\" class=column><icon name=icon-caution></icon></div><div flex layout=column layout-align=\"center start\" class=column><div class=banner-bold>Alert</div><div class=banner-regular>{{vm.alerts.equipment[equipment.id].alert[0].originalCode}}</div></div><div ng-click=vm.closeAlert(vm.alerts.equipment[equipment.id].alert[0].id) flex=10 layout=column layout-align=\"start center\" class=\"column close\"><icon name=icon-close></icon></div></div></div><div ng-if=\"equipment.type === &quot;Water Heater&quot;\" ng-class=\"{&quot;md-whiteframe-14dp&quot;: vm.state.includes(&quot;equipment&quot;, {equipmentId: equipment.id})}\" layout=column class=locationEquipment><div layout=row ng-click=\"vm.go(equipment, location || vm.data.locations[0])\" class=row><div flex=15 layout=column layout-align=\"center center\" class=column><img src=./assets/images/btn_waterheater@3xruud.png></div><div flex layout=column layout-align=\"center start\" class=column><div class=equipment-nickname>{{equipment.name}}</div><div ng-if=equipment.mode class=equipment-subhead>{{equipment.mode}} Mode</div><div ng-if=\"equipment.isConnected &amp;&amp; equipment.numberManifolded &amp;&amp; equipment.numberManifolded &gt; 1\" class=equipment-subhead>Manifold &bull; {{equipment.numberManifolded + \" Units\"}}</div></div><div ng-show=equipment.isConnected flex=25 layout=column layout-align=\"center center\" class=column><div ng-if=equipment.isEnabled class=\"equipment-value heat\">{{equipment.setPoint | temperature}}</div><div ng-if=!equipment.isEnabled class=equipment-value>OFF</div></div><div ng-hide=equipment.isConnected flex=25 layout=column layout-align=\"center center\" class=column><icon name=icon-caution class=caution></icon></div><div flex=10 layout=column layout-align=\"start start\" ng-if=equipment.isConnected class=column><icon name=icon-rightarrow class=arrow></icon><icon ng-if=equipment.isOnVacation name=\"Banner Vacation\" class=vacation-banner></icon><img ng-if=\"vm.isNestEvent(equipment, location || vm.data.locations[0])\" src=./assets/images/img_flag_nest@3x.png class=nest-banner></div></div><div ng-show=!equipment.isConnected layout=row class=\"alert error\"><div flex=10 layout=column layout-align=\"start center\" class=column><icon name=icon-caution></icon></div><div flex layout=column layout-align=\"center start\" class=column><div class=banner-bold>Connection Error</div><div class=banner-regular>Can\'t Connect to Equipment</div></div></div><div ng-click=vm.openAlert(vm.alerts.equipment[equipment.id].critical[0].id) ng-show=\"equipment.isConnected &amp;&amp; vm.alerts.equipment[equipment.id].critical.length\" layout=row class=\"alert critical\"><div flex=10 layout=column layout-align=\"start center\" class=column><icon name=icon-caution></icon></div><div flex layout=column layout-align=\"center start\" class=column><div class=banner-bold>Critical</div><div class=banner-regular>{{vm.alerts.equipment[equipment.id].critical[0].originalCode}}</div></div></div><div ng-click=vm.openAlert(vm.alerts.equipment[equipment.id].alert[0].id) ng-show=\"equipment.isConnected &amp;&amp; !equipment.hasCriticalAlert &amp;&amp; vm.alerts.equipment[equipment.id].alert.length\" layout=row class=alert><div flex=10 layout=column layout-align=\"start center\" class=column><icon name=icon-caution></icon></div><div flex layout=column layout-align=\"center start\" class=column><div class=banner-bold>Alert</div><div class=banner-regular>{{vm.alerts.equipment[equipment.id].alert[0].originalCode}}</div></div><div ng-click=vm.closeAlert(vm.alerts.equipment[equipment.id].alert[0].id) flex=10 layout=column layout-align=\"start center\" class=\"column close\"><icon name=icon-close></icon></div></div></div>");
$templateCache.put("app/location/troubleshooting.html","<equipment-toolbar title=Troubleshooting></equipment-toolbar><div id=troubleshooting layout=column flex><md-content layout=column flex><md-tabs md-selected=vm.selectedIndex flex><md-tab label=page1><md-list layout=column class=column><p>EcoNet is unable to connect to the Wifi Module(s) attached to the following equipment</p><md-list-item ng-repeat=\"equipment in vm.offlineEquipment\" layout=row layout-align=stretch><icon name=icon-caution flex=5></icon><div flex=95 class=md-list-item-text><p class=header>{{equipment.locationName}} • {{equipment.name}}</p><p>{{equipment.name}}</p><md-divider></md-divider></div></md-list-item></md-list></md-tab><md-tab label=page2><div layout=column class=column><p>Please temporarily disconnect all cables from the WiFi Module(s) attached to the following equipment and then reconnect them.</p><p>IMPORTANT: DO NOT press the WLAN SETUP/Reset button during this process. Once you have reconnected your WiFi Modules tap \'Retry Connection\' below</p><md-list ng-repeat=\"location in vm.troubleLocations\"><md-divider></md-divider><md-list-item layout=row layout-align=\"start start\"><img src=./assets/images/icon_wifimodule@3x.png><div layout=column class=md-list-item-text><p>{{location.name}}</p><p>{{vm.offlineEquipment[0].connectedSystem.macAddress}}</p><p>Equipment:</p><ul layout=row flex layout-wrap><li ng-repeat=\"equipment in vm.offlineEquipment | filter:{isConnected: false, type: &quot;!WiFi Adapter&quot;}\" ng-bind=\"equipment.name + ($last ? \'\' : \', \')\"></li></ul></div></md-list-item><md-divider></md-divider></md-list></div></md-tab><md-tab label=page3><div layout=column ng-switch=vm.status class=column><p ng-switch-when=success>Connection Successful!</p><p ng-switch-when=searching>Establishing Connection...</p><p ng-switch-when=support>EcoNet is still unable to connect the WiFI Module(s) attached to the following equipment. Please select contact Customer Service or Cancel(above) to stop troubleshooting for now.</p><md-list><md-list-item ng-repeat=\"equipment in vm.offlineEquipment\" layout=row layout-align=stretch><icon ng-show=\"!vm.found[equipment.id] &amp;&amp; vm.status !== &quot;searching&quot;\" name=icon-caution flex=5></icon><icon ng-show=vm.found[equipment.id] name=icon-checkmark flex=5 class=green></icon><md-progress-circular ng-switch-when=searching ng-hide=vm.found[equipment.id] md-diameter=20px md-mode=indeterminate class=md-hue-1></md-progress-circular><div flex=95 class=md-list-item-text><p class=header>{{equipment.locationName}} • {{equipment.name}}</p><p>{{equipment.name}}</p><md-divider></md-divider></div></md-list-item></md-list></div></md-tab></md-tabs></md-content><md-tabs md-selected=vm.selectedIndex class=controls><md-tab label=page1><div layout=column class=column><md-button ng-click=vm.continue() class=\"md-raised md-primary large\">Continue Troubleshooting</md-button></div></md-tab><md-tab label=page2><div layout=column class=column><md-button ng-click=vm.retry() class=\"md-raised md-primary large\">Retry Connection</md-button></div></md-tab><md-tab label=page3><div layout=column class=column><md-button ng-show=\"vm.status === &quot;searching&quot;\" layout=row layout-align=\"space-around center\" class=\"md-raised md-primary large\"><span>Connecting...</span><md-progress-circular md-diameter=20px md-mode=indeterminate class=md-hue-1></md-progress-circular></md-button><md-button ng-show=\"vm.status === &quot;support&quot;\" target=_blank href=http://www.ruud.com/contact.aspx class=\"md-raised md-primary large\">Contact Customer Service</md-button></div></md-tab></md-tabs></div>");
$templateCache.put("app/main/forgotPassword.html","<md-content id=forgot-password flex layout=column layout-align=\"center center\" ui-view><div layout=column class=contents><form name=forgotPasswordForm layout=column layout-align=\"start center\" ng-submit=\"forgotPasswordForm.$valid &amp;&amp; vm.forgotPassword()\" novalidate><h1>Forgot Password</h1><p>Enter the email address you use to sign into your account.</p><md-input-container><label>Email</label><input ng-model=vm.forgotPasswordEmail name=email placeholder=example@domain.com required ng-pattern=/^.+@.+..+$/ ><div ng-messages=forgotPasswordForm.email.$error ng-show=forgotPasswordForm.$submitted role=alert><div ng-message=required>Required Field</div><div ng-message=pattern>Please enter a valid email.</div></div></md-input-container><p>We\'ll help you reset it!</p><md-button type=submit class=\"md-raised md-primary large\">Reset</md-button><md-button ng-click=vm.cancel() class=\"md-raised md-warn large\">Cancel</md-button></form></div></md-content>");
$templateCache.put("app/main/login.footer.html","<div id=loginFooter layout=row layout-align=\"center center\" rm-class-height-gt=\"{&quot;hidden&quot;: &quot;590&quot;}\"><img src=./assets/images/footer.svg class=smile><div layout=column layout-align=\"center center\" class=column><img src=./assets/images/logo_EcoNet.png ng-click=showEnvironmentSelect() class=econet></div></div>");
$templateCache.put("app/main/login.html","<md-content id=login layout=column layout-align=\"center center\" flex><div layout=row class=row><img src=./assets/images/login-message-big-ruud.png hide show-gt-sm class=login-message><div layout=column class=contents><form name=loginForm layout=column flex=noshrink layout-align=\"start center\" ng-submit=\"loginForm.$valid &amp;&amp; vm.login()\" novalidate><h1>Login</h1><md-input-container><label>Email Address</label><input ng-model=vm.user.username aria-label=Email name=email required ng-pattern=/^.+@.+..+$/ ><div ng-messages=loginForm.email.$error ng-show=loginForm.$submitted role=alert><div ng-message=required>Required Field</div><div ng-message=pattern>Please enter a valid email.</div></div></md-input-container><md-input-container><password-field><input ng-model=vm.user.password aria-label=Password name=password required autocomplete=off type=password></password-field><label>Password</label><div ng-messages=loginForm.password.$error type=password ng-show=loginForm.$submitted role=alert><div ng-message=required>Required Field</div></div><md-checkbox ng-model=vm.keepLoggedIn>Keep me logged in</md-checkbox></md-input-container><a ui-sref=forgot>Forgot Password?</a><md-button type=submit class=\"md-raised md-primary large\">Login</md-button><md-input-container ng-show=vm.showEnvironmentSelect><label>Environment</label><md-select ng-model=vm.environment md-on-close=vm.updateEnv()><md-option ng-repeat=\"env in vm.environments\" value={{env}}>{{env}}</md-option></md-select></md-input-container><p class=md-caption>Need an account?</p><a ui-sref=signup>Sign up now</a></form><md-divider></md-divider><app-store></app-store></div></div></md-content>");
$templateCache.put("app/main/redirect.html","<md-content id=redirect layout=column layout-align=\"start center\" flex><div layout=column md-whiteframe=10 layout-align=start class=information><h1>Success!</h1><p>Your EcoNet module has been connected to your router.</p><p><span class=bold>MAC Address: </span>{{vm.params.id}}</p><p ng-show=vm.showNext>Select Next to continue to the next step.</p><md-divider></md-divider><md-button ng-show=vm.showNext ng-click=vm.goNext() href=\"\" class=\"md-raised md-primary\">Next</md-button><md-list ng-hide=vm.showNext><md-list-item ng-click=vm.goNext()>Attach module to a new account</md-list-item><md-divider></md-divider><md-list-item ng-click=vm.goNext()>Attach module to an existing account</md-list-item><md-divider></md-divider><md-list-item ng-click=vm.goNext()>Login to EcoNet</md-list-item></md-list></div></md-content>");
$templateCache.put("app/main/registration.html","<md-content id=registration layout=column flex><md-progress-linear md-mode=determinate value=\"{{(vm.stepIndex + 1) / vm.totalSteps * 100}}\" class=progress></md-progress-linear><provision steps=vm.steps flex></provision></md-content>");
$templateCache.put("app/main/resetPassword.html","<md-content id=forgot-password flex layout=column layout-align=\"center center\"><div layout=column class=contents><h1>New Password</h1><form name=resetPasswordForm ng-submit=\"resetPasswordForm.$valid &amp;&amp; vm.resetPassword()\" novalidate><md-input-container class=md-block><label>Enter new password</label><password-field><input ng-model=vm.options.password type=password autocomplete=off name=password required></password-field><div ng-messages=resetPasswordForm.password.$error ng-show=resetPasswordForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><md-input-container class=md-block><label>Confirm new password</label><password-field><input ng-model=vm.confirmPassword type=password name=confirmPassword required></password-field><div ng-messages=resetPasswordForm.confirmPassword.$error ng-show=resetPasswordForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><div ng-show=\"resetPasswordForm.$submitted &amp;&amp; !vm.match\" class=validationAlert><div>Passwords do not match.</div></div><div layout=row layout-align=center class=row><md-button type=submit class=\"md-raised md-primary large\">Update Password</md-button></div></form></div></md-content>");
$templateCache.put("app/settings/_changeEmail.html","<md-content class=md-padding><form name=emailForm ng-submit=\"emailForm.$valid &amp;&amp; vm.changeEmail.update()\" novalidate><md-input-container class=md-block><label>Enter new-email address</label><input ng-model=vm.changeEmail.options.email name=email required ng-pattern=/^.+@.+..+$/ ><div ng-messages=emailForm.email.$error ng-show=emailForm.$submitted role=alert><div ng-message=required>Required Field</div><div ng-message=pattern>Please enter a valid email.</div></div></md-input-container><md-input-container class=md-block><label>Confirm new e-mail address</label><input ng-model=vm.changeEmail.emailVerify name=emailVerify required ng-pattern=/^.+@.+..+$/ ><div ng-messages=emailForm.emailVerify.$error ng-show=emailForm.$submitted role=alert><div ng-message=required>Required Field</div><div ng-message=pattern>Please enter a valid email.</div></div></md-input-container><md-input-container class=md-block><label>Enter your EcoNet account password</label><password-field><input ng-model=vm.changeEmail.options.validationPassword type=password autocomplete=off name=validationPassword required></password-field><div ng-messages=emailForm.validationPassword.$error ng-show=emailForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><div ng-show=\"emailForm.$submitted &amp;&amp; !vm.changeEmail.match\" class=validationAlert><p>Email addresses must match.</p></div><div layout=row layout-align=center class=row><md-button type=submit class=\"md-raised md-primary large\">Update Email</md-button></div></form></md-content>");
$templateCache.put("app/settings/_changePassword.html","<md-content class=md-padding><form name=passwordForm ng-submit=\"passwordForm.$valid &amp;&amp; vm.changePassword.update()\" novalidate><md-input-container class=md-block><label>Enter old password</label><password-field><input ng-model=vm.changePassword.options.validationPassword type=password autocomplete=off name=validationPassword required></password-field><div ng-messages=passwordForm.validationPassword.$error ng-show=passwordForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><md-input-container class=md-block><label>Enter new password</label><password-field><input ng-model=vm.changePassword.options.password type=password autocomplete=off name=password required></password-field><div ng-messages=passwordForm.password.$error ng-show=passwordForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><md-input-container class=md-block><label>Confirm new password</label><password-field><input ng-model=vm.changePassword.confirmPassword type=password name=confirmPassword required></password-field><div ng-messages=passwordForm.confirmPassword.$error ng-show=passwordForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><div ng-show=\"passwordForm.$submitted &amp;&amp; !vm.changePassword.match\" class=validationAlert><div>Passwords do not match.</div></div><div layout=row layout-align=center class=row><md-button type=submit class=\"md-raised md-primary large\">Update Password</md-button></div></form></md-content>");
$templateCache.put("app/settings/_contractor.html","<md-content class=md-padding><div id=addContractor><form layout=column ng-class=vm.contractorInfo.action name=addContractorForm ng-submit=\"addContractorForm.$valid &amp;&amp; vm.contractorInfo.saveContractor()\" novalidate><h3>Contact Information</h3><md-input-container><label>Contractor Name</label><input ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-model=vm.contractorInfo.options.contactName name=name required><div ng-messages=addContractorForm.name.$error ng-show=addContractorForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><md-input-container><label>Company Name</label><input ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-model=vm.contractorInfo.options.companyName name=companyName required><div ng-messages=addContractorForm.companyName.$error ng-show=addContractorForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><md-input-container ng-repeat=\"phone in vm.contractorInfo.options.phoneNumbers\"><label ng-if=\"$index === 0\">Phone Number</label><label ng-if=\"$index &gt; 0\">Alternate Phone</label><input ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-model=phone.number name=phone required><div ng-messages=addContractorForm.phone.$error ng-show=addContractorForm.$submitted role=alert><div ng-message=required>Required Field</div></div><a ng-href=tel:{{phone.number}} ng-show=\"vm.contractorInfo.action === &quot;view&quot;\"><icon name=Call class=icon-call></icon></a></md-input-container><md-button ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-click=vm.contractorInfo.addNumberField() class=\"add-phone-field md-raised\">Add Another Phone Number</md-button><md-input-container><label>Email</label><input ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-model=vm.contractorInfo.options.email name=email required ng-pattern=/^.+@.+..+$/ ><div ng-messages=addContractorForm.email.$error ng-show=addContractorForm.$submitted role=alert><div ng-message=required>Required Field</div><div ng-message=pattern>Please enter a valid email.</div></div><a ng-href=mailto:{{vm.contractorInfo.options.email}} ng-show=\"vm.contractorInfo.action === &quot;view&quot;\"><icon name=Email class=icon-email></icon></a></md-input-container><h3>System Expertise</h3><md-list><md-list-item><md-avatar><img src=./assets/images/btn_hvac_ruud.png></md-avatar><p>HVAC</p><md-checkbox ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-model=vm.contractorInfo.options.expertiseHVAC></md-checkbox><md-divider></md-divider></md-list-item><md-list-item><md-avatar><img src=./assets/images/btn_water_heater_ruud.png></md-avatar><p>Water Heater</p><md-checkbox ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-model=vm.contractorInfo.options.expertiseWaterHeater></md-checkbox><md-divider></md-divider></md-list-item><md-list-item><md-avatar><img src=./assets/images/btn_pool_ruud.png></md-avatar><p>Pool Heater</p><md-checkbox ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-model=vm.contractorInfo.options.expertisePoolAndSpa></md-checkbox></md-list-item></md-list><h3>Notes</h3><md-input-container class=textarea><label>Add Notes Here</label><textarea ng-disabled=\"vm.contractorInfo.action === &quot;view&quot;\" ng-model=vm.contractorInfo.options.notes rows=5 md-select-on-focus></textarea></md-input-container><div layout=column class=controls><md-button ng-hide=\"vm.contractorInfo.action === &quot;view&quot;\" type=submit class=\"md-raised md-primary large\">Save Contractor</md-button><md-button ng-show=\"vm.contractorInfo.action === &quot;view&quot;\" ng-click=vm.contractorInfo.editContractor() class=\"md-raised md-primary large\">Edit Contractor</md-button><md-button ng-show=\"vm.contractorInfo.action === &quot;view&quot;\" ng-click=vm.contractorInfo.removeContractor(vm.contractorInfo.contractor.id) class=\"md-raised md-warn large\">Remove Contractor</md-button></div></form></div></md-content>");
$templateCache.put("app/settings/_contractorInfo.html","<md-content id=contractorList class=md-padding><md-list layout=column><div layout=row layout-align=space-between class=row><md-subheader class=md-no-sticky>Contractors</md-subheader><md-button ng-click=vm.contractorInfo.addContractor()>Add Contractor<icon name=Add2></icon></md-button></div><md-list-item ng-repeat=\"contractor in vm.contractorInfo.contractors\" ng-click=\"vm.contractorInfo.viewContractor(contractor.id, $index)\" layout=row layout-margin class=no-margin><div layout=column flex class=column><p class=name>{{contractor.contactName}}</p><p class=company>{{contractor.companyName}}</p></div><div layout=row layout-align=end class=row><div layout=column ng-switch=contractor.expertiseHVAC class=column><img ng-switch-when=true src=./assets/images/btn_hvac_ruud.png><img ng-switch-default src=./assets/images/btn_hvac_disabled_ruud.png><p class=label>HVAC</p></div><div layout=column ng-switch=contractor.expertiseWaterHeater class=column><img ng-switch-when=true src=./assets/images/btn_water_heater_ruud.png><img ng-switch-default src=./assets/images/btn_water_heater_disabled_ruud.png><p class=label>Water Heater</p></div><div layout=column ng-switch=contractor.expertisePoolAndSpa class=column><img ng-switch-when=true src=./assets/images/btn_pool_ruud.png><img ng-switch-default src=./assets/images/btn_pool_disabled_ruud.png><p class=label>Pool/Spa</p></div></div><md-divider></md-divider></md-list-item></md-list></md-content>");
$templateCache.put("app/settings/_getStarted.html","<md-content class=md-padding><p>Set/Adjust Temperature</p><p>You can manually adjust the temperature of the water in the water heater by tapping the “-“ and “+” arrows on the homescreen, or you can select one of the pre-programmed modes described below. Safety and energy conservation are factors to be considered when selecting the water temperature setting of the water heater. The lower the temperature setting, the greater the savings in energy and operating costs. To comply with safety regulations, the temperature is factory set at 120°F or less where local codes require. This is the recommended starting point. Water temperatures above 125°F can cause severe burns or death from scalding.</p><p>Modes</p><p>Available modes for your system will be displayed below the current temperature. You can change/set your mode using the toggle button. A description of the mode will display and you’ll be prompted to confirm your selection. Available modes are detailed below.</p><p>Energy Saver</p><p>(default factory setting) The Energy Saver mode uses both compressor and electric element heat to deliver the best of both worlds – energy efficiency and faster heating times. The mode meets Energy Star requirements and is designed to maximize compressor use while minimizing electric heat element use to conserve energy while still meeting needs of your household.</p><p>Heat Pump Only</p><p>(most energy efficient mode) Designed for maximum energy savings, the Heat Pump Only mode uses a compressor to heat the water by taking heat from the surrounding air. Because no electric heating element is used, this mode takes longer to heat the water, so it may not be sufficient for high-demand situations such as a large household or grandparents and second cousins visiting for the holidays.</p><p>High Demand</p><p>The High Demand mode does just what it says – meets high demand for hot water. If your water heater is undersized for your house, or if you have a lot of guests, this mode helps you keep up, while still saving as much energy as possible. In this mode, the unit will only use electric heating elements when the demand rate is high. This will heat the water faster but will use more energy. During lower demand periods, the unit will automatically switch to the compressor to conserve energy.</p><p>Electric Only</p><p>The Electric Only mode uses just electric elements to heat water. This mode uses the most energy and should only be selected during compressor maintenance periods.</p><p>Disabled</p><p>The mode is ideal when you have no use for hot water. The water heating functionality is turned off, however errors and alerts will still be produced and reported.</p><p>Add/Delete Equipment</p><p>You can manage all equipment and locations within the settings section of the app. To edit/delete existing equipment or locations, or install new EcoNet enabled equipment, simply follow the step-by-step commands within this section. A strong WiFi connection is required.</p><p>Set Vacation</p><p>Turn on/off one or all of your systems with the touch of a button and start saving money on unnecessary energy costs while you are away from home. Manage Account Settings Want to change your EcoNet password, adjust notification preferences or change the temperature display from Fahrenheit to Celsius? You can easily manage all personal account info and preferences under Settings/Manage Account Info. Manage Contractor Info Store contact information for your HVAC, Water Heater and Pool/Spa contractors so that you have their information at your fingertips for general service calls, as well as the rare equipment emergency.</p><p>Alerts</p><p>Priority Levels</p><p>Alert Levels Red = Critical Alert/Warning – take immediate notice/action.</p><p>Orange = General Alert – May impact system performance – take action as soon as possible.</p><p>Green = General Messages/ System Notifications.</p><p>Alerts Alarm Code</p><p>A100 Lower temperature thermistor issue Electronic control has detected lower temperature sensor is bad. The problem could be the sensor, wiring, or the control board. Please call for service.</p><p>A101 Upper temperature thermistor issue</p><p>Electronic control has detected lower temperature sensor is bad. The problem could be the sensor, wiring, or the control board. Please call for service.</p><p>A103 Fill tank with water</p><p>Electronic control has detected no water in the tank. Please fill the tank with water and recycle power.</p><p>A104 Emergency cut off alarm</p><p>Electronic control has detected high temperature electrical cut-out device (ECO) has been activated. Reset ECO or call for service</p><p>A105 Lower element error</p><p>Electronic control has detected an error with the lower element or associated wiring and connections. Please call for service.</p><p>A106 Upper element error</p><p>Electronic control has detected an error with the upper element or associated wiring and connections. Please call for service.</p><p>A107 Element wire routing error</p><p>Please call for service</p><p>A108 Lower element relay stuck on error</p><p>There is an error with the control board. Please call for service</p><p>A109 Upper element relay stuck on error</p><p>There is an error with the control board. Please call for service</p><p>A110 Lower temperature conversion error</p><p>There is an error with the control board. Please call for service</p><p>A111 Upper temperature conversion error</p><p>There is an error with the control board. Please call for service</p><p>A500 Control Failure</p><p>There is an error with the control board. Please call for service</p><p>MSG1 Communication Error</p><p>Communication error with equipment. Please check wifi module.</p><p>MSG2 Software Update</p><p>There is a new software update. Please go to app store to update.</p></md-content>");
$templateCache.put("app/settings/_locationsAndEquipment.html","<md-content id=locationsAndEquipment layout-fill><div ng-repeat=\"location in vm.locationsAndEquipment.locations.locations\" layout=column class=location><div layout=row layout-align=\"space-between end\" class=row><h1>{{location.name}}</h1><md-button ng-click=vm.locationsAndEquipment.editLocation(location)>Edit Location</md-button></div><md-list><md-list-item layout=row layout-align=start ng-repeat=\"equipment in location.equipment | filter: {type: \'!WiFi Adapter\'} | orderBy: \'name\'\" ng-click=vm.locationsAndEquipment.editEquipment(equipment)><md-list-item-text layout=column flex layout-offset=5><p class=header>{{equipment.subType}}</p><p>{{::equipment.name}}</p></md-list-item-text><md-list-item-text flex=10 layout=column><icon name=icon-rightarrow class=arrow></icon><md-divider></md-divider></md-list-item-text></md-list-item><md-list-item layout=column layout-align=\"start start\"><md-button ng-click=vm.locationsAndEquipment.addEquipment(location) class=add><icon name=Add></icon>Add New Equipment</md-button></md-list-item></md-list></div><div layout=column layout-align=\"center center\" class=check-button><md-button ng-click=vm.locationsAndEquipment.equipmentCheck() class=\"md-raised md-primary large\">Check for connected equipment</md-button><md-button ng-click=vm.locationsAndEquipment.addLocation() class=\"md-raised md-primary large\">Add New Location</md-button></div></md-content>");
$templateCache.put("app/settings/_manageEquipment.html","<md-content id=manageLocation ng-if=\"vm.state === &quot;editLocation&quot;\" flex><form name=editLocationForm layout=column ng-submit=\"editLocationForm.$valid &amp;&amp; vm.locationsAndEquipment.updateLocation(vm.locationsAndEquipment.location)\" novalidate><div layout=column><div layout=row layout-align=\"space-between end\" class=row><h1>{{::vm.locationsAndEquipment.location.name}}</h1></div><md-list><md-list-item layout=row layout-align=start><md-list-item-text layout=column flex layout-offset=5><md-input-container><label>Location Name</label><input ng-model=vm.locationsAndEquipment.location.name></md-input-container><md-input-container><label>ZIP Code</label><input ng-model=vm.locationsAndEquipment.location.zipCode type=text maxlength=5 ng-minlength=5 ng-change=\"editLocationForm.zipCode.$valid &amp;&amp; vm.locationsAndEquipment.validateZipCode(vm.locationsAndEquipment.location.zipCode, vm.locationsAndEquipment.location)\" name=zipCode required><div ng-messages=editLocationForm.zipCode.$error ng-show=editLocationForm.$submitted role=alert><div ng-message=required>Required Field</div><div ng-message=minlength>Please enter a valid zipcode</div></div></md-input-container><p>{{vm.locationsAndEquipment.location.city + \', \' + vm.locationsAndEquipment.location.state}}</p></md-list-item-text></md-list-item></md-list></div><div layout=column layout-align=\"center center\" class=check-button><md-button type=submit class=\"md-raised md-primary large\">Save</md-button><md-button ng-click=vm.locationsAndEquipment.removeLocation() class=\"md-raised md-warn large\">Delete Location</md-button></div></form></md-content><md-content id=manageEquipment ng-if=\"vm.state === &quot;editEquipment&quot;\" flex><div layout=column><div layout=row layout-align=\"space-between end\" class=row><h1>{{::vm.locationsAndEquipment.equipment.name}}</h1></div><md-list><md-list-item layout=row layout-align=start><md-list-item-text layout=column flex layout-offset=5><md-input-container><label>Equipment Name</label><input ng-model=vm.locationsAndEquipment.equipment.name></md-input-container></md-list-item-text></md-list-item></md-list></div><div layout=column layout-align=\"center center\" class=check-button><md-button ng-click=vm.locationsAndEquipment.updateEquipment() class=\"md-raised md-primary large\">Save</md-button><md-button ng-click=vm.locationsAndEquipment.removeEquipment() class=\"md-raised md-warn large\">Delete Equipment</md-button></div></md-content><md-content id=addLocation ng-if=\"vm.state === &quot;addLocation&quot;\" layout=column flex><provision steps=vm.locationsAndEquipment.steps on-finish=vm.back() flex></provision></md-content><md-content id=addEquipment ng-if=\"vm.state === &quot;addEquipment&quot;\" layout=column flex><provision steps=vm.locationsAndEquipment.steps location=vm.locationsAndEquipment.location on-finish=vm.back() flex></provision></md-content>");
$templateCache.put("app/settings/_nest.html","<md-content flex id=nest class=md-padding><div layout=row layout-align=\"start end\" class=row><md-avatar><img src=./assets/images/icon_nest_badge@3x.png></md-avatar><div layout=column layout-align=\"end start\" class=column><h3>Nest</h3><p>Works with Nest Currently: {{vm.nest.nestLocations.length ? \'ACTIVE\':\'INACTIVE\'}}</p></div></div><hr><p>Connecting your EcoNet and Nest accounts can reduce energy costs by ensuring your water heater is in an energy efficient mode when:</p><ul><li>Nest notices you are <a href=https://nest.com/support/article/Learn-more-about-Home-Away-Assist>Away</a>.</li><li>Nest receives a <a href=https://nest.com/support/article/What-is-Rush-Hour-Rewards>Rush Hour request</a> from your authorized utility company.</li></ul><p>If you have a gas water heater EcoNet will also place it in vacation mode if your Nest Protect detects smoke or carbon monoxide.</p><hr><md-list ng-show=vm.nest.nestLocations.length layout=column flex><md-subheader layout=row flex><span>Nest Location</span><span>EcoNet Location</span></md-subheader><md-list-item ng-repeat=\"location in vm.nest.nestLocations\" ng-click=vm.nest.attachNest(location) class=no-margin><md-list-item-text layout=row layout-align=\"space-between center\" flex><p class=bold>{{location.name}}</p><p>{{_.find(vm.nest.locations.locations, [\'id\', location.pairedLocation.id]).name}}</p></md-list-item-text></md-list-item></md-list><div layout=row layout-align=center class=row><md-button href={{vm.nest.nestAddress}} ng-if=!vm.nest.nestLocations.length class=\"md-raised md-primary large\">Connect to Nest</md-button><md-button ng-if=vm.nest.nestLocations.length ng-click=vm.nest.disconnect() class=\"md-raised md-warn large\">Disconnect Nest</md-button></div><p class=md-caption>*Requires EcoNet Enabled water heater</p></md-content>");
$templateCache.put("app/settings/_nestAttach.html","<md-content flex id=nest class=md-padding><p>Which EcoNet location does <span class=bold>{{vm.nest.nestLocation.name}}</span> correspond to?</p><md-list><md-list-item ng-repeat=\"location in vm.nest.locations.locations\" ng-click=\"vm.nest.attach(vm.nest.nestLocation, location.id)\" class=no-margin><p class=bold>{{location.name}}</p><md-checkbox ng-click=\"vm.nest.attach(vm.nest.nestLocation, location.id)\" ng-checked=\"location.id === vm.nest.nestLocation.pairedLocation.id\"></md-checkbox></md-list-item></md-list></md-content>");
$templateCache.put("app/settings/_network.html","<md-list layout=column><md-list-item><div layout=column flex layout-align=\"center center\" class=column><p>{{vm.networkInfo.network.macAddress}}</p></div><md-divider></md-divider></md-list-item><md-list-item><p>Software Version:</p><p class=md-secondary>{{vm.networkInfo.network.softwareVersion}}</p></md-list-item><md-list-item><p>Server Status Connection:</p><p ng-if=vm.networkInfo.network.isConnected class=\"md-secondary ok\">Active</p><p ng-if=!vm.networkInfo.network.isConnected class=\"md-secondary warning\">Disconnected</p><md-divider></md-divider></md-list-item><md-list-item><p>Network:</p><p ng-hide=!vm.networkInfo.network.isConnected class=md-secondary>{{vm.networkInfo.network.wifiSSID}}</p></md-list-item><md-list-item><p>IP Address:</p><p ng-hide=!vm.networkInfo.network.isConnected class=md-secondary>{{vm.networkInfo.network.wifiIPAddress}}</p></md-list-item><md-list-item><p>Signal Strength:</p><div class=\"signal md-secondary\"><icon name=icon-signalstrength></icon><div style=\"width: {{vm.networkInfo.network.isConnected?vm.networkInfo.network.wifiSignal:0}}%\" class=visible-area><icon name=icon-signalstrength></icon></div></div><p></p></md-list-item></md-list>");
$templateCache.put("app/settings/_networkInfo.html","<md-list id=networkInfo><md-list-item ng-repeat=\"module in vm.networkInfo.modules\" ng-click=vm.networkInfo.viewNetwork(module)><md-list-item-text flex layout=column><p>{{module.productDescription}}</p><p>MAC: {{module.macAddress}}</p><md-divider></md-divider></md-list-item-text><md-list-item-text flex=10 layout=column><icon name=icon-rightarrow class=arrow></icon></md-list-item-text></md-list-item></md-list>");
$templateCache.put("app/settings/_notificationsPreferences.html","<md-content id=notificationPreferences class=md-padding><md-list layout=column><md-list-item><p>Text Alerts</p><md-switch ng-model=vm.notificationsPreferences.notifications.allowTextNotifications aria-label=\"Text Notifications\" class=md-secondary></md-switch><md-divider ng-hide=vm.notificationsPreferences.notifications.allowTextNotifications class=md-inset></md-divider></md-list-item><md-list-item ng-show=vm.notificationsPreferences.notifications.allowTextNotifications layout=row><md-input-container class=md-secondary><label>Enter Phone Number</label><input type=text ng-model=vm.notificationsPreferences.identity.phone ui-mask=\"(999) 999-9999\"></md-input-container><md-divider class=md-inset></md-divider></md-list-item><md-list-item><p>Email Alerts</p><md-switch ng-model=vm.notificationsPreferences.notifications.allowEmailNotifications aria-label=\"Email Notifications\" class=md-secondary></md-switch><md-divider class=md-inset></md-divider></md-list-item><md-list-item><p>Marketing Messages</p><md-switch ng-model=vm.notificationsPreferences.notifications.receiveMarketingMessages aria-label=\"Receive Marketing Messages\" class=md-secondary></md-switch><md-divider class=md-inset></md-divider></md-list-item></md-list><div layout=row layout-align=center class=row><md-button ng-click=vm.notificationsPreferences.update() class=\"md-raised md-primary large\">Update Preferences</md-button></div></md-content>");
$templateCache.put("app/settings/_privacyStatement.html","<md-content ng-switch=vm.language class=md-padding><p ng-switch-default>Choose Language</p><p ng-switch-when=fr>Changer de langue</p><p ng-switch-when=sp>cambio de idioma</p><md-select ng-model=vm.language><md-option ng-repeat=\"language in vm.languages\" value={{language.abbr}}>{{language.full}}</md-option></md-select><div id=langEn ng-switch-default><h3>Privacy Policy</h3><p class=p2>Ruud Manufacturing Company (\"RUUD\") is sensitive to privacy issues on the Internet and mobile services. This policy explains how RUUD treats the information about you that we receive on the Internet or through mobile services. The purpose of this privacy policy is to inform you, as a user of these services, what kinds of information we may gather about you, how we may use that information, whether we disclose it to anyone and the choices you have regarding our use of, and your ability to correct, the information. Please note that this policy service lies only to our services, and not to other companies\' or organizations\' web applications or services to which we link.</p><p class=p2>In general, you can use our services without telling us who you are or revealing any information about yourself. Our service automatically gathers certain usage information such as the numbers and frequency of visitors to the service. This information is aggregated to measure the number of visits, average time spent on the service and how much of the service you use, so that we can improve our service.</p><p class=p2>On certain pages, we may ask you for personal information to provide a service that you have requested relating to this service. The personal information we collect may include:</p><ul class=ul1><li class=li2>contact details, such as your name, e-mail address, and telephone number;</li><li class=li2>your e-mail marketing preferences;</li><li class=li2>use and consumption information for the devices that the services control;</li><li class=li2>information used to customize and facilitate your use of our websites or mobile apps, including login and technical information;</li><li class=li2>information that assists us in identifying the products and services that best meet your requirements;</li><li class=li2>event registration information; and</li><li class=li2>feedback from you about our websites and our products and services generally.</li></ul><p class=p2>You are not required to provide any of this information, but if you do not, we may not be able to provide you the requested service or complete your transaction.</p><p class=p2>When you access or use our services, we automatically collect information about you, including:</p><ul class=ul1><li class=li2><b>Log Information</b>: We log information about your use of our services, including the type of device you use, access times, pages viewed, and your IP Address.</li><li class=li2><b>Device Information</b>: We collect information about the type of device you use, it\'s settings and the actions taken by you on the mobile device.</li><li class=li2><b>Information Collected by Tokens and Other Tracking Technologies</b>: We use various technologies to collect information, and this may include sending tokens to your device. Tokens are small data files stored on your hard drive or in your device memory that helps us to verify your identity and provide secure access. Tracking technologies are also used to verify settings you have previously enabled, IP address and location information (excluding physical location).</li></ul><p class=p2>RUUD does not use or disclose information about your individual visits or information that you may give us, such as your name, address, email address or telephone number, to any outside companies.</p><p class=p2>Using your registration information, at times RUUD may conduct on-line surveys to better understand the needs and profile of our visitors. When we conduct a survey, we will let you know how we will use the information collected from you.</p><p class=p2>The service may contain links to other third party services. While we try to link only to services that share our high standards and respect for privacy, we are not responsible for the content or the privacy practices employed by them.</p><p class=p2>Ruud does not knowingly collect information from children and does not target or direct its websites to children.</p><p class=p2>If we decide to change our privacy policy, we will post those changes here so that you will always know what information we gather, how we might use that information and whether we will disclose it to anyone.</p></div><div id=langFr ng-switch-when=fr><h3>Politique de confidentialité</h3><p class=p2>Ruud Manufacturing Company (\"RUUD\") est sensible aux problèmes de confidentialité sur Internet et les services mobiles. Cette politique explique comment RUUD traite les renseignements vous concernant que nous recevons par Internet ou par l’intermédiaire de services mobiles. L’objectif de cette politique de confidentialité est de vous aviser, en tant qu’utilisateur de ces services, des types de renseignements que nous pouvons recueillir à votre sujet, quel usage nous pouvons en faire, si nous les divulguons à qui que ce soit et les choix qui vous sont offerts concernant notre utilisation de ces renseignements et votre capacité à les corriger. Veuillez noter que cette politique ne concerne que nos services et non pas les applications ou services d’autres sociétés ou organismes dont les liens sont présents sur notre site.</p><p class=p2>En général, vous pouvez utiliser nos services sans nous dire qui vous êtes ou divulguer des renseignements quelconques à votre sujet. Notre service recueille automatiquement certains renseignements sur l’utilisation, tels que le nombre des visiteurs et la fréquence de leurs visites au service. Ces renseignements sont rassemblés pour mesurer le nombre de visites, la durée moyenne passée sur le service et le degré d’utilisation du service, pour nous aider à l’améliorer.</p><p class=p2>Sur certaines pages, il se peut que nous vous demandions des renseignements personnels afin de vous fournir un service que vous avez demandé dans le cadre de ce service. Les renseignements personnels recueillis peuvent comprendre :</p><ul class=ul1><li class=li2>les coordonnées telles que votre nom, une adresse courriel et un numéro de téléphone;</li><li class=li2>vos préférences en matière de commercialisation par courriel;</li><li class=li2>renseignements sur l’utilisation et la consommation des dispositifs contrôlés par le service;</li><li class=li2>les renseignements utilisés pour personnaliser et faciliter votre usage de nos sites Web ou applications de portable, y compris les informations de connexion et techniques;</li><li class=li2>les informations qui nous aident à identifier les produits et services qui conviennent le mieux à vos besoins;</li><li class=li2>les renseignements relatifs à l’inscription; et</li><li class=li2>des commentaires de votre part sur nos sites Web et nos produits et services en général.</li></ul><p class=p2>Vous n’êtes pas obligé de nous fournir ces renseignements mais si vous ne le faites pas, il se peut que nous ne puissions pas vous procurer le service requis ou accomplir la transaction.</p><p class=p2>Lorsque vous accédez à nos services ou les utilisez, nous recueillons automatiquement des renseignements vous concernant, y compris :</p><ul class=ul1><li class=li2><b>Renseignements relatifs à la connexion</b>: Nous enregistrons les renseignements sur votre utilisation de nos services, y compris le type d’appareil que vous utilisez, les heures d’accès, les pages consultées et votre adresse IP.</li><li class=li2><b>Renseignements sur l’appareil</b>: Nous recueillons des informations sur le type d’appareil que vous utilisez, ses paramètres et les mesures prises sur l’appareil mobile.</li><li class=li2><b>Renseignements recueillis par des jetons et autres technologies de suivi</b>: Nous utilisons diverses technologies pour recueillir les renseignements et cela peut comprendre envoyer des jetons à votre appareil. Les jetons sont de petits fichiers de données enregistrés sur votre disque dur ou dans la mémoire de votre appareil, qui nous aident à vérifier votre identité et à vous offrir un accès sécurisé. Les technologies de suivi sont également utilisées pour vérifier les paramètres que vous avez activés auparavant, l’adresse IP et les renseignements relatifs à l’emplacement (excepté l’emplacement physique).</li></ul><p class=p2>RUUD n’utilise et ne divulgue les renseignements relatifs à vos visites individuelles ou informations que vous pouvez nous avoir fournies, telles que votre nom, adresse, adresse courriel ou numéro de téléphone, à aucune société externe.</p><p class=p2>En se servant de vos renseignements relatifs à l’inscription, il se peut que de temps à autres, RUUD mène des sondages en ligne pour mieux comprendre les besoins et profils de nos visiteurs. Lorsque nous menons un sondage, nous vous aviserons de la façon dont nous utiliserons les renseignements recueillis de votre part.</p><p class=p2>Il se peut que le service contienne des liens vers des services de tiers. Bien que nous nous efforcions de n’avoir des liens que vers des services qui partagent nos normes rigoureuses et notre respect de la confidentialité, nous ne pouvons pas être tenus responsables du contenu ou des pratiques de confidentialité qu’ils utilisent.</p><p class=p2>Ruud ne recueille pas volontairement des renseignements de la part des enfants et ne cible pas ni ne destine ses sites Web aux enfants.</p><p class=p2>Si nous décidons de modifier notre politique de confidentialité, nous afficherons ces modifications dans la présente afin que vous soyez toujours tenu au courant des renseignements que nous recueillons, de l’usage que nous en faisons et si oui ou non nous allons les divulguer à qui que ce soit.</p></div><div id=langSp2 ng-switch-when=sp><h3>Nomas de privacidad</h3><p class=p2>Ruud Manufacturing Company (\"RUUD\") es muy sensible ante los problemas de privacidad en Internet y servicios móviles. Estas normas explican la forma en que RUUD maneja la información que recibimos de usted por Internet o a través de servicios móviles. El objetivo de estas normas de privacidad es informarle, como usuario de estos servicios, los tipos de información que podemos recopilar sobre usted, la forma en que podemos usarla si la revelamos a alguien y las opciones que usted tiene con respecto a nuestro uso, así como su capacidad para rectificar la información. Tenga en cuenta que estas normas sólo aplican a nuestros servicios y no a otras aplicaciones o servicios de otras compañías u organizaciones a las cuales nos vinculamos.</p><p class=p2>En general, usted puede usar nuestros servicios sin decirnos quién es ni revelarnos cualquier información personal. Nuestro servicio automáticamente recopila cierta información de uso como la cantidad y frecuencia de visitantes del servicio. Esta información se agrega para calcular el número de visitas, el tiempo promedio en el servicio y cuánto del servicio usa usted, para que podamos mejorar nuestro servicio.</p><p class=p2>En ciertas páginas puede pidamos información personal para brindar el servicio que usted a solicitado. La información personal que recopilamos puede incluir:</p><ul class=ul1><li class=li2>detalles de contacto, tales como nombre, dirección de correo electrónico y número telefónico;</li><li class=li2>sus preferencias de publicidad a través de correo electrónico;</li><li class=li2>información sobre el uso y consumo de los dispositivos que los servicios controlan;</li><li class=li2>información usada para personalizar y facilitar el uso de los sitios web o aplicaciones móviles, incluyendo información técnica y de acceso;</li><li class=li2>información que nos ayuda a determinar los productos y servicios que mejor satisfacen sus requerimientos;</li><li class=li2>información de inscripción de evento; y</li><li class=li2>sus comentarios acerca de nuestros sitios web, productos y servicios en general.</li></ul><p class=p2>Usted no está obligado a suministrar ninguna de esta información, pero si no lo hace puede que no podamos brindarle el servicio que ha solicitado ni completar su transacción.</p><p class=p2>Cuando usted accede o usa nuestros servicios, automáticamente recopilamos información sobre usted, incluyendo:</p><ul class=ul1><li class=li2><b>Información de acceso:</b> Registramos información sobre el uso de nuestros servicios, incluyendo el tipo de dispositivo que usted usa, las veces que accede, las páginas que ve y su dirección IP.</li><li class=li2><b>Información de dispositivo:</b> Recopilamos información sobre el tipo de dispositivo que usted usa, su configuración y sus acciones en el dispositivo móvil.</li><li class=li2><b>Información recopilada por identificadores y otras tecnologías de rastreo:</b> Usamos varias tecnologías para recopilar información, que pueden incluir el envío de identificadores al dispositivo suyo. Los identificadores son pequeños archivos de datos que se almacenan en su disco duro o en la memoria de su dispositivo para ayudarnos a verificar su identidad y darle acceso seguro. Las tecnologías de rastreo se usan también para verificar configuraciones que usted haya habilitado previamente, la dirección IP e información de ubicación (excluyendo ubicación física).</li></ul><p class=p2>RUUD no usa ni revela información a terceros sobre visitas individuales o información que usted pueda darnos, tales como nombre, dirección, dirección de correo electrónico o número telefónico.</p><p class=p2>Algunas veces, usando su información de inscripción, RUUD puede realizar encuestas en línea para entender mejor las necesidades y perfiles de nuestros visitantes. Cuando realizamos una encuesta, le informaremos cómo usaremos la información que tenemos sobre usted.</p><p class=p2>El servicio puede contener enlaces a servicios de terceros. Aunque tratamos de tener enlaces con servicios que comparten nuestros altos estándares de respeto a la privacidad, no nos hacemos responsables por el contenido o las prácticas de privacidad de ellos.</p><p class=p2>Ruud no recopila intencionalmente información sobre niños ni sus sitios web están dirigidos o enfocados en ellos.</p><p class=p2>Si decidimos cambiar nuestras normas de privacidad, publicaremos esos cambios aquí para que usted siempre sepa qué información recopilamos, cómo podemos usarla y si la revelaremos a alguien.</p></div></md-content>");
$templateCache.put("app/settings/_temperatureUnit.html","<md-content class=md-padding><md-radio-group ng-model=vm.temperatureUnit.user.temperatureDisplayUnit ng-change=vm.temperatureUnit.update()><md-radio-button ng-class=\"{&quot;md-primary&quot;: vm.temperatureUnit.user.temperatureDisplayUnit === &quot;Fahrenheit&quot;}\" value=Fahrenheit>Fahrenheit</md-radio-button><md-radio-button ng-class=\"{&quot;md-primary&quot;: vm.temperatureUnit.user.temperatureDisplayUnit === &quot;Celsius&quot;}\" value=Celsius>Celsius</md-radio-button></md-radio-group></md-content>");
$templateCache.put("app/settings/_termsOfService.html","<md-content ng-switch=vm.language class=md-padding><p ng-switch-default>Choose Language</p><p ng-switch-when=fr>Changer de langue</p><p ng-switch-when=sp>cambio de idioma</p><md-select ng-model=vm.language><md-option ng-repeat=\"language in vm.languages\" value={{language.abbr}}>{{language.full}}</md-option></md-select><div id=langEn ng-switch-default><h3>Terms of Service</h3><p class=p3><b>1. GENERAL:</b><span class=Apple-converted-space></span> By installing the Application (as defined below), you agree to be bound by these terms of use (“Terms”). Please review them carefully before installation and/or acceptance.<span class=Apple-converted-space></span></p><p class=p3><b>2. DEFINITIONS:</b> The “Application” shall mean the software provided by Ruud to offer services related to Ruud, Ruud’s services and its partners’ services, to be used on Apple® iOS and Android® OS and web accessible devices and any upgrades from time to time and any other software or documentation which enables the use of the Application.<span class=Apple-converted-space></span></p><p class=p3><b>3. SCALD WARNING AND WATER TEMPERATURE SETTINGS:</b> Safety and energy conservation are factors to be considered when selecting the water temperature setting of the water heater’s remote control settings when using this Application. Water temperatures above 120°F (49°C) can cause death or severe burns from scalding. Be sure to read and follow the warnings outlined in the user manual of your water heater and included with this product. There is a hot water scald potential if the water temperature is set too high. Households with small children, the disabled, or elderly persons may require a 120°F (49°C) or lower temperature setting to prevent contact with “HOT” water.</p><p class=p3><b>4. DATA PROTECTION:</b><span class=Apple-converted-space></span></p><p class=p3>4.1. Any personal information you supply to Ruud when using the Application will be used by Ruud in accordance with its Privacy Statement, as shown on the Privacy Statement tab of this Application.<span class=s1></span>To access the Application or some of the resources it offers, you may be asked to provide certain registration details or other information. It is a condition of your use of the Application that all the information you provide on the Application is correct, current and complete. You agree that all information you provide to register with this Application or otherwise, including but not limited to through the use of any interactive features on the Application, is governed by our Privacy Statement and you consent to all actions we take with respect to your information consistent with our Privacy Statement.</p><p class=p4><br></p><p class=p3>4.2. If you choose, or are provided with, a user name, password or any other piece of information as part of our security procedures, you must treat such information as confidential, and you must not disclose it to any other person or entity. You also acknowledge that your account is personal to you and agree not to provide any other person with access to this Application or portions of it using your user name, password or other security information. You agree to notify us immediately of any unauthorized access to or use of your user name or password or any other breach of security. You also agree to ensure that you exit from your account at the end of each session. You should use particular caution when accessing your account from a public or shared computer so that others are not able to view or record your password or other personal information.</p><p class=p4><br></p><p class=p3>4.3. We have the right to disable any user name, password or other identifier, whether chosen by you or provided by us, at any time in our sole discretion for any or no reason, including if, in our opinion, you have violated any provision of these Terms of Use.</p><p class=p3><br><b>5. PROPRIETARY RIGHTS AND LICENSE:</b><span class=Apple-converted-space></span></p><p class=p2>5.1. All trademarks, copyright, database rights and other intellectual property rights of any nature in the Application together with the underlying software code are owned either directly by Ruud or by Ruud’s affiliates.<span class=Apple-converted-space></span></p><p class=p2>5.2. Ruud hereby grants you a worldwide, non-exclusive, royalty-free revocable license to use the Application for your business and personal use in accordance with these terms.<span class=Apple-converted-space></span></p><p class=p2><b>6. OWNERSHIP AND MODIFICATION OF APPLICATION:</b> You acknowledge that title, ownership and all intellectual property rights in and to the Application and any copies of the Application are owned by and remain with Ruud and its affiliated companies unless otherwise specified. This Application may be changed, improved or updated periodically at any time without notice. Ruud may also make improvements and/or changes in the products referred to in the Application without notice. In order to obtain the latest product information, data sheets, technical information or further details about the Application, you may contact the Ruud directly using the contact information provided in the user manual.</p><p class=p3><b>7. CONDITIONS OF USE:</b><span class=Apple-converted-space></span></p><p class=p2>7.1. You will not, nor allow third parties on your behalf to (i) make and distribute copies of the Application (ii) attempt to copy, reproduce, alter, modify, reverse engineer, disassemble, decompile, transfer, exchange or translate the Application; or (iii) create derivative works of the Application of any kind whatsoever.<span class=Apple-converted-space></span></p><p class=p2>7.2. The Application is currently made available to you free of charge for your personal, non-commercial use. Ruud reserves the right to amend or withdraw the Application, or charge for the Application or service provided to you in accordance with these terms, at any time and for any reason.</p><p class=p2>7.3. You acknowledge that the terms of agreement with your respective mobile network provider (‘Mobile Provider’) or web access provider (\"Web Provider\") will continue to apply when using the Application. As a result, you may be charged by the Mobile Provider or Web Provider for access to network connection services for the duration of the connection while accessing the Application or any such third party charges as may arise. You accept responsibility for any such charges that arise.<span class=Apple-converted-space></span></p><p class=p2>7.4. If you are not the bill payer for the mobile telephone, computer or handheld device being used to access the Application, you will be assumed to have received permission from the bill payer for using the Application.<span class=Apple-converted-space></span></p><p class=p2><b>8. THIRD PARTY MATERIALS:</b> The Application may enable access to Ruud\'s and third party services and web sites (collectively and individually, \"Services\"). Use of the Services may require Internet access and may require you to accept additional terms of service.<span class=Apple-converted-space></span></p><p class=p2>8.1. You understand that by using any of the Services, you may encounter content that may be deemed offensive, indecent, or objectionable, which content may or may not be identified as having explicit language, and that the results of any search or entering of a particular URL may automatically and unintentionally generate links or references to objectionable material. Nevertheless, you agree to use the Services at your sole risk and that Ruud shall not have any liability to you for content that may be found to be offensive, indecent, or objectionable.<span class=Apple-converted-space></span></p><p class=p2>8.2. Certain Services may display, include or make available content, data, information, applications or materials from third parties (“Third Party Materials”) or provide links to certain third party web sites. By using the Services, you acknowledge and agree that Ruud is not responsible for examining or evaluating the content, accuracy, completeness, timeliness, validity, copyright compliance, legality, decency, quality or any other aspect of such Third Party Materials or web sites. Ruud does not warrant or endorse and does not assume and will not have any liability or responsibility to you or any other person for any third-party Services, Third Party Materials or web sites, or for any other materials, products, or services of third parties. Third Party Materials and links to other web sites are provided solely as a convenience to you.<span class=Apple-converted-space></span></p><p class=p2>8.3. You agree that any Services containing proprietary content, information and material that is protected by applicable intellectual property and other laws, including but not limited to copyright, and that you will not use such proprietary content, information or materials in any way whatsoever except for permitted use of the Services. No portion of the Services may be reproduced in any form or by any means. You agree not to modify, rent, lease, loan, sell, distribute, or create derivative works based on the Services, in any manner, and you shall not exploit the Services in any unauthorized way whatsoever, including but not limited to, by trespass or burdening network capacity.<span class=Apple-converted-space></span></p><p class=p2>8.4.<span class=Apple-converted-space></span>In addition, third party Services and Third Party Materials that may be accessed from, displayed on or linked to from the Application are not available in all languages or in all countries. Ruud makes no representation that such Services and Materials are appropriate or available for use in any particular location. To the extent you choose to access such Services or Materials, you do so at your own initiative and are responsible for compliance with any applicable laws, including but not limited to applicable local laws. Ruud, and its licensors, reserve the right to change, suspend, remove, or disable access to any Services at any time without notice. In no event will Ruud be liable for the removal of or disabling of access to any such Services. Ruud may also impose limits on the use of or access to certain Services, in any case and without notice or liability.<span class=Apple-converted-space></span></p><p class=p3><b>9. AVAILABILITY:</b><span class=Apple-converted-space></span></p><p class=p2>9.1. This Application is available to handheld mobile devices running Apple® iOS and Android® OS operating systems and web accessible devices. Ruud will use reasonable efforts to make the Application available at all times. However you acknowledge the Application is provided over the internet and mobile networks and so the quality and availability of the Application may be affected by factors outside Ruud’s reasonable control.<span class=Apple-converted-space></span></p><p class=p2>9.2. Ruud, its group of companies and sub-contractors do not accept any responsibility whatsoever for unavailability of the Application, or any difficulty or inability to download or access content or any other communication system failure which may result in the Application being unavailable.<span class=Apple-converted-space></span></p><p class=p3><b>10. SYSTEM REQUIREMENTS:</b><span class=Apple-converted-space></span></p><p class=p2>10.1. In order to use the Application, you are required to have a compatible mobile telephone or handheld device, internet access, and the necessary minimum specifications (\'Software Requirements\').</p><p class=p2>10.2. The Software Requirements are as follows: Apple iOS, Android OS or Internet Explorer 8 or above; Language: English.<span class=Apple-converted-space></span>As the Application is updated, the System Requirements may also be updated.<span class=Apple-converted-space></span>You are responsible for downloading or acquiring the appropriate updates to your mobile or web accessible device to continue use of the Application.<span class=Apple-converted-space></span></p><p class=p2>10.3. The version of the Application software may be upgraded from time to time to add support for new functions and services.</p><p class=p3><b>11. TERMINATION:</b><span class=Apple-converted-space></span></p><p class=p2>11.1. Ruud may terminate use of the Application at any time by giving notice of termination to you.<span class=Apple-converted-space></span></p><p class=p2>11.2. Upon any termination, (a) the rights and licenses granted to you herein shall terminate; (b) you must cease all use of the Application.</p><p class=p3><b>12. LIMITATION OF LIABILITY:</b><span class=Apple-converted-space></span></p><p class=p2>12.1. In no event will Ruud be liable for any direct, indirect, special, punitive, exemplary or consequential losses or damages of whatsoever kind arising out of your use or access to the Application, including injury whether or not in the contemplation of the parties, whether based on breach of contract, tort (including negligence), product liability or otherwise.<span class=Apple-converted-space></span></p><p class=p2>12.2. Ruud is not liable to you for any damage or alteration to your equipment including but not limited to computer equipment, handheld device or mobile telephones as a result of the installation or use of the Application.<span class=Apple-converted-space></span></p><p class=p2>12.3. Nothing in these terms shall exclude or limit Ruud’s liability for death or personal injury caused by negligence or for fraud or fraudulent misrepresentation or any other liability which cannot be excluded or limited under applicable law.<span class=Apple-converted-space></span></p><p class=p2>12.4. The Application in this Application may contain technical inaccuracies or typographical errors. Ruud does not warrant the accuracy or completeness of the content in the Application or the reliability of any advice, opinion, statement or other information displayed or distributed through this Application. You acknowledge that any reliance on any such advice, opinion, statement or other information shall be at your sole risk. Ruud and its affiliated companies assume no responsibility for any damage, liability or other loss arising from your use of the Application or any claim of infringement of any third-party\'s rights or a trade secret violation that arise as a result of your use of the Application. IN NO EVENT SHALL Ruud OR ITS AFFILIATED COMPANIES BE LIABLE TO ANY PERSON OR ENTITY FOR ANY DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, SPECIAL OR CONSEQUENTIAL DAMAGES (INCLUDING, WITHOUT LIMITATION, ANY DAMAGES RESULTING FROM LOSS OF USE, BUSINESS INTERRUPTION, LOSS OF INFORMATION, LOSS OR INACCURACY OF DATA, LOSS OF PROFITS, LOSS OF SAVINGS, THE COST OF PROCUREMENT OF SUBSTITUTED GOODS, SERVICES OR TECHNOLOGIES, OR FOR ANY MATTER BEYOND ITS REASONABLE CONTROL), ARISING OUT OF OR IN CONNECTION WITH THE USE OR INABILITY TO USE THE APPLICATION, WHETHER IN AN ACTION FOR BREACH OF CONTRACT, NEGLIGENCE OR OTHER ACTION IN TORT, EVEN IF Ruud OR ONE OF ITS AFFILIATED COMPANIES WERE EXPRESSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. Some states or jurisdictions do not allow the exclusion or limitation for certain damages such as direct, incidental, special or consequential damages, so the above limitations may not apply to you.</p><p class=p2><b>13. DISCLAIMER OF WARRANTIES:<span class=Apple-converted-space></span></b> To the maximum extent permitted by law, and for the avoidance of doubt, Ruud hereby disclaims all implied warranties with regard to the Application. The Application and software are provided \"as is\" and \"as available\" without warranty of any kind.</p><p class=p2><b>14. JURISDICTION AND VENUE:</b> This Application shall be governed by and construed in accordance with the laws of the State of Georgia of the United States of America and, as to matters affecting copyright, trademark and patents, by United States federal law. In addition, you agree that if any legal action is filed as a result of the use or inability to use the Application contained in this Application, then such action shall be filed in the Georgia State Court or in the United States District Court located in Fulton County, Georgia. By using this Application, you irrevocably consent to the jurisdiction of those courts for all disputes arising out of or relating to the use of the Application.</p><p class=p2><b>15. MODIFICATIONS:</b> Ruud reserves the right to change or revise these Terms of Use. Please check these Terms of Use periodically for changes and modifications. Your continued use of this Application following the posting of modifications to these Terms of Use constitutes acceptance of these changes. Ruud may terminate, change, suspend or discontinue any aspect of the Application, availability of the Application or features of the Application at any time. Ruud may also impose restrictions on features and services and may limit your access to the Application without notice or liability.</p><p class=p2>your continued use of the Application following the posting of revised Terms of Use means that you accept and agree to the changes. You are expected to check this page from time to time so you are aware of any changes, as they are binding on you.<span class=Apple-converted-space></span></p><p class=p2><b>16. SEVERABILITY:</b> If any provision or portion of a provision of these Terms of Use is held to be invalid or unenforceable for any reason, such invalidity shall not affect the validity of the balance of that provision and/or remaining provisions of these Terms of Use, which shall remain valid and enforceable.</p><p class=p2><b>17. ENTIRE AGREEMENT:</b> These Terms of Use constitute the entire agreement between you and Ruud with respect to this Application and supersedes all prior or contemporaneous communications and proposals in any medium between you and Ruud.</p><p class=p2><b>18. MISCELLANEOUS:</b> Any rights not expressly granted in these Terms of Use are reserved by Ruud and its affiliated companies.</p><p class=p5><br></p><p class=p6>This Application is provided by Ruud Manufacturing Company; 1100 Abernathy Rd, Suite 1400; Atlanta, GA 30328</p></div><div id=langFr ng-switch-when=fr><h3>Modalités de service</h3><p class=p3><b>1. DIRECTIVES GÉNÉRALES :</b> En installant l’application (telle que définie ci-dessous), vous acceptez d’être lié par ces conditions d’utilisation («Modalité»). Veuillez les consulter avec soin avant d’installer et/ou d’accepter.</p><p class=p3><b>2. DÉFINITIONS :</b> L’«Application» signifie le logiciel fourni par Ruud pour offrir des services relatifs à Ruud, les services de Ruud et les services de ses partenaires, qui seront utilisés sur Apple® IOS et Android® OS et les appareils qui peuvent accéder à Internet, et toutes améliorations régulières et tout autre logiciel ou documents permettant l’utilisation de l’application.</p><p class=p3><b>3. AVERTISSEMENT CONTRE LES BRÛLURES ET RÉGLAGES DE LA TEMPÉRATURE DE L’EAU :</b> La sécurité et la conservation d’énergie sont des facteurs dont il faut tenir compte lorsque vous choisissez la température de l\'eau sur la télécommande du chauffe-eau lorsque vous utilisez cette Application. Les températures d’eau supérieures à 49 °C (120 °F) peuvent entraîner des brûlures graves ou la mort. Veillez à lire et vous conformer aux avertissements soulignés dans le guide de l’utilisateur de votre chauffe-eau et fourni avec ce produit. Les brûlures dues à l’eau chaude sont possibles si la température de l’eau est réglée trop haut. Les ménages comprenant de jeunes enfants, des personnes handicapées ou âgées peuvent nécessiter un réglage de température de 49 °C (120 °F) ou plus bas pour empêcher tout contact avec de l’eau «BRÛLANTE».</p><p class=p3><b>4. PROTECTION DES DONNÉES :</b></p><p class=p3>4.1. Tous renseignements personnels que vous fournissez à Ruud lorsque vous utilisez l’Application seront utilisés par Ruud conformément à sa déclaration sur la confidentialité, telle qu’affichée sur l’onglet de déclaration sur la confidentialité de cette Application. Pour avoir accès à l’Application ou à certaines des ressources qu’elle offre, il se peut qu’on vous demande de fournir des détails relatifs à l’inscription ou autres renseignements. Vous vous engagez, comme condition d’utilisation de l’Application, à fournir sur l’Application des renseignements corrects, actuels et complets. Vous convenez que tous les renseignements que vous fournissez pour vous inscrire à cette Application ou autrement, y compris mais non limités à l’utilisation de toutes caractéristiques interactives de l’Application, sont régis par notre déclaration sur la confidentialité et vous acceptez toutes les mesures que nous prenons relatives à vos renseignements, qui sont conformes à notre déclaration sur la confidentialité.</p><p class=p3>4.2. Si vous choisissez ou recevez un nom d’utilisateur, mot de passe ou tout autre renseignement dans le cadre de nos procédures de sécurité, vous devez considérer ces renseignements comme confidentiels et ne les divulguer à aucune autre personne ou entité. Vous reconnaissez également que votre compte est personnel et consentez à ne fournir à aucune autre personne l’accès à cette Application ou portion de cette Application au moyen de votre nom d’utilisateur, mot de passe ou autres renseignements confidentiels. Vous consentez à nous avertir immédiatement de tout accès ou utilisation non autorisé(e) de votre nom d’utilisateur ou mot de passe ou de toute autre enfreinte à la sécurité. Vous consentez également à vous assurer de sortir de votre compte à la fin de chaque session. Vous devez faire preuve d’une grande prudence lorsque vous accédez à votre compte à partir d’un ordinateur public ou partagé, afin qu’aucune autre personne ne puisse voir ou enregistrer votre mot de passe ou autres renseignements personnels.</p><p class=p3>4.3. Nous nous réservons le droit de désactiver tout nom d’utilisateur, mot de passe ou autre identifiant, qu’il soit choisi par vous ou fourni par nous, à tout moment et à notre seule discrétion pour tout motif ou sans aucun motif si, à notre avis, vous avez violé une disposition quelconque de ces modalités d’utilisation.</p><p class=p3><b>5. DROITS EXCLUSIFS ET LICENCE :</b></p><p class=p3>5.1. Toutes les marques de commerce, tous les droits d’auteur, droits relatifs à la base de donnée et autres droits de propriété intellectuelle de toute nature dans l’Application ainsi que le code de logiciel sous-jacent sont la propriété directe de Ruud ou des sociétés affiliées de Ruud.</p><p class=p3>5.2. Ruud vous accorde par la présente une licence universelle, non exclusive, franche de redevances et révocable, d’utiliser l’Application dans le cadre de vos activités professionnelles et personnelles conformément à ces modalités.</p><p class=p3><b>6. TITULARITÉ ET MODIFICATION DE L’APPLICATION :</b> Vous reconnaissez que le titre, la propriété et tous les droits de propriété intellectuelle relatifs à l’Application et toutes copies de l’Application, sont et demeurent la propriété de Ruud et de ses sociétés affiliées sauf indication contraire. Cette Application peut être modifiée, améliorée ou mise à jour en tout temps sans préavis. Ruud peut également apporter des améliorations et/ou modifications aux produits auxquels l’Application fait référence, sans préavis. Afin d’obtenir les renseignements sur les produits, feuilles de données, renseignements techniques ou autres détails supplémentaires les plus récents concernant l’Application, vous devez contacter Ruud directement en vous servant des coordonnées fournies dans le guide de l’utilisateur.</p><p class=p3><b>7. CONDITIONS D’UTILISATION :</b></p><p class=p3>7.1. Vous ne ferez et n’autoriserez aucun tiers en votre nom à (i) faire et distribuer des copies de l’Application; (ii) tenter de copier, reproduire, modifier, faire de l’ingénierie inverse, désassembler, décompiler, transférer, échanger ou traduire l’Application; ou (iii) créer des œuvres dérivées quelconques de l’Application.</p><p class=p3>7.2. L’Application est actuellement mise à votre disposition gratuitement pour votre usage personnel et non commercial. Ruud se réserve le droit de modifier ou retirer l’Application, ou d’obtenir un paiement pour l’Application ou le service fourni, conformément à ces modalités, en tout temps et pour un motif quelconque.</p><p class=p3>7.3. Vous reconnaissez que les dispositions de l\'accord avec vos fournisseurs respectifs de réseau mobile (’Fournisseur mobile’) ou de l’accès à Internet (’Fournisseur Internet’) continueront d’être en vigueur lorsque vous utilisez l’Application. Par conséquent, vous pouvez être tenu de payer le Fournisseur mobile ou Fournisseur Internet pour l’accès aux services de connexion au réseau pendant toute la durée de la connexion lors de l’accès à l’Application ou tout autre paiement qu’un tel tiers peut réclamer le cas échéant. Vous acceptez la responsabilité de tels paiement potentiels.</p><p class=p3>7.4. Si vous n’êtes pas la personne qui paie le téléphone portable, l’ordinateur ou l’appareil portatif utilisé pour avoir accès à l’Application, il sera présumé que vous avez reçu la permission d’utiliser l’Application de la personne responsable du paiement.</p><p class=p3><b>8. DOCUMENTS DE TIERS :</b> L’Application peut permettre l’accès aux services et services Internet de Ruud et de tiers (collectivement et individuellement, «Services»). L’utilisation des Services peut nécessiter l’accès au service Internet et il se peut que vous ayez à accepter d’autres modalités de service.</p><p class=p3>8.1. Vous comprenez que dans le cadre de l’utilisation des Services, il se peut que vous trouviez un contenu qui puisse être jugé offensant, indécent ou inadmissible, que tel contenu peut ou non être identifié comme comportant un langage explicite et que les résultats de toute recherche ou l’accès à un URL particulier peut automatiquement et involontairement générer des liens ou références à un matériel inadmissible. Néanmoins, vous acceptez d’utiliser les Services à vos propres risques et que Ruud n\'aura aucune responsabilité envers vous pour un contenu qui peut être considéré offensant, indécent ou inadmissible.</p><p class=p3>8.2. Certains Services peuvent afficher, comprendre ou mettre à votre disposition un contenu, des données, des renseignements, des applications ou des documents de tiers («Documents de tiers») ou fournir des liens vers certains sites Internet de tiers. En utilisant les Services, vous reconnaissez et acceptez que Ruud n’est aucunement responsable de l’examen ou de l’évaluation du contenu, de l’exactitude, l’exhaustivité, la rapidité d’exécution, la validité, la conformité aux droits d’auteur, la légalité, la bienséance, la qualité ou tout autre aspect de tels documents ou sites Internet de tiers. Ruud ne garantit pas ni n’approuve et n’assumera ni n\'aura aucune responsabilité envers vous ou toute autre personne, pour tous Services de tiers, documents ou sites Internet de tiers, ou pour tous autres documents, produits ou services de tiers. Les documents et liens de tiers vers des sites Internet ne vous sont fournis qu’à des fins de commodité.</p><p class=p3>8.3. Vous acceptez que tous Services ayant un contenu, des renseignements et des documents exclusifs sont protégés par les lois applicables relatives à la propriété intellectuelle et autres lois, y compris mais non limités au droit d’auteur et que vous n’utiliserez pas tel contenu, renseignements ou documents exclusifs d’une manière quelconque à l’exception d’une utilisation autorisée de ces Services. Aucune portion des Services ne peut être reproduite ou copiée sous quelque forme ou de quelque manière que ce soit. Vous consentez à ne pas modifier, louer, céder, prêter, vendre, distribuer ou créer des œuvres dérivées sur la base des Services, de quelque manière que ce soit et vous ne vous servirez pas des Services d’une manière quelconque non autorisée, notamment mais sans s’y limiter, en portant atteinte à ou en surchargeant la capacité du réseau.</p><p class=p3>8.4. En outre, les Services et documents de tiers auxquels on peut accéder, qui sont affichés ou vers lesquels il existe des liens à partir de l’Application, ne sont pas disponibles dans toutes les langues ou tous les pays. Ruud ne fait aucune représentation que tels Services et documents sont pertinents ou disponibles pour une utilisation dans un emplacement particulier. Dans la mesure où vous décidez d’accéder à de tels Services ou documents, vous le faites de votre propre initiative et êtes responsable de vous conformer à toutes les lois applicables, y compris mais non limitées aux lois locales applicables. Ruud et ses concédants se réservent le droit de modifier, interrompre, retirer ou désactiver l’accès à des Services quelconques à tout moment et sans préavis. En aucun cas Ruud ne sera tenue responsable du retrait ou de la désactivation de l’accès à de tels Services. Ruud peut également imposer des limites à l’utilisation ou l’accès de certains Services, dans tous les cas et sans préavis ou responsabilité.</p><p class=p3><b>9. DISPONIBILITÉ :</b></p><p class=p3>9.1. Cette Application est disponible sur les appareils mobiles portatifs munis des systèmes d’exploitation Apple® IOS et Android® IOS et sur les appareils qui ont accès à Internet. Ruud fera tous les efforts raisonnables pour assurer l’accès à l’Application en tout temps. Cependant, vous reconnaissez que l’Application est fournie par des réseaux Internet et mobiles et que la qualité et disponibilité de l’Application peuvent donc être affectées par des facteurs hors du contrôle raisonnable de Ruud.</p><p class=p3>9.2. Ruud, son groupe de sociétés et sous-traitants, n’acceptent aucune responsabilité quelconque pour le manque de disponibilité de l’Application ou toute difficulté ou incapacité à télécharger ou avoir accès au contenu ou pour toute autre défaillance du système de communication qui peut entraîner la perte de disponibilité de l’Application.</p><p class=p3><b>10. EXIGENCES RELATIVES AU SYSTÈME :</b></p><p class=p3>10.1. Afin d’utiliser l’Application, vous devez avoir un téléphone portable ou appareil portatif compatibles, l’accès Internet et un minimum de caractéristiques nécessaires (’Exigences en matière de logiciel’).</p><p class=p3>10.2. Les exigences en matière de logiciel sont les suivantes : Apple iOS, Android OS ou Internet Explorer 8 ou supérieur; Langage : Anglais. Lorsque l’Application est mise à jour, il se peut que les exigences du système soient également mises à jour. Vous êtes responsable du téléchargement et de l’acquisition des mises à jour pertinentes pour votre appareil mobile ou à accès Internet pour continuer à utiliser l’Application.</p><p class=p3>10.3. La version du logiciel de l’Application peut être améliorée de temps en temps pour ajouter un soutien pour de nouvelles fonctions et de nouveaux services.</p><p class=p3><b>11. CESSATION :</b></p><p class=p3>11.1. Ruud peut annuler l’utilisation de l’Application à tout moment en vous envoyant un avis de cessation.</p><p class=p3>11.2. Lorsqu’un accord prend fin, (a) les droits et licences qui vous sont accordés dans le cadre de cet accord cesseront; (b) vous devez cesser toute utilisation de l’Application.</p><p class=p3><b>12. LIMITES DE RESPONSABILITÉ :</b></p><p class=p3>12.1. En aucun cas Ruud ne sera tenue responsable de toutes pertes ou tous dommages directs, indirects, particuliers, punitifs, exemplaires ou consécutifs de quelque nature que ce soit, résultant de votre utilisation de ou accès à l’Application, y compris les blessures, anticipées ou non par les parties, résultant d’une rupture du contrat, d’un délit civil (y compris la négligence), de la responsabilité du fait du produit ou autre.</p><p class=p3>12.2. Ruud n’a aucune responsabilité envers vous pour tout dommage ou altération de votre équipement, y compris mais non limités à votre ordinateur, appareil portatif ou téléphones portables, résultant de l’installation ou utilisation de l’Application.</p><p class=p3>12.3. Aucun aspect de ces modalités n’exclura ou limitera la responsabilité de Ruud en cas de décès ou blessure résultant de négligence ou en cas de fraude ou déclaration frauduleuse ou toute autre responsabilité qui ne peut être exclue ou limitée en vertu de la loi en vigueur.</p><p class=p3>12.4. L’Application contenue dans cette Application peut comporter certaines erreurs techniques ou typographiques. Ruud ne garantit pas l’exactitude ou l’exhaustivité du contenu de l’Application, ni la fiabilité de tout conseil, opinion, déclaration ou autres renseignements affichés ou distribués par cette Application. Vous reconnaissez que toute confiance accordée à de tels conseil, opinion, déclaration ou autre renseignement sera à vos propres risques. Ruud et ses sociétés affiliées n’assument aucune responsabilité quant à tout dommage, responsabilité ou autre perte résultant de votre utilisation de l’Application ou toute réclamation pour enfreinte à tous droits d’une tierce partie ou violation d’un secret commercial résultant de votre utilisation de l’Application. EN AUCUN CAS, Ruud OU SES SOCIÉTÉS AFFILIÉES NE SERONT TENUES RESPONSABLES ENVERS AUCUNE PERSONNE OU ENTITÉ POUR TOUT DOMMAGE DIRECT, INDIRECT, ACCESSOIRE, PUNITIF, SPÉCIAL OU CONSÉCUTIF (Y COMPRIS MAIS SANS S’Y LIMITER, TOUT DOMMAGE RÉSULTANT DE LA PERTE D’USAGE, INTERRUPTION DES ACTIVITÉS, PERTE DE RENSEIGNEMENTS, PERTE OU INEXACTITUDE DES DONNÉES, PERTE DE PROFITS, PERTE D’ÉCONOMIES, LE COÛT D’ACHAT DE MARCHANDISES, SERVICES OU TECHNOLOGIES DE REMPLACEMENT, OU POUR TOUTE QUESTION EN DEHORS DE SON CONTRÔLE RAISONNABLE), RÉSULTANT DE OU RELATIFS à L’UTILISATION OU INCAPACITÉ Dֹ’UTILISATION DE L’APPLICATION, QUE CE SOIT DANS LE CADRE D’UNE ACTION DE RUPTURE DU CONTRAT, DE LA NÉGLIGENCE OU AUTRE ACTION DE DÉLIT CIVIL, MÊME SI Ruud OU L’UNE DE SES SOCIÉTÉS AFFILIÉES A/ONT ÉTÉ EXPRESSÉMENT PRÉVENUE(S) DE LA POSSIBILITÉ DE TELS DOMMAGES. Certains états, provinces ou pays ne permettent pas l’exclusion ou la restriction des dommages directs, indirects, spéciaux ou consécutifs et par conséquent, les restrictions mentionnées ci-dessus pourraient ne pas s’appliquer à votre cas.</p><p class=p3><b>13. STIPULATION D’EXONÉRATION DE GARANTIES :</b> Dans la mesure où la loi le permet, et pour dissiper tout doute, Ruud décline par la présente, toutes les garanties implicites relatives à l’Application. L’Application et le logiciel sont fournis «tels quels» et sont «disponibles» sans aucune garantie.</p><p class=p3><b>14. COMPÉTENCE ET LIEU :</b> Cette Application sera régie et interprétée par les lois de l’État de Géorgie des États-Unis d’Amérique et, en ce qui concerne les droits d’auteur, les marques commerciales et les brevets, par la loi fédérale des États-Unis. En outre, vous convenez que si toute poursuite judiciaire est déposée en raison de l’utilisation ou l’incapacité d’utilisation de l’Application contenue dans cette Application, une telle poursuite sera enregistrée dans le tribunal étatique de la Géorgie ou dans le tribunal de district des États-Unis situé dans le comté de Fulton en Géorgie. En utilisant cette Application, vous consentez irrévocablement à la compétence de ces tribunaux pour tous les conflits issus de ou relatifs à l’utilisation de l’Application.</p><p class=p3><b>15. MODIFICATIONS :</b> Ruud se réserve le droit de modifier ou réviser ces modalités d’utilisation. Veuillez consulter ces modalités d’utilisation régulièrement pour toutes modifications. Votre usage poursuivi de cette Application, suite à l’affichage de modifications de ces modalités d’utilisation, constitue votre acceptation de ces modifications. Ruud peut annuler, modifier, interrompre ou abandonner tout aspect de l’Application, la disponibilité de l’Application ou les caractéristiques de l’Application à tout moment. Ruud peut également imposer des restrictions sur les caractéristiques et services et peut limiter votre accès à l’Application sans préavis ou responsabilité.</p><p class=p3>Votre usage poursuivi de cette Application, suite à l’affichage de révisions des modalités d’utilisation, constitue votre acceptation de ces modifications. Vous êtes tenu de consulter cette page de temps en temps pour vous tenir au courant des modifications, puisqu’elles sont liantes.</p><p class=p3><b>16. DIVISIBILITÉ :</b> Si toute disposition ou portion d’une disposition de ces modalités d’utilisation est considérée inapplicable ou inexécutable pour une raison quelconque, telle inapplicabilité n’affectera pas l’applicabilité du reste de cette disposition et/ou du reste des dispositions de ces modalités d’utilisation qui demeureront applicables et exécutables.</p><p class=p3><b>17. INTÉGRALITÉ DE L’ACCORD :</b> Ces modalités d’utilisation constituent l’intégralité de l’accord entre vous et Ruud, en ce qui a trait à cette Application et remplacent toutes communications et propositions contemporaines ou précédentes par tout moyen entre vous et Ruud.</p><p class=p3><b>18. DIVERS :</b> Tous droits qui ne sont pas expressément accordés par les présentes modalités d’utilisation sont réservés par Ruud et ses sociétés affiliées.</p><p class=p6>Cette Application est fournie par Ruud Manufacturing Company; 1100 Abernathy Rd, Suite 1400; Atlanta, Géorgie 30328</p></div><div id=langSp ng-switch-when=sp><h3>Términos de servicio</h3><p class=p3><b>1. GENERALES:</b> Al instalar la Aplicación (como se define más abajo), usted conviene en estar sujeto a estos términos de uso (“Terminos”). Revíselos cuidadosamente antes de la instalación y/o aceptación.</p><p class=p3><b>2. DEFINICIONES:</b> La “Aplicación” significará el software suministrado por Ruud para ofrecer servicios relacionados con Ruud, los servicios de Ruud y los servicios de los socios de Ruud, el cual será usado en dispositivos Apple® iOS, Android® OS y otros de acceso a través de internet, así como cualquier actualización eventual y cualquier otro software o documentación que permita usar la Aplicación.</p><p class=p3><b>3. ADVERTENCIA DE QUEMADURAS Y CONFIGURACIONES DE TEMPERATURA DE AGUA:</b> La seguridad y el ahorro de energía son factores a tener en cuenta al seleccionar la configuración de temperatura de agua de la configuración del control remoto del calentador de agua al usar esta Aplicación. El agua a temperaturas superiores a 120 °F (49°C) puede causar la muerte o quemaduras severas por agua hirviente. Asegúrese de leer y cumplir con las advertencias enumeradas en el manual del usuario de su calentador de agua e incluidas con este producto. Se corre el riesgo de quemaduras por agua hirviente si la configuración de la temperatura del agua es muy alta. En los hogares donde hay niños pequeños, personas incapacitadas o ancianas, la configuración de temperatura debe ser de 120°F (49°C) o menor, para evitar algún contacto con agua “CALIENTE”.</p><p class=p3><b>4. PROTECCIÓN DE INFORMACIÓN:</b></p><p class=p3>4.1. Cualquier información personal que usted suministre a Ruud al usar la Aplicación será usada por Ruud de acuerdo con su Declaración de Privacidad, como se muestra en la pestaña de Declaración de Privacidad de esta Aplicación. Para acceder a la Aplicación o a algunos de los recursos que brinda, puede que se le solicite suministrar ciertos detalles de inscripción u otra información. Es una condición para el uso de la Aplicación que toda la información que suministre en ella sea correcta, actual y completa. Usted conviene en que toda la información que suministra para inscribirte en la Aplicación o de otra forma, incluyendo, pero sin limitarse al uso de cualquier característica interactiva de la Aplicación, se regirá por nuestra Declaración de Privacidad y usted aprueba todas las acciones que tomemos con respecto a su información conforme a nuestra Declaración de Privacidad.</p><p class=p3>4.2. Si elige, o se le suministra, un nombre de usuario, contraseña o cualquier otra información como parte de nuestros procedimientos de seguridad, usted debe considerar esa información como confidencial y no debe revelarla a ninguna persona o entidad. También acepta que su cuenta es personal y está de acuerdo en no suministrar a nadie el acceso o parte del acceso a esta Aplicación usando su nombre de usuario, contraseña u otra información de seguridad. Usted acepta notificarnos inmediatamente cualquier acceso o uso no autorizado de su nombre de usuario o contraseña o de cualquier otra violación de la seguridad. También está de acuerdo con salir de su cuenta al final de cada sesión. Debe tener especial cuidado al acceder a su cuenta desde una computadora pública o compartida para que otros no puedan ver o guardar su contraseña u otra información personal.</p><p class=p3>4.3. Tenemos derecho a deshabilitar cualquier nombre de usuario, contraseña u otro identificador, ya sea escogido por usted o proporcionado por nosotros, en cualquier momento y a nuestro criterio, con o sin razón, incluyendo si se ha violado, en nuestra opinión, alguna disposición de estos Términos de Uso.</p><p class=p3><b>5. DERECHOS EXCLUSIVOS Y LICENCIA:</b></p><p class=p3>5.1. Todas las marcas registradas, derechos de propiedad, derechos de base de datos y otros derechos de propiedad intelectual de cualquier naturaleza en la Aplicación al igual que el código de software subyacente, son propiedad directa de Ruud o sus socios.</p><p class=p3>5.2. Por este medio Ruud brinda una licencia revocable, sin pago de derechos de autor y no exclusiva, para usar la Aplicación de forma personal o comercial conforme a estos términos.</p><p class=p3><b>6. PROPIEDAD Y MODIFICACIÓN DE LA APLICACIÓN:</b> Usted acepta que el título, propiedad y todos los derechos de propiedad intelectual en y de la Aplicación y de cualquier copia de la Aplicación son propiedad de y permanecen con Ruud y sus compañías afiliadas, a menos que se especifique de otra forma. Esta Aplicación puede cambiarse, mejorarse o actualizarse periódicamente en cualquier momento y sin aviso. Ruud también puede hacer mejoras y/o cambios en los productos a los que se hace referencia en la Aplicación sin aviso. Para obtener la información más actual del producto, hojas de datos, información técnica y otros detalles acerca de la Aplicación, puede contactar a Ruud directamente a través de la información de contacto suministrada en el manual del usuario.</p><p class=p3><b>7. CONDICIONES DE USO:</b></p><p class=p3>7.1. Ni usted ni terceros en su nombre (i) harán ni distribuirán copias de la aplicación, (ii) ni intentarán copiar, reproducir, cambiar, modificar, aplicar un proceso de ingeniería a la inversa, desarmar, descompilar, transferir, intercambiar o traducir la Aplicación; (iii) ni crear trabajos de ningún tipo derivados de la Aplicación.</p><p class=p3>7.2. La Aplicación está disponible ahora para usted gratuitamente en calidad de uso personal, no comercial. Ruud se reserva el derecho a enmendar o retirar la Aplicación, o a cobrar por la Aplicación o servicios prestados a usted conforme a estos términos, en cualquier momento y por cualquier motivo.</p><p class=p3>7.3. Usted acepta que los términos del acuerdo con sus respectivos suministradores de red móvil (Proveedor Móvil) o suministrador de acceso a internet (Proveedor de Internet) continuarán siendo válidos al usar la Aplicación. En consecuencia puede que el Proveedor Móvil o el Proveedor de Internet le cobren por el acceso a servicios de conexión por red durante la conexión al acceder a la Aplicación o cualquier cargo de terceros que pueda surgir. Usted acepta la responsabilidad por tales cargos que puedan surgir.</p><p class=p3>7.4. Si no es usted quien paga la factura del teléfono móvil, de la computadora o del dispositivo portátil usado para acceder a la Aplicación, se asumirá que ha recibido permiso de quien paga la factura por el uso de la Aplicación.</p><p class=p3><b>8. MATERIALES DE TERCEROS:</b> La Aplicación puede permitir el acceso a servicios y sitios web de Ruud y de terceros (de manera colectiva e individual, “Servicios”). El uso de servicios puede requerir acceso a internet y aceptar términos de servicio adicionales.</p><p class=p3>8.1. Usted entiende que al usar cualquiera de estos servicios, puedes encontrar contenido que se considere ofensivo, indecente, o desagradable, el cual puede contener o no lenguaje explícito, y que el resultado de tal búsqueda o ingreso de una URL en particular puede automática e involuntariamente generar enlaces o referencias a materiales reprobables. Sin embargo, acepta usar los Servicios a su propio riesgo y que Ruud no tiene ninguna responsabilidad con usted por contenido que pueda ser ofensivo, indecente y desagradable.</p><p class=p3>8.2. Ciertos Servicios pueden mostrar, incluir o tener disponible contenido, datos, información, aplicaciones o materiales de terceros (“Materiales de Terceras Partes”) o suministrar enlaces a ciertos sitios web de terceros. Al usar los Servicios, usted reconoce y acepta que Ruud no es responsable por examinar o evaluar el contenido, exactitud, integridad, oportunidad, vigencia, cumplimiento con los derechos de propiedad, legalidad, decencia, calidad o cualquier otro aspecto de tales materiales o sitios web de terceros. Ruud no garantiza ni respalda y no asume ni tendrá responsabilidad alguna con usted ni con cualquier otra persona por Servicios, Materiales o sitios web de terceros, o por cualesquiera otros materiales, productos, o servicios de terceros. Los Materiales y enlaces de terceros a otros sitios web se suministran ya sólo como conveniencia para usted.</p><p class=p3>8.3. Usted acepta que si cualquier Servicio incluye contenido exclusivo, información y material protegido por leyes de propiedad intelectual aplicables u otras, incluyendo, pero no limitado a los derechos de propiedad, no usará ese contenido exclusivo, información o materiales de ninguna forma, excepto de la forma permitida por el uso de los Servicios. Ninguna parte de los Servicios puede ser reproducida de ninguna forma ni por ningún medio. Usted acepta no modificar, alquilar, arrendar, prestar, vender, distribuir, o crear trabajos derivados basados en los Servicios, de forma alguna, y no explotar los Servicios de ninguna manera no autorizada, incluyendo, pero sin limitarse a, la violación o sobrecarga de la capacidad de la red.</p><p class=p3>8.4. Además, los Servicios y Materiales de Terceros a los que se pudiera tener acceso, mostrarse en o enlazarse desde la Aplicación no están disponibles en todos los idiomas ni en todos los países. Ruud no garantiza que tales Servicios y Materiales sean apropiados o estén disponibles para su uso en determinado lugar. Usted decide hasta donde accede a tales Servicios o Materiales y es responsable por el cumplimiento de las leyes aplicables, incluyendo, pero sin limitarse a, las leyes locales aplicables. Ruud, y quien otorga su licencia, se reservan el derecho a cambiar, suspender, eliminar o deshabilitar el acceso a cualquier Servicio en cualquier momento sin aviso. De ninguna forma Ruud será responsable por la eliminación o deshabilitación del acceso a tales Servicios. Ruud también puede imponer límites al uso de o acceso a ciertos Servicios, en cualquier caso y sin aviso ni obligación.</p><p class=p3><b>9. DISPONIBILIDAD:</b></p><p class=p3>9.1. Esta Aplicación está disponible para dispositivos móviles portátiles con sistemas operativos Apple® iOS y Android® OS, así como para otros dispositivos con acceso a internet. Ruud hará todo lo razonablemente posible para que la Aplicación siempre esté disponible. Sin embargo, usted acepta que la Aplicación se ofrece a través de internet y redes móviles y, por tanto, la calidad y disponibilidad puede verse afectada por factores fuera del control razonable de Ruud.</p><p class=p3>9.2. Ni Ruud ni su grupo de compañías y subcontratistas aceptan responsabilidad alguna por la no disponibilidad de la Aplicación, o por cualquier dificultad o incapacidad de descargar o acceder a contenido, o por cualquier otra falla del sistema de comunicación que pueda ocasionar que la Aplicación no esté disponible.</p><p class=p3><b>10. REQUERIMIENTOS DEL SISTEMA:</b></p><p class=p3>10.1. Para poder usar la Aplicación, usted debe tener un teléfono móvil o dispositivo portátil compatible y acceso a internet, así como cumplir con las especificaciones mínimas necesarias (“Requerimientos de Software”).</p><p class=p3>10.2. Los Requerimientos de Software son los siguientes: Apple iOS, Android OS or Internet Explorer 8 o superior; Idioma: Inglés. Al actualizarse la Aplicación, los Requerimientos de Sistema también pueden actualizarse. Eres responsable por la descarga u obtención de las actualizaciones adecuadas para poder seguir usando la Aplicación en tu dispositivo móvil o de acceso por internet.</p><p class=p3>10.3. La versión del software de la Aplicación puede ser actualizada de vez en cuando para agregar soporte para nuevas funciones y servicios.</p><p class=p3><b>11. CANCELACIÓN:</b></p><p class=p3>11.1. Ruud puede cancelar el uso de la Aplicación en cualquier momento con sólo notificar a usted la cancelación.</p><p class=p3>11.2. Con la cancelación (a) se dan por terminados los derechos y licencias otorgados a usted; (b) usted tiene que dejar de usar la Aplicación.</p><p class=p3><b>12. LÍMITES DE RESPONSABILIDAD:</b></p><p class=p3>12.1. En ningún caso, Ruud será responsable por cualquier pérdida o daño directo, indirecto, especial, disciplinario, ilustrativo o secundario que surja de su uso de o acceso a la Aplicación, incluyendo daños considerados o no por las partes, ya sean basados en una violación de contrato, agravio (incluyendo negligencia), responsabilidad por el producto u de otra manera.</p><p class=p3>12.2. Ruud no es responsable ante usted por ningún daño o modificación de su equipo incluyendo, pero sin limitarse a, equipos de computadora, dispositivos portátiles, o teléfonos móviles, como resultado de la instalación o uso de la Aplicación.</p><p class=p3>12.3. Nada en estos términos excluirá o limitará la responsabilidad de Ruud por la muerte o lesiones personales causadas por negligencia o fraude o distorsión fraudulenta o cualquier otra responsabilidad que no pueda ser excluida o limitada bajo la ley aplicable.</p><p class=p3>12.4. La Aplicación en esta Aplicación puede contener inexactitudes técnicas o errores de tipografía. Ruud no garantiza la exactitud ni integridad del contenido de la Aplicación ni la fiabilidad de cualquier dispositivo, opinión, declaración u otra información mostrada o distribuida a través de esta Aplicación. Usted reconoce que sólo por su propio riesgo podrá confiar en tal dispositivo, opinión, declaración u otra información. Ni Ruud ni sus asociados asumen responsabilidad alguna por cualquier daño, responsabilidad u otra pérdida que surja de su uso de la Aplicación, o por cualquier reclamación de violación de los derechos de una tercera parte, o por una violación de secreto comercial que surja como resultado de tu uso de la Aplicación. EN NINGÚN CASO Ruud O SUS COMPAÑÍAS AFILIADAS SERÁN RESPONSABLES ANTE CUALQUIER PERSONA O ENTIDAD POR CUALQUIER DAÑO DIRECTO, INDIRECTO, CASUAL, DISCIPLINARIO, ESPECIAL O SECUNDARIO (INCLUYENDO, SIN LIMITACIÓN, CUALQUIER DAÑO QUE RESULTE DE LA PÉRDIDA DE USO, INTERRUPCIÓN DE NEGOCIOS, PÉRDIDA DE INFORMACIÓN, PÉRDIDA O INEXACTITUD DE INFORMACIÓN, PÉRDIDA DE GANANCIAS, PÉRDIDA DE AHORROS, COSTO POR ADQUISICIÓN DE BIENES SUSTITUIDOS, SERVICIOS O TECNOLOGÍAS, O POR CUALQUIER CAUSA MÁS ALLÁ DE SU CONTROL RAZONABLE), QUE SURJA DE O EN RELACIÓN CON EL USO O IMPOSIBILIDAD DE USO DE LA APLICACIÓN, YA SEA EN UNA ACCIÓN POR VIOLACIÓN DE CONTRATO, NEGLIGENCIA, U OTRA ACCIÓN DE AGRAVIO, INCLUSO SI Ruud O ALGUNA DE SUS COMPAÑÍAS AFILIADAS FUERON ADVERTIDOS SOBRE LA POSIBILIDAD DE TALES DAÑOS. Algunos estados no permiten la exclusión o limitación de ciertos daños directos, casuales, especiales o secundarios, por lo cual las limitaciones expuestas más arriba pudieran no aplicarse a usted.</p><p class=p3><b>13. EXENCIÓN DE RESPONSABILIDAD DE GARANTÍAS:</b> Por medio de la presente, hasta el punto máximo permitido por la ley y para evitar cualquier duda, Ruud excluye todas las garantías implícitas con relación a la Aplicación. La Aplicación y el software se suministran “en el estado en que se encuentran” y “de la forma disponible”, sin garantía de tipo alguno.</p><p class=p3><b>14. JURISDICCIÓN Y SEDE:</b> Esta Aplicación debe regirse e interpretarse según las leyes del estado de Georgia de los Estados Unidos de América y, en cuanto a a los temas relacionados con los derechos de propiedad, marcas registradas y patentes, según las leyes federales de los Estados Unidos. Además, usted acepta que si se entabla una acción legal como resultado del uso o imposibilidad de uso de la Aplicación contenida en esta Aplicación, tal acción debe presentarse en la Corte de estado de Georgia o en la Corte de Distrito de los Estados Unidos ubicada en el Condado Fulton, Georgia. Al usar esta Aplicación, usted acepta irrevocablemente la jurisdicción de esas cortes para todas las disputas que surjan o estén relacionadas con el uso de la Aplicación.</p><p class=p3><b>15. MODIFICACIONES:</b> Ruud se reserva el derecho a cambiar o revisar estos Términos de Uso. Revise periódicamente estos Términos de Uso para verificar si ha habido cambios o modificaciones. El uso continuado de esta Aplicación después de la publicación de modificaciones de estas condiciones de uso constituye una aceptación de estos cambios. Ruud puede cancelar, cambiar, suspender o interrumpir cualquier aspecto de la Aplicación, disponibilidad de la Aplicación, o características de la Aplicación en cualquier momento. Ruud también puede imponer restricciones a características o servicios y puede limitar su acceso a la Aplicación sin aviso o responsabilidad.</p><p class=p3>El uso continuado de la Aplicación después de la publicación de estas condiciones de uso modificadas significa que acepta y está de acuerdo con los cambios Esperamos que revise esta página de vez en cuando para conocer los cambios, pues son de obligatorio cumplimiento.</p><p class=p3><b>16. SUBSISTENCIA:</b> Si una disposición o parte de una disposición de estos Términos de Uso es invalidada o es inaplicable por cualquier motivo, tal invalidación no afectará al resto de esa disposición ni a las disposiciones restantes de estos Términos de Uso, que seguirán siendo válidos y aplicables.</p><p class=p3><b>17. ACUERDO COMPLETO:</b> Estos Términos de Uso constituyen el acuerdo completo entre usted y Ruud con respecto a esta Aplicación y reemplaza todas las comunicaciones previas o contemporáneas y propuestas por cualquier medio entre usted y Ruud.</p><p class=p3><b>18. MISCELÁNEAS:</b> Cualquier derecho no otorgado expresamente en estos Términos de Uso se reservan por Ruud y sus compañías afiliadas.</p><p class=p5><br></p><p class=p6>Esta Aplicación se provee por Ruud Manufacturing Company; 1100 Abernathy Rd, Suite 1400; Atlanta, GA 30328</p></div></md-content>");
$templateCache.put("app/settings/_troubleshooting.html","<md-content class=md-padding><h2>Application Troubleshooting.</h2><p>Close App If you experience any issues with the app, try closing and re-launching the application. If that doesn’t resolve the issue, check to see if there are any updates available by visiting the app store for your device to download the latest version of the app. If you continue to experience issues, please contact our support team at econet@ruud.com</p><h2>Equipment Troubleshooting</h2><h3>Problem</h3><p>Rumbling noise</p><h4>Possible Causes</h4><p>Water conditions in your home caused a build up of scale or mineral deposits on the heating elements.</p><h4>What To Do</h4><p>Remove and clean the heating elements.</p><h3>Problem</h3><p>Relief valve producing popping noise or draining</p><h4>Possible Causes</h4><p>Pressure build up caused by thermal expansion in a closed system.</p><h4>What to do</h4><p>This is an unacceptable condition and must be corrected.Contact the water supplier or plumbing contractor onhow to correct this. Do not plug the relief valve outlet.</p><h3>Problem</h3><p>Rattling noise during periods of water usage</p><h4>Possible Causes</h4><p>Internal heat trap fittings in operation.</p><h4>What to do</h4><p>This is normal for heat trap fittings when in operation and does not indicate a need for service.</p><h3>Problem</h3><p>Not enough or no hot water</p><h4>Possible Causes</h4><p>Water usage may have exceeded the capacity of the water heater.</p><h4>What to Do</h4><p>Wait for the water heater to recover after an abnormal demand.</p><h4>Possible Causes</h4><p>A fuse is blown or a circuit breaker tripped</p><h4>What to Do</h4><p>Replace fuse or reset circuit breaker.</p><h4>Possible Causes</h4><p>Electric supply may be off.</p><h4>What to Do</h4><p>Make sure electric supply to water heater and disconnect switch, if used, are in the ON position.</p><h4>Possible Causes</h4><p>The thermostat may be set set too low.</p><h4>What to Do</h4><p>See the Temperature regulation of the water heater section of the user manual.</p><h4>Possible Causes</h4><p>Leaking or open hot water faucets.</p><h4>What to Do</h4><p>Make sure all faucets are closed.</p><h4>Possible Causes</h4><p>Electric service to your home may be interrupted.</p><h4>What to Do</h4><p>Contact the local electric utility.</p><h4>Possible Causes</h4><p>Improper wiring.</p><h4>What to Do</h4><p>See the Installing the water heater section of the user manual.</p><h4>Possible Causes</h4><p>Manual reset limit (ECO).</p><h4>What to Do</h4><p>See the Temperature regulation of the water heater section of the user manual.</p><h4>Possible Causes</h4><p>Cold water inlet temperature may be colder during the winter months.</p><h4>What to Do</h4><p>This is normal. The colder inlet water takes longer toheat.</p><h3>Problem</h3><p>Water is too hot</p><h4>Possible Cause</h4><p>The thermostat is set too high.</p><h4>What to Do</h4><p>See the Temperature regulation of the water heater section of this manual. Cannot set above 140°F</p><h3>Problem</h3><p>Cannot set above 140°F</p><h4>Possible Cause</h4><p>Water heaters are not allowed to be set above 140°F</p><h4>What to Do</h4><p>This is as designed for your safety.</p></md-content>");
$templateCache.put("app/settings/settings.html","<div id=settings layout=row><md-sidenav md-component-id=settings class=\"md-sidenav-right md-whiteframe-z2\"><div layout=column layout-fill class=nav-container><md-toolbar layout=column><div layout=row class=md-toolbar-tools><div layout=column layout-align=\"center start\" flex=15 class=column><md-button ng-if=\"vm.settingsIndex === 0\" ng-click=vm.close()>Done</md-button><md-button ng-if=\"vm.settingsIndex &gt; 0\" ng-click=vm.back()>Back</md-button></div><div layout=column layout-align=\"center center\" flex class=column><span class=banner-bold>{{vm.crumb[vm.settingsIndex].header}}</span></div><div layout=column ng-if=\"vm.crumb.length === 1\" flex=15 layout-align=\"center end\" class=column><md-button ui-sref=logout>Log Out</md-button></div></div></md-toolbar><md-tabs layout=column md-selected=vm.settingsIndex flex md-no-ink-bar><md-tab label=menu><md-content><ul ng-cloak class=side-menu><li ng-repeat=\"section in vm.menu.sections\" ng-class=\"{\'parentActive\' : vm.isSectionSelected(section)}\" class=parent-list-item><menu-link section=section ng-if=\"section.type === \'link\'\"></menu-link><menu-toggle section=section ng-if=\"section.type === \'toggle\'\"></menu-toggle><menu-external section=section ng-if=\"section.type === \'external\'\"></menu-external><menu-static section=section ng-if=\"section.type === \'static\'\"></menu-static></li></ul></md-content></md-tab><md-tab label=detail><div layout=column layout-fill on-finish=vm.load(vm.crumb[1].name) static-include={{vm.crumb[1].name}}></div></md-tab><md-tab label=detail2><div layout=column layout-fill static-include={{vm.crumb[2].name}}></div></md-tab></md-tabs></div></md-sidenav></div>");
$templateCache.put("app/vacation/vacation.footer.html","<div id=vacationFooter layout=row layout-align=center flex><div ng-show=!vm.vacation.vacation layout layout-align=center flex class=vacationInactive><md-button layout ng-disabled=\"vm.data.locations.length === 0\" layout-align=space-around ui-sref=locations.vacation class=vacationButton><icon name=icon-briefcase></icon><span>Enable Vacation Mode</span></md-button></div><div ng-show=vm.vacation.vacation layout layout-align=center flex class=vacationAlert><div layout=column class=column><icon name=icon-briefcase></icon></div><div layout=column layout-align=\"center start\" class=column><div class=banner-bold>Vacation Mode Active</div><div class=banner-regular>Ends {{vm.vacation.vacation.endDate | date:\'MMM d, yyyy h:mma\' }}</div></div><div layout=column class=column><md-button ui-sref=locations.vacation>EDIT</md-button></div></div></div>");
$templateCache.put("app/vacation/vacation.html","<equipment-toolbar title={{vm.data.location.name}}></equipment-toolbar><md-content id=vacation flex class=md-padding><h3 ng-if=!vm.data.vacation>Create Vacation</h3><h3 ng-if=vm.data.vacation>Edit Vacation</h3><md-subheader class=md-no-sticky>When is your Vacation?</md-subheader><md-list><md-list-item><span>Start Time</span> <input mdc-datetime-picker date=true time=true type=text short-time=true placeholder=\"Start Time\" min-date=vm.startTime format={{vm.format}} ng-model=vm.settings.startDate class=\"date-time-input md-secondary\"><md-divider></md-divider></md-list-item><md-list-item><p>End Time</p><input mdc-datetime-picker date=true time=true type=text short-time=true placeholder=\"End Time\" min-date=vm.startTime format={{vm.format}} ng-model=vm.settings.endDate class=\"date-time-input md-secondary\"></md-list-item></md-list><md-subheader class=md-no-sticky>Select HVAC Systems to go on Vacation</md-subheader><md-list layout=column ng-repeat=\"equipment in vm.data.location.equipment | filter: {type: &quot;HVAC&quot;}\" class=items><div layout=row layout-align=\"space-between center\" ng-click=\"vm.select(categoryIndex, settingIndex)\" class=item><span><icon name=Air></icon><span>{{equipment.name}}{{equipment.isConnected?\'\':\' (disconnected)\'}}</span></span><md-checkbox ng-checked=\"vm.exists(equipment.id, vm.settings.participatingEquipment)\" ng-click=\"vm.toggle(equipment.id, vm.settings.participatingEquipment, equipment)\" ng-disabled=!equipment.isConnected aria-label={{equipment.name}}></md-checkbox></div><div ng-show=\"vm.exists(equipment.id, vm.settings.participatingEquipment)\" layout=column layout-align=\"start center\" class=itemExpanded><div class=header>Configure Settings for HVAC Systems</div><div layout=row class=row><selector prev=\"vm.decreasePoint(&quot;heatSetPoint&quot;, equipment)\" next=\"vm.increasePoint(&quot;heatSetPoint&quot;, equipment)\"><h4>Heat</h4><div class=\"equipment-value heat\">{{vm.settings.heatSetPoint | temperature}}</div></selector><selector prev=\"vm.decreasePoint(&quot;coolSetPoint&quot;, equipment)\" next=\"vm.increasePoint(&quot;coolSetPoint&quot;, equipment)\"><h4>Cool</h4><div class=\"equipment-value cool\">{{vm.settings.coolSetPoint | temperature}}</div></selector><selector prev=vm.decreaseFanMode() next=vm.increaseFanMode()><h4>Fan</h4><div class=\"fanMode equipment-value\">{{vm.settings.fanMode}}</div></selector></div></div></md-list><md-subheader class=md-no-sticky>Select Water Heaters to go on Vacation</md-subheader><md-list ng-repeat=\"equipment in vm.data.location.equipment | filter: {type: &quot;Water Heater&quot;}\" class=items><div layout=row layout-align=\"space-between center\" ng-click=\"vm.select(categoryIndex, settingIndex)\" class=item><span><icon name=Water></icon><span>{{equipment.name}}{{equipment.isConnected?\'\':\' (disconnected)\'}}</span></span><md-checkbox ng-checked=\"vm.exists(equipment.id, vm.settings.participatingEquipment)\" ng-click=\"vm.toggle(equipment.id, vm.settings.participatingEquipment, equipment)\" ng-disabled=!equipment.isConnected aria-label={{equipment.name}}></md-checkbox></div></md-list><div layout layout-align=center class=vacation-controls><md-button ng-click=vm.create() ng-if=!vm.data.vacation ng-disabled=!vm.settings.participatingEquipment.length class=\"md-raised md-primary large\">Schedule Vacation</md-button><md-button ng-click=vm.update() ng-if=\"vm.data.vacation &amp;&amp; vm.settings.participatingEquipment.length\" class=\"md-raised md-primary large\">Save Changes</md-button><md-button ng-click=vm.delete() ng-if=vm.data.vacation class=\"md-raised md-warn large\">End Vacation</md-button></div></md-content>");
$templateCache.put("app/components/dialogs/dialogs.html","<md-dialog ng-class=\"{fullscreen: content.fullscreen}\" layout=column layout-align=\"center center\" class=alert><md-toolbar ng-style=content.style layout-align=\"center center\"><p class=title>{{content.title}}</p></md-toolbar><md-dialog-content layout=column flex=80 layout-align=\"center center\"><p ng-bind-html=content.description></p></md-dialog-content><md-dialog-actions ng-if=\"content.type !== &quot;alert&quot;\" layout=row><div layout flex=50 layout-align=center class=row><md-button ng-click=cancelDialog() class=\"md-primary red\">{{content.cancel}}</md-button></div><div layout flex=50 layout-align=center class=row><md-button ng-click=closeDialog() class=\"md-primary blue\">{{content.ok}}</md-button></div></md-dialog-actions><md-dialog-actions ng-if=\"content.type === &quot;alert&quot;\" layout=row><div layout flex=100 layout-align=center class=row><md-button ng-click=closeDialog() class=\"md-primary blue\">{{content.ok}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/elements/appStore.html","<div layout=column flex=noshrink class=app-store-block><p class=app-store-text>Control your Ruud EcoNet system with leading mobile and tablet devices. The apps are powerful - and absolutely free.</p><div layout=row class=app-store-buttons><a ng-repeat=\"store in stores\" ng-href={{store.link}}><img ng-src={{store.image}}></a></div></div>");
$templateCache.put("app/components/elements/icon.html","<md-icon md-font-icon={{mode.icon.name}}><span ng-repeat=\"icon in ::mode.icon.path\" class={{::icon}}></span></md-icon>");
$templateCache.put("app/components/elements/selector.html","<div ng-if=isHorizontal layout=row flex layout-align=\"space-between center\" style=\"flex-direction: row-reverse\" class=controls><md-button layout=column layout-align=\"end center\" ng-class=\"{disabled: isDisabled}\" ng-disabled=isDisabled ng-click=next() aria-label=Increase><icon name=\"Arrow Plus\"></icon></md-button><div layout=column layout-align=center ng-transclude class=label></div><md-button layout=column layout-align=\"end center\" ng-class=\"{disabled: isDisabled}\" ng-disabled=isDisabled ng-click=prev() aria-label=Decrease><icon name=\"Arrow Minus\"></icon></md-button></div><div ng-if=!isHorizontal layout=column flex class=controls><md-button layout=column layout-align=\"end center\" ng-class=\"{disabled: isDisabled}\" ng-disabled=isDisabled ng-click=next() aria-label=Increase><icon name=\"Arrow Plus\"></icon></md-button><div layout=column layout-align=center ng-transclude class=label></div><md-button layout=column layout-align=\"end center\" ng-class=\"{disabled: isDisabled}\" ng-disabled=isDisabled ng-click=prev() aria-label=Decrease><icon name=\"Arrow Minus\"></icon></md-button></div>");
$templateCache.put("app/components/elements/toolbar.html","<md-toolbar layout=column><div layout=row flex layout-align=\"start center\" class=md-toolbar-tools><div layout=column flex=none class=column><md-button ui-sref=^>{{buttonText || \'Back\'}}</md-button></div><div layout=column flex layout-align=\"center center\" class=\"column banner-text\"><div class=banner-bold>{{title}}</div></div><div layout=column flex=none hide-xs class=\"column empty\"></div></div></md-toolbar>");
$templateCache.put("app/components/navbar/navbar.html","<div layout=row flex class=row><img src=./assets/images/smile.svg class=smile><div layout=column flex=20 layout-align=\"center start\" layout-align-gt-md=\"center end\" class=column><a ui-sref=locations><img src=./assets/images/logo_Ruud.png class=logo></a></div><div layout=column flex layout-align=\"center center\" class=column><img src=./assets/images/ECONET_Logo_Layered_with_TM.svg hide show-gt-md class=econet></div><div layout=column flex=20 layout-align=center class=column><div layout=row layout-align=\"end center\" class=\"row button-container\"><md-button ng-click=\"vm.openSidenav(&quot;alerts&quot;, {name: &quot;root&quot;})\" aria-label=alerts md-no-ink><icon name=icon-caution></icon><div ng-show=\"vm.alerts.newAlertCount &gt; 0\" class=\"unread-messages bold\">{{vm.alerts.newAlertCount}}</div></md-button><md-button ng-click=\"vm.openSidenav(&quot;settings&quot;, {name: &quot;root&quot;})\" aria-label=settings md-no-ink><icon name=icon-cog></icon></md-button></div></div></div>");
$templateCache.put("app/components/navbar/navbarLogin.html","<div layout=row flex rm-class-height-gt=\"{&quot;hidden&quot;: &quot;590&quot;}\" class=row><img src=./assets/images/smile.svg class=smile><div layout=column flex=15 flex-gt-md=33 layout-align=\"center center\" class=column><img ui-sref=login src=./assets/images/logo_Ruud.png class=logo></div><div layout=column flex=70 flex-gt-md=33 layout-align=\"center center\" class=column><img src=./assets/images/tagline_intergrated_homes_comfort.png class=comfort></div></div>");
$templateCache.put("app/components/registration/addEquipment.html","<div layout=row layout-align=\"space-between end\" class=row><h1>Equipment setup</h1></div><div layout=column class=formContainer><md-input-container ng-repeat=\"equipment in locationData.location.equipment | filter: {type: \'!WiFi Adapter\', connectedSystem: { macAddress: newLocation.adapterMACAddress}} | orderBy: \'name\'\"><label>{{equipment.subType}}</label><input ng-model=equipmentData[equipment.id].name ng-blur=updateEquipment(equipment.id) ng-init=\"equipmentData[equipment.id].originalName = equipment.name; equipmentData[equipment.id].name = equipment.name\"></md-input-container><p>Select a name for your equipment and hit continue.</p></div><div layout=column class=check-button><md-button ng-if=!lastStep() ng-click=next() class=\"md-raised md-primary large\">Next</md-button><md-button ng-if=lastStep() ng-click=onFinish() class=\"md-raised md-primary large\">Done</md-button></div>");
$templateCache.put("app/components/registration/addLocation.html","<div layout=row layout-align=\"space-between end\" class=row><h1>Location setup</h1></div><form name=addLocationForm layout=column ng-submit=\"addLocationForm.$valid &amp;&amp; zipcodeVerified &amp;&amp; createLocation(newLocation)\" novalidate><div layout=column class=formContainer><md-input-container ng-if=::!newLocation.adapterMACAddress><label>Mac Address</label><input ng-model=newLocation.adapterMACAddress ui-mask=HH-HH-HH-HH-HH-HH model-view-value=true name=adapterMACAddress required><div ng-messages=addLocationForm.adapterMACAddress.$error ng-show=addLocationForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><md-input-container><label>Location Name</label><input ng-model=newLocation.name name=name></md-input-container><md-input-container><label>ZIP Code</label><input ng-model=newLocation.zipCode type=text maxlength=5 ng-minlength=5 ng-change=\"zipcodeVerified = false || addLocationForm.zipCode.$valid &amp;&amp; validateZipCode(newLocation.zipCode, newLocation)\" name=zipCode required><div ng-messages=addLocationForm.zipCode.$error ng-show=addLocationForm.$submitted role=alert><div ng-message=required>Required Field</div><div ng-message=minlength>Please enter a valid zipcode</div></div></md-input-container><p ng-if=newLocation.city>{{newLocation.city + \', \' + newLocation.state}}</p></div><div layout=column layout-align=\"center center\" class=check-button><md-button type=submit class=\"md-raised md-primary large\">Save</md-button></div></form>");
$templateCache.put("app/components/registration/addLocationTutorial.html","<md-tabs md-dynamic-height md-selected=tutorialIndex><md-tab label=one><img src=./assets/images/tutorial_1@3x.png><h4 class=uppercase>Step One</h4><p>Locate your equipment\'s wifi module and press the button at the bottom. Wait until the lights are flashing.</p><md-button ng-click=nextSlide() class=\"md-raised md-primary\">Next</md-button></md-tab><md-tab label=two><img src=./assets/images/tutorial_2@3x.png><h4 class=uppercase>Step Two</h4><p>Connecting to your wifi module will require you to connect to it with a WiFI enabled PC or phone.</p><p><span class=bold>Note: </span>Device will need to be within range of the wifi module.</p><md-button ng-click=\"nextSlide(); detectNetworkChange()\" class=\"md-raised md-primary\">Connect using this device</md-button></md-tab><md-tab label=three><img src=./assets/images/tutorial_3-2@3x.png><h4>STEP THREE</h4><p>Open your Wireless settings from this device, then select the \"EcoNet\" network from the list to connect to it.</p><p>The Next button will highlight when a network change is detected.</p><md-button ng-disabled=!ready ng-click=next() class=\"md-raised md-primary\">Next</md-button></md-tab></md-tabs>");
$templateCache.put("app/components/registration/connectModule.html","<h1>Connect your router</h1><div class=fill-container><module-iframe ng-if=iframeVisible on-finish-loading=onFinish() on-connection-success=successConnect(event)></module-iframe></div>");
$templateCache.put("app/components/registration/notificationPreferences.html","<div id=notificationPreferences><h1>Notification Preferences</h1><md-list layout=column><md-list-item><p>Text Alerts</p><md-switch ng-model=notifications.allowTextNotifications aria-label=\"Text Notifications\" class=md-secondary></md-switch><md-divider ng-hide=notifications.allowTextNotifications class=md-inset></md-divider></md-list-item><md-list-item ng-show=notifications.allowTextNotifications layout=row><md-input-container class=md-secondary><label>Enter Phone Number</label><input type=text ng-model=identity.phone ui-mask=\"(999) 999-9999\"></md-input-container><md-divider class=md-inset></md-divider></md-list-item><md-list-item><p>Email Alerts</p><md-switch ng-model=notifications.allowEmailNotifications aria-label=\"Email Notifications\" class=md-secondary></md-switch><md-divider class=md-inset></md-divider></md-list-item><md-list-item><p>Marketing Messages</p><md-switch ng-model=notifications.receiveMarketingMessages aria-label=\"Receive Marketing Messages\" class=md-secondary></md-switch><md-divider class=md-inset></md-divider></md-list-item><p>A mobile phone number is necessary in order to receive SMS notifications.</p><md-button ng-click=finishRegistration() class=\"md-raised md-primary large\">Continue</md-button></md-list></div>");
$templateCache.put("app/components/registration/provision.html","<md-tabs flex layout=column md-selected=stepIndex md-center-tabs md-dynamic-height md-no-ink-bar><md-tab layout=column flex ng-repeat=\"step in steps\" label={{step}}><div layout=column class={{step}}><terms ng-if=\"step === &quot;terms&quot; &amp;&amp; stepIndex === $index\" layout=column></terms><register-account ng-if=\"step === &quot;register-account&quot; &amp;&amp; stepIndex === $index\" layout=column></register-account><add-location-tutorial ng-if=\"step === &quot;add-location-tutorial&quot; &amp;&amp; stepIndex === $index\" layout=column></add-location-tutorial><connect-module ng-if=\"step === &quot;connect-module&quot; &amp;&amp; stepIndex === $index\" layout=column></connect-module><add-location ng-if=\"step === &quot;add-location&quot; &amp;&amp; stepIndex === $index\" layout=column></add-location><add-equipment ng-if=\"step === &quot;add-equipment&quot; &amp;&amp; stepIndex === $index\" layout=column></add-equipment><notification-preferences ng-if=\"step === &quot;notification-preferences&quot; &amp;&amp; stepIndex === $index\" layout=column></notification-preferences></div></md-tab></md-tabs>");
$templateCache.put("app/components/registration/registerAccount.html","<form name=registerForm layout=column ng-submit=\"registerForm.$valid &amp;&amp; register()\" novalidate><h1>Create an account</h1><md-input-container><label>Email</label><input ng-model=user.email name=email required ng-pattern=/^.+@.+..+$/ ><div ng-messages=registerForm.email.$error ng-show=registerForm.$submitted role=alert><div ng-message=required>Required Field</div><div ng-message=pattern>Please enter a valid email.</div></div></md-input-container><md-input-container><label>Confirm Email</label><input ng-model=user.emailConfirm name=emailConfirm required><div ng-messages=registerForm.emailConfirm.$error ng-show=registerForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><md-input-container><label>Password</label><password-field><input ng-model=user.password name=password required autocomplete=off type=password></password-field><div ng-messages=registerForm.password.$error type=password ng-show=registerForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><md-input-container><label>Confirm Password</label><password-field><input ng-model=user.passwordConfirm name=passwordConfirm required autocomplete=off type=password></password-field><div ng-messages=registerForm.passwordConfirm.$error type=password ng-show=registerForm.$submitted role=alert><div ng-message=required>Required Field</div></div></md-input-container><p>{{error}}</p><md-button type=submit class=\"md-raised md-primary large\">Next</md-button></form>");
$templateCache.put("app/components/registration/terms.html","<ng-include src=\"\'app/settings/_termsOfService.html\'\"></ng-include><md-button ng-click=next() class=\"md-raised md-primary large\">Accept</md-button>");
$templateCache.put("app/settings/menu/_menu-external.html","<md-button ng-class=\"{\'{{::section.icon}}\' : true}\" ui-sref-active=active ng-href={{::section.state}} ng-click=focusSection()>{{::section | humanizeDoc}}<span ng-if=isSelected() class=md-visually-hidden>current page</span></md-button>");
$templateCache.put("app/settings/menu/_menu-link.html","<md-button ng-class=\"{\'{{::section.icon}}\' : true}\" ui-sref-active=active ng-click=focusSection()>{{::section | humanizeDoc}}<span ng-if=isSelected() class=md-visually-hidden>current page</span></md-button>");
$templateCache.put("app/settings/menu/_menu-static.html","<md-button ng-class=\"{\'{{::section.icon}}\' : true}\" ng-click=\"\">{{::section | humanizeDoc}}</md-button>");
$templateCache.put("app/settings/menu/_menu-toggle.html","<md-button ng-class=\"{\'toggled\' : isOpen()}\" ng-click=toggle() aria-controls=\"docs-menu-{{::section.name | nospace}}\" aria-expanded={{isOpen()}} class=md-button-toggle>{{::section.name}}<icon name=icon-rightarrow ng-class=\"{\'toggled\' : isOpen()}\" class=\"md-toggle-icon arrow\"></icon></md-button><ul ng-show=isOpen() id=\"docs-menu-{{::section.name | nospace}}\" ng-if=section.pages.length class=menu-toggle-list><li ng-repeat=\"page in ::section.pages\"><menu-link section=page></menu-link></li></ul>");}]);